const ar = {
  translation: {
    common: {
      appName: "ء خدمات",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      confirmPassword: "تأكيد كلمة المرور",
      firstName: "الاسم الأول",
      lastName: "اللقب",
      phone: "الهاتف",
      address: "العنوان",
      submit: "إرسال",
      save: "حفظ",
      cancel: "إلغاء",
      delete: "حذف",
      edit: "تعديل",
      back: "عودة",
      search: "بحث...",
      loading: "جاري التحميل...",
      actions: "إجراءات",
      date: "التاريخ",
      amount: "المبلغ",
      status: "الحالة",
      total: "المجموع",
      quantity: "الكمية",
      price: "السعر",
      product: "المنتج",
      see_details: "التفاصيل",
      download: "تحميل",
      copied: "تم النسخ!",
      theme: "المظهر",
      language: "اللغة",
      settings: "الإعدادات",
      logout: "تسجيل الخروج",
      dashboard: "لوحة التحكم",
      profile: "الملف الشخصي",
      yes: "نعم",
      no: "لا",
      optional: "اختياري",
      quantity_decrease: "إنقاص الكمية",
      quantity_increase: "زيادة الكمية",
      balance: "الرصيد",
      page: "صفحة",
      next: "التالي",
      prev: "السابق",
      currency: "دت",
      read_all: "تحديد الكل كمقروء",
      reset: "إعادة تعيين",
      filter: "تصفية",
      confirm: "تأكيد",
      error: "حدث خطأ ما",
      unknown_error: "خطأ غير معروف",
      unit: "وحدة",
      and: "و",
      favorites: "المفضلة",
      login: "تسجيل الدخول",
      light_mode: "الوضع الفاتح",
      dark_mode: "الوضع الداكن",
      notifications: "الإشعارات",
      security: "الأمان",
      close: "إغلاق",
      open_full: "فتح في ملء الشاشة",
      copy: "نسخ",
      role: {
        admin: "مدير",
        client: "العميل"
      }
    },
    ManageProducts: {
      header: {
        title: "إدارة المنتجات"
      },
      form: {
        titleNew: "منتج جديد",
        titleEdit: "تعديل المنتج",
        name: "اسم المنتج",
        description: "الوصف",
        descriptionPlaceholder: "وصف مفصّل للمنتج...",
        price: "السعر الأساسي (دينار)",
        category: "الفئة",
        subcategory: "الفئة الفرعية",
        status: "الحالة",
        statusOnSale: "معروض للبيع",
        statusIncoming: "قادم قريباً",
        statusSoldOut: "غير متوفر",
        value: "القيمة",
        valuePlaceholder: "مثال: 1 جيقابايت، 5 دينار...",
        minQuantity: "الحد الأدنى للكمية",
        deliveryMethod: "طريقة التسليم",
        deliveryMethods: {
          codeInstantane: "رمز فوري",
          mailCompteCode: "بريد: حساب + رمز",
          mailCode: "بريد: رمز",
          mailAcces: "بريد: بيانات الدخول",
          mailLicence: "بريد: رخصة",
          traitementLien: "معالجة رابط",
          livraisonDomicile: "توصيل إلى المنزل"
        },
        saleType: "نوع البيع",
        saleTypes: {
          detail: "مفرد",
          gros: "بالجملة"
        },
        paymentMethods: "وسائل الدفع",
        paymentMethodsLabels: {
          solde: "الرصيد",
          livraison: "التسليم",
          carte: "البطاقة",
          virement: "تحويل بنكي",
          mandat: "حوالة بريدية",
          portefeuille: "محفظة إلكترونية",
          p2p: "بين المستخدمين"
        },
        validated: "منتج معتمد",
        bestSeller: "الأكثر مبيعاً",
        duplicateSuffix: "(نسخة)",
        showPreview: "معاينة المنتج",
        hidePreview: "إخفاء المعاينة",
        images: {
          logo: "1. الشعار / العلامة",
          main: "2. الصورة الرئيسية",
          gallery: "3. صور أخرى (معرض)"
        },
        preferences: {
          title: "خيارات التسعير",
          addGroup: "+ مجموعة",
          groupPlaceholder: "مثال: نوع التغطية",
          optionPlaceholder: "مثال: صلب",
          required: "إلزامي",
          featuresLabel: "الخدمات المشمولة (1 لكل سطر)",
          featuresPlaceholder: "أدخل الميزات...",
          addValue: "+ قيمة جديدة",
          removeGroup: "حذف مجموعة الخيارات هذه",
          removeOption: "حذف هذا الخيار",
          removeCondition: "حذف هذا الشرط",
          conditions: {
            if: "إذا",
            groupSelect: "المجموعة...",
            valueSelect: "القيمة...",
            thenPrice: "إذن الجبر =",
            featuresLabel: "الخدمات المشمولة (عند تحقق الشرط)",
            featuresPlaceholder: "ميزات خاصة...",
            add: "+ شرط تسعير"
          }
        },
        submit: {
          processing: "جارٍ المعالجة...",
          update: "تحديث",
          create: "حفظ المنتج"
        }
      },
      validation: {
        nameRequired: "اسم المنتج مطلوب",
        priceRequired: "يجب أن يكون السعر أكبر من 0",
        subcategoryRequired: "الفئة الفرعية مطلوبة",
        minQuantityInvalid: "يجب أن يكون الحد الأدنى للكمية 1 على الأقل",
        preferenceLabelRequired: "تسمية الخيار رقم {{index}} مطلوبة",
        preferenceOptionsRequired: "يجب أن يحتوي الخيار \"{{label}}\" على قيمة واحدة على الأقل",
        optionNameRequired: "اسم القيمة رقم {{optionIndex}} في \"{{label}}\" مطلوب"
      },
      preview: {
        title: "معاينة",
        preferences: "التخصيص",
        productNamePlaceholder: "اسم المنتج",
        valueLabel: "القيمة",
        selectPlaceholder: "اختر...",
        inputPlaceholder: "أدخل {{field}}",
        amountPlaceholder: "المبلغ",
        estimatedTotal: "السعر الإجمالي المقدّر",
        filePlaceholder: "ملف للايداع"
      },
      filters: {
        searchLabel: "بحث",
        searchPlaceholder: "اسم المنتج...",
        categoryLabel: "الفئة",
        subcategoryLabel: "الفئة الفرعية",
        all: "الكل"
      },
      list: {
        empty: "لا يوجد أي منتج",
        basePriceSuffix: "(أساسي)",
        duplicate: "نسخ",
        edit: "تعديل",
        delete: "حذف"
      },
      messages: {
        confirmDelete: "حذف هذا المنتج؟"
      }
    },
    ManagePaymentMethods: {
      page_title: "طرق الدفع",
      page_subtitle: "قم بتكوين طرق الدفع المتاحة لعملائك.",
      credentials_title: "بيانات الدفع",
      disabled_badge: "معطّل",
      scope_short_order: "الطلب",
      scope_short_deposit: "الإيداع",
      scope_short_product: "الكتالوج",
      stats: {
        total: "طرق الدفع",
        types: "الأنواع (العائلات)",
        subtypes: "الأنواع الفرعية",
        enabled: "نشطة",
        disabled: "غير نشطة"
      },
      filters: {
        search: "بحث",
        search_placeholder: "الاسم، المعرف، الرابط، الشفرة...",
        family: "العائلة",
        status: "الحالة",
        usage: "الاستخدام",
        all_families: "جميع العائلات",
        all_statuses: "جميع الحالات",
        all_usages: "جميع الاستخدامات",
        enabled: "نشطة",
        disabled: "غير نشطة",
        usage_order: "الطلب",
        usage_deposit: "الإيداع",
        usage_product: "الكتالوج",
        reset: "إعادة تعيين",
        no_results: "لا توجد طريقة دفع مطابقة للفلاتر.",
        results: "{{count}} نتيجة"
      },
      card: {
        sort: "الترتيب",
        created: "تاريخ الإنشاء"
      },
      form: {
        add_method: "إضافة طريقة",
        edit_title: "تعديل الطريقة",
        add_title: "طريقة جديدة",
        family_label: "الفئة",
        method: "الطريقة",
        used_for_label: "يُستخدم لـ",
        scope_order: "الطلب",
        scope_deposit: "الإيداع",
        scope_product: "الكتالوج",
        sort_order: "ترتيب العرض",
        instructions: "التعليمات",
        instructions_placeholder: "التعليمات المعروضة على العميل (اختياري).",
        enabled: "مفعّل",
        error_method_code: "رمز طريقة غير صالح.",
        error_scope: "اختر نطاقاً واحداً على الأقل.",
        error_identifier_portefeuille: "رقم الهاتف مطلوب للمحفظة.",
        error_identifier_phone: "رقم هاتف محمول تونسي غير صالح.",
        error_identifier_rib_required: "RIB مطلوب.",
        error_identifier_rib_format: "يجب أن يحتوي RIB على 20 رقماً.",
        error_identifier_ccp_required: "CCP مطلوب.",
        error_identifier_ccp_format: "يجب أن يحتوي CCP على 10 إلى 16 رقماً.",
        error_provider: "اسم المزود مطلوب.",
        error_scope_solde_deposit: "لا يمكن استخدام الرصيد الداخلي للإيداعات.",
        error_scope_livraison_deposit: "لا يمكن استخدام الدفع عند الاستلام للإيداعات.",
        error_scope_livraison_product: "لا يمكن استخدام الدفع عند الاستلام للكتالوج.",
        error_scope_p2p_order: "لا يمكن استخدام P2P للطلبات.",
        error_scope_p2p_product: "لا يمكن استخدام P2P للكتالوج.",
        scope_forbidden: "غير مطبق",
        scope_solde_no_deposit: "مخصص للطلبات/الكتالوج",
        scope_livraison_no_deposit: "مخصص للطلبات",
        scope_livraison_no_product: "مخصص للطلبات",
        scope_p2p_no_order: "مخصص للإيداعات",
        scope_p2p_no_product: "مخصص للإيداعات",
        hint_rib: "مطلوب 20 رقماً لـ RIB بنكي",
        hint_ccp: "10 إلى 16 رقماً لـ CCP بريدي",
        hint_phone: "رقم هاتف محمول تونسي (+216)",
        identifier_label_portefeuille: "رقم الهاتف (محمول ت)",
        identifier_label_virement: "RIB (20 رقماً)",
        identifier_label_virement_postal: "CCP / الحساب البريدي",
        identifier_label_mandat: "رقم الهوية أو المرجع (اختياري)",
        identifier_label_optional: "المعرف (اختياري)",
        family_auto: "(يُكتشف تلقائياً)",
        provider_name: "اسم المزود",
        identifier: "المعرف الأساسي",
        iban_optional: "IBAN (اختياري)",
        account_holder_optional: "حامل الحساب (اختياري)",
        family: {
          title: "الفئة",
          solde: "الرصيد",
          livraison: "الاستلام",
          portefeuille: "المحفظة",
          virement: "التحويل",
          carte: "البطاقة",
          mandat: "الآمانة",
          p2p: "P2P"
        }
      },
      method: {
        solde_interne: "الرصيد الداخلي",
        livraison: "الدفع عند الاستلام",
        portefeuille_flouci: "فلوسي",
        portefeuille_d17: "D17",
        portefeuille_izi_pay: "IZI Pay",
        portefeuille_wafacash: "وفاكاش",
        virement_bancaire: "تحويل بنكي",
        virement_postal: "CCP / بريد",
        carte_bancaire: "بطاقة بنكية",
        carte_postale: "بطاقة بريدية",
        mandat_minute: "مانдат فوري",
        mandat_normale: "مانдат عادي",
        mandat_bancaire: "مانдат بنكي",
        p2p: "P2P"
      },
      actions: {
        edit: "تعديل",
        duplicate: "تكرار",
        delete: "حذف"
      },
      details: {
        identifier: "المعرف",
        iban: "IBAN",
        holder: "الحامل"
      },
      messages: {
        load_error: "خطأ في تحميل البيانات.",
        update_success: "تم تحديث الطريقة.",
        create_success: "تم إنشاء الطريقة.",
        delete_success: "تم حذف الطريقة.",
        delete_confirm: "هل أنت متأكد من حذف هذه الطريقة؟"
      }
    },
    ManageStock: {
      header: {
        title: "إدارة المخزون"
      },
      tabs: {
        instant: "📦 الأكواد الفورية",
        manual: "🔧 ديجيتال يدوي",
        physical: "🚚 مخزون مادي"
      },
      common: {
        show: "إظهار",
        hide: "إخفاء",
        loading: "جاري التحميل...",
        error: "حدث خطأ ما",
        success: "تم بنجاح",
        all: "الكل",
        actions: "إجراءات",
        previous: "السابق",
        next: "التالي",
        cancel: "إلغاء",
        close: "إغلاق",
        save: "حفظ",
        product: "المنتج",
        choose: "اختيار",
        type: "النوع",
        status: "الحالة",
        quantity: "الكمية",
        date: "التاريخ",
        email: "البريد الإلكتروني",
        customer: "العميل",
        noData: "لا توجد بيانات"
      },
      status: {
        onSale: "متاح للبيع",
        soldOut: "نفد المخزون",
        incoming: "قادم"
      },
      sync: {
        button: "مزامنة الحالات",
        nothingToUpdate: "كل شيء يبدو صحيحًا.",
        updated: "تم تحديث {{count}} منتجًا.",
        confirm: {
          title: "مزامنة الحالات؟",
          description: "سيتم فحص المنتجات وتحديث حالتها عند الحاجة.",
          confirm: "متابعة"
        }
      },
      instant: {
        kpis: {
          total: "إجمالي الأكواد",
          available: "متاحة",
          sold: "مباعة",
          expired: "منتهية"
        },
        import: {
          title: "استيراد الأكواد",
          subtitle: "الصيغة المطلوبة: code;serial;date (يوم/شهر/سنة).",
          parsing: "جارٍ تحليل الملف…",
          noInstantProduct: "لا يوجد منتج فوري",
          instantOnlyHint: "الاستيراد متاح فقط لمنتجات CODE_INSTANTANE.",
          fileLabel: "ملف (.csv / .txt)",
          fileSelected: "تم اختيار الملف.",
          submit: "استيراد",
          uploading: "جارٍ استيراد {{count}} كود…",
          success: "تم بنجاح! تم استيراد {{count}} كود.",
          errors: {
            badFormat: "السطر {{line}}: الصيغة المطلوبة \"code;serial;date\".",
            badCode: "السطر {{line}}: يجب أن يحتوي الكود على 15 رقمًا بالضبط.",
            badSerial: "السطر {{line}}: يجب أن يطابق السيريال \"SN-XXXXXXXXXXXXX\" (13 رقمًا).",
            badDate: "السطر {{line}}: تاريخ غير صالح، الصيغة يوم/شهر/سنة.",
            more: "(+{{count}} أخرى)",
            noCode: "لم يتم العثور على أي كود."
          }
        },
        table: {
          title: "الأكواد الفورية",
          subtitle: "استعرض وأدر الأكواد الفورية.",
          filters: {
            product: "المنتج",
            status: "الحالة",
            search: "بحث",
            searchPlaceholder: "المرجع أو السيريال…"
          },
          columns: {
            reference: "المرجع",
            serial: "السيريال",
            status: "الحالة",
            expiration: "تاريخ الانتهاء",
            buyer: "المشتري",
            soldAt: "تاريخ البيع"
          },
          actions: {
            viewBuyer: "عرض المشتري",
            details: "عرض التفاصيل",
            markExpired: "وضع كمنتهي"
          },
          status: {
            available: "متاح",
            sold: "مباع",
            used: "مستخدم",
            expired: "منتهي"
          },
          pagination: {
            range: "{{from}} إلى {{to}} من أصل {{total}} كود",
            page: "صفحة {{page}} / {{pages}}"
          },
          confirmExpire: {
            title: "وضع كمنتهي؟",
            description: "سيتم تغيير الحالة إلى EXPIRED. لا يمكن التراجع عن هذا الإجراء.",
            confirm: "وضع كمنتهي"
          },
          toastExpired: "تم وضع الكود كمنتهي."
        },
        details: {
          title: "تفاصيل الكود",
          codeEncrypted: "الكود (مخفي افتراضيًا)",
          codeHash: "هاش",
          actions: {
            copyReference: "نسخ المرجع"
          },
          otp: {
            hint: "لعرض الكود، يلزم التحقق عبر رمز OTP على واتساب.",
            grantedFor: "تم السماح بالعرض لمدة {{seconds}} ث.",
            phoneRequired: "يلزم رقم واتساب لعرض الكود (تحقق من ملفك الشخصي).",
            transactionLabel: "عرض الكود",
            success: "تم التحقق من OTP. تم السماح بالعرض لمدة ~{{minutes}} دقيقة."
          }
        },
        buyer: {
          title: "المشتري",
          openProfile: "فتح ملف العميل"
        }
      },
      manual: {
        title: "ديجيتال يدوي",
        subtitle: "تبديل توفر المنتجات اليدوية.",
        actions: {
          setSoldOut: "تعيين كنفاد",
          setOnSale: "تعيين كمتاح للبيع"
        }
      },
      physical: {
        title: "مخزون مادي",
        typeLabel: "مادي",
        actions: {
          history: "السجل",
          adjust: "تعديل"
        },
        adjust: {
          title: "تعديل المخزون",
          movementType: "نوع الحركة",
          in: "+ إدخال",
          out: "- إخراج",
          reason: "السبب",
          reasonPlaceholder: "مثال: تلف، جرد، إرجاع…",
          toastSuccess: "تم تعديل المخزون بنجاح."
        }
      }
    },
    SplashScreen: {
      tagline: {
        slogan: "فضاؤكم الرقمي"
      },
      status: {
        checking: "التحقق من التحديثات...",
        applying: "جاري تطبيق التحديث...",
        loading: "جاري تحميل الموارد..."
      },
      footer: {
        buildLabel: "الإصدار"
      },
      logo: {
        appName: "ء خدمات"
      }
    },
    favorites: {
      title: "المفضلة لديك",
      empty:
        "لا توجد لديك مفضلات بعد. تصفّح الخدمات وأضف المنتجات التي تهمك.",
      remove: "إزالة من المفضلة",
      view_all: "عرض جميع المفضلة",
      load_error:
        "تعذر عرض مفضلاتك. تحقق من اتصالك بالإنترنت ثم أعد المحاولة.",
      retry: "تحديث القائمة"
    },
    AIChatAssistant: {
      header: {
        title: "مساعد ء خدمات الذكي",
        statusOnline: "متصل الآن",
        resetConversation: "بدء محادثة جديدة"
      },
      emptyState: {
        title: "تحتاج مساعدة؟",
        description: "اطرح أسئلتك حول الشحنات أو خدماتنا."
      },
      input: {
        placeholder: "اكتب رسالتك..."
      },
      tooltip: {
        help: "تحتاج مساعدة؟"
      },
      messages: {
        errorTechnical: "عذرًا، أواجه حاليًا مشكلة تقنية بسيطة.",
        errorUnavailable: "الخدمة غير متاحة مؤقتًا.",
        errorQuota: "تم استنفاد حد استخدام المساعد. يرجى المحاولة مرة أخرى بعد دقائق."
      }
    },
    status: {
      en_attente: "قيد الانتظار",
      pending: "قيد الانتظار",
      validated: "تم التحقق",
      refused: "مرفوض",
      validé: "تم التحقق",
      refusé: "مرفوض",
      in_delivery: "جاري التنفيذ",
      completed: "مكتمل",
      cancelled: "ملغى",
      dispute: "قيد النزاع",
      processing: "قيد المعالجة",
      delivered: "تم التسليم",
      failed: "فشل",
      refunded: "تم الاسترداد",
      en_vente: "متوفر",
      en_arrivage: "قريبًا",
      ouvert: "مفتوح",
      en_cours: "قيد التنفيذ",
      actif: "نشط",
      suspendu: "معلق",
      en_attente_email: "في انتظار التأكيد بالبريد",
      awaiting_delivery: "جاهز للشحن",
      p2p: "تحويل إلى معرف (إيداع)",
      postal: "تحويل بريدي",
      flouci: "فلوسي",
      d17: "D17",
      izi_pay: "IZI Pay",
      virement: "تحويل بنكي",
      épuisé: "نفدت الكمية"
    },
    notifications: {
      filter_by_type: "تصفية حسب النوع",
      filter_all: "الكل",
      filter_orders: "الطلبات",
      filter_tickets: "التذاكر",
      filter_deposits: "الإيداعات",
      filter_admin: "العملاء",
      filter_alerts: "التنبيهات",
      empty_filtered: "لا توجد إشعارات في هذه الفئة.",
      empty: "لا توجد إشعارات في الوقت الحالي.",
      order_status_changed: "حالة طلبك #{{orderId}} الآن: {{status}}",
      replacement_order_created: "تم إنشاء أمر استبدال (#{{replacementId}}) لطلبك #{{originalId}}. الأكواد الجديدة متوفرة في رموزي.",
      deposit_validated: "تم التحقق من إيداعك {{amount}}.",
      deposit_refused: "تم رفض إيداعك {{amount}}.",
      ticket_reply: "رد جديد على تذكرتك #{{ticketId}}",
      admin: {
        new_order: "طلب جديد #{{orderId}} ({{amount}})",
        new_deposit: "إيداع جديد {{amount}} عبر {{method}}",
        new_ticket: "تذكرة دعم جديدة: {{sujet}}",
        new_client: "عميل جديد مسجل: {{name}}",
        new_client_unknown: "عميل جديد"
      },
      generic: {
        default: "إشعار جديد",
        ticket_reponse: "رد جديد على تذكرة الدعم",
        ticket_statut: "تحديث حالة تذكرتك",
        ticket_cree: "تم إنشاء تذكرتك",
        ticket_urgence: "تم تحديد التذكرة كعاجلة",
        depot_valide: "تم التحقق من إيداعك",
        depot_refuse: "تم رفض إيداعك",
        depot_cree: "تم تسجيل إيداعك",
        commande_statut: "تم تحديث حالة طلبك",
        commande_creee: "تم إنشاء طلبك",
        commande_payee: "تم دفع طلبك",
        commande_livree: "تم تسليم طلبك",
        commande_annulee: "تم إلغاء طلبك",
        commande_litige: "تحديث بخصوص طلبك",
        nouveau_client: "عميل جديد مسجل",
        nouveau_ticket: "تذكرة دعم جديدة",
        stock_faible: "تنبيه انخفاض المخزون",
        stock_epuise: "نفد المخزون",
        system_alert: "تنبيه النظام"
      }
    },
    auth: {
      login: {
        title: "مرحبًا بعودتك!",
        subtitle: "سجل الدخول إلى حسابك",
        cta: "تسجيل الدخول",
        forgot_password: "نسيت كلمة المرور؟",
        new_user: "جديد في ء خدمات؟",
        create_account: "إنشاء حساب مجاني",
        back_home: "العودة للرئيسية",
        loading: "جاري الاتصال..."
      },
      register: {
        title: "إنشاء حساب",
        subtitle: "املأ النموذج أدناه للبدء.",
        cta: "إنشاء حسابي",
        have_account: "لديك حساب بالفعل؟",
        login_link: "سجل دخولك هنا",
        success_title: "تهانينا!",
        success_msg: "تم إنشاء حسابك بنجاح. تم إرسال بريد إلكتروني للتأكيد. يرجى التحقق من صندوق بريدك الإلكتروني والنقر على رابط التأكيد. تذكر أيضاً التحقق من مجلد الرسائل غير المرغوب فيها (البريد العشوائي).",
        email_sent: "تم إرسال بريد إلكتروني للتأكيد إلى",
        back_login: "العودة لتسجيل الدخول"
      },
      errors: {
        invalid_credentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
        user_not_found: "لم يتم العثور على حساب بهذا البريد.",
        email_exists: "يوجد حساب بالفعل بهذا البريد الإلكتروني.",
        password_mismatch: "كلمات المرور غير متطابقة.",
        email_not_confirmed: "حسابك غير",
        generic: "حدث خطأ ما."
      }
    },
    Deposits: {
      paymentMethods: {
        p2p: "من شخص لشخص (P2P)",
        virement: "تحويل بنكي",
        mandat: "حوالة",
        portefeuilles: "محافظ رقمية",
        carte: "بطاقة",
        livraison: "تسليم"
      },
      mandatTypes: {
        minute: "حوالة فورية",
        normale: "حوالة عادية",
        moneyGram: "موني جرام"
      },
      p2p: {
        instructionsTitle: "تعليمات التسليم يداً بيد (P2P)",
        instructionsDesc: "هذه الطريقة عبارة عن تسليم يداً بيد. يرجى إدخال اسمك للتحقق أدناه فقط.",
        clientNameLabel: "اسم العميل للتحقق",
        clientNamePlaceholder: "اسم المرسل / المسلّم"
      },
      mandat: {
        instructionsTitle: "تعليمات إرسال حوالة",
        typeLabel: "نوع الحوالة المرسلة"
      }
    },
    Login: {
      sidebar: {
        appName: "ء خدمات",
        heroDesc: "شريكك الموثوق لجميع خدماتك الرقمية.",
        securityBadge: "أمان ء خدمات",
        trustedLoginQuote: "تسجيل دخول موثوق، تحقق فوري عبر واتساب، ووصول محمي في كل جلسة.",
        secureService: "خدمة آمنة وموثوقة",
        support24_7: "دعم متاح على مدار الساعة"
      },
      header: {
        title: "مرحباً بعودتك!",
        subtitle: "سجّل الدخول إلى حسابك"
      },
      form: {
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        emailPlaceholder: "exemple@email.com",
        passwordPlaceholder: "••••••••"
      },
      validation: {
        credentialsInvalid: "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
        emailInvalid: "صيغة البريد الإلكتروني غير صحيحة"
      },
      twoFA: {
        label: "رمز التحقق (2FA)",
        hint: "أدخل الرمز المكون من 6 أرقام من تطبيق المصادقة",
        placeholder: "000000",
        codeError: "يرجى إدخال رمز مكون من 6 أرقام",
        invalidCode: "رمز التحقق الثنائي غير صالح",
        back: "← رجوع"
      },
      options: {
        rememberMe: "البقاء متصلاً",
        forgotPassword: "نسيت كلمة المرور؟"
      },
      captcha: {
        pleaseValidate: "يرجى إكمال التحقق الأمني (CAPTCHA).",
        pleaseComplete: "يرجى إكمال التحقق الأمني",
        devMode: "🔧 وضع التطوير: CAPTCHA معطل"
      },
      cta: {
        loading: "جاري تسجيل الدخول...",
        submit: "تسجيل الدخول"
      },
      divider: {
        orContinueWith: "أو المتابعة باستخدام"
      },
      oauth: {
        googleError: "خطأ في تسجيل الدخول عبر Google",
        comingSoon: "قريباً",
        googleLabel: "Google"
      },
      footer: {
        noAccount: "ليس لديك حساب بعد؟",
        createAccount: "إنشاء حساب مجاني",
        agreePrefix: "بتسجيل الدخول، فإنك توافق على",
        termsLink: "شروط الاستخدام",
        and: "و",
        privacyLink: "سياسة الخصوصية"
      },
      whatsappOtp: {
        title: "التحقق عبر واتساب",
        description:
          "تم إرسال رمز مكوّن من 6 أرقام إلى رقم واتساب المسجّل لدينا.",
        cancelButton: "إلغاء",
        submitButton: "تأكيد الرمز",
        verifying: "جارٍ التحقق..."
      }
    },
    ResetPassword: {
      errors: {
        invalidOrExpiredLink: "رابط إعادة التعيين غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.",
        invalidLink: "رابط إعادة التعيين غير صالح. يرجى طلب رابط جديد.",
        verificationFailed: "حدث خطأ أثناء التحقق من الرابط. يرجى المحاولة مرة أخرى.",
        updateFailed: "حدث خطأ أثناء تحديث كلمة المرور",
        resetFailed: "حدث خطأ أثناء إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى."
      },
      validation: {
        passwordRequired: "كلمة المرور مطلوبة",
        passwordMinLength: "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل",
        confirmPasswordRequired: "تأكيد كلمة المرور مطلوب",
        passwordMismatch: "كلمتا المرور غير متطابقتين"
      },
      loading: {
        verifyingLink: "جارٍ التحقق من الرابط..."
      },
      invalidState: {
        title: "رابط غير صالح",
        message: "رابط إعادة تعيين كلمة المرور غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.",
        requestNewLink: "طلب رابط جديد"
      },
      sidebar: {
        appName: "ء خدمات",
        heroDesc: "قم بتعيين كلمة مرور جديدة وآمنة",
        securePassword: "كلمة مرور آمنة",
        bankEncryption: "تشفير بمستوى مصرفي"
      },
      header: {
        title: "كلمة مرور جديدة",
        subtitle: "أدخل كلمة المرور الجديدة الآمنة"
      },
      success: {
        title: "تم تحديث كلمة المرور بنجاح!",
        description: "سيتم تحويلك إلى صفحة تسجيل الدخول خلال ثوانٍ..."
      },
      form: {
        newPasswordLabel: "كلمة مرور جديدة",
        confirmPasswordLabel: "تأكيد كلمة المرور",
        passwordPlaceholder: "••••••••",
        passwordHint: "الحد الأدنى 6 أحرف"
      },
      cta: {
        loading: "جارٍ التحديث...",
        submit: "تحديث كلمة المرور"
      },
      footer: {
        rememberPassword: "هل تتذكر كلمة المرور؟",
        loginLink: "تسجيل الدخول"
      }
    },
    ForgotPassword: {
      validation: {
        emailRequired: "البريد الإلكتروني مطلوب",
        emailInvalid: "صيغة البريد الإلكتروني غير صحيحة"
      },
      errors: {
        sendFailed: "حدث خطأ أثناء إرسال بريد الاستعادة",
        sendRetry: "حدث خطأ أثناء إرسال البريد الإلكتروني. يرجى المحاولة مرة أخرى."
      },
      sidebar: {
        appName: "ء خدمات",
        heroDesc: "استعادة كلمة المرور بشكل آمن",
        secureRecoveryLink: "رابط استعادة آمن",
        instantEmail: "إرسال فوري للبريد الإلكتروني"
      },
      header: {
        title: "هل نسيت كلمة المرور؟",
        subtitle: "أدخل بريدك الإلكتروني وسنرسل لك رابط الاستعادة"
      },
      success: {
        title: "تم إرسال البريد بنجاح!",
        description: "تحقق من صندوق الوارد. تم إرسال رابط إعادة التعيين إلى بريدك الإلكتروني. الرابط صالح لمدة ساعة واحدة.",
        backToLogin: "العودة إلى تسجيل الدخول"
      },
      form: {
        emailPlaceholder: "example@email.com"
      },
      cta: {
        loading: "جارٍ الإرسال...",
        submit: "إرسال رابط الاستعادة"
      },
      footer: {
        rememberPassword: "هل تتذكر كلمة المرور؟",
        loginLink: "تسجيل الدخول",
        needHelp: "في حال وجود مشكلة، تواصل مع",
        supportLink: "الدعم"
      }
    },
    Register: {
      sidebar: {
        securityBadge: "تسجيل آمن في ء خدمات",
        title: "أنشئ حسابك",
        titleHighlight: "في أقل من دقيقتين.",
        description: "مساحة مشفرة، تحقق ذكي، وتفعيل سريع لملفك الشخصي كعميل.",
        testimonialQuote: "\"تسجيل سلس جداً، تحقق فوري، وواجهة واضحة. تشعر بالموثوقية من اللحظة الأولى.\"",
        testimonialAuthorInitials: "AT",
        testimonialAuthorName: "Amira T.",
        testimonialAuthorRole: "مؤسسة متجر إلكتروني"
      },
      success: {
        title: "تهانينا!",
        message: "تم إنشاء حسابك بنجاح. تم إرسال بريد إلكتروني للتأكيد. يرجى التحقق من صندوق بريدك والنقر على رابط التأكيد. تحقق أيضاً من مجلد الرسائل غير المرغوب فيها (البريد العشوائي).",
        backToLogin: "العودة لتسجيل الدخول",
        phoneVerificationHint: "يمكنك أيضاً التحقق من رقم هاتفك عبر واتساب قبل تسجيل الدخول."
      },
      errors: {
        email_already_used: "هذا البريد الإلكتروني مستخدم مسبقاً من حساب آخر.",
        phone_already_used: "رقم الهاتف هذا مستخدم مسبقاً من حساب آخر."
      },
      header: {
        title: "إنشاء حساب",
        subtitle: "املأ النموذج أدناه للبدء."
      },
      form: {
        firstName: "الاسم الأول",
        lastName: "اسم العائلة",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        address: "العنوان",
        password: "كلمة المرور",
        confirmPassword: "تأكيد كلمة المرور",
        firstNamePlaceholder: "محمد",
        lastNamePlaceholder: "بن علي",
        emailPlaceholder: "example@email.com",
        phonePlaceholder: "+216 21 380 039",
        phonePlaceholderDigits: "XXXXXXXX",
        phoneHelper: "التنسيق: +216 XX XXX XXX",
        addressPlaceholder: "الشارع، المدينة، الرمز البريدي",
        passwordPlaceholder: "••••••••"
      },
      validation: {
        firstNameRequired: "الاسم الأول مطلوب",
        firstNameMinLength: "الاسم الأول يجب أن يحتوي على حرفين على الأقل",
        lastNameRequired: "اسم العائلة مطلوب",
        lastNameMinLength: "اسم العائلة يجب أن يحتوي على حرفين على الأقل",
        emailRequired: "البريد الإلكتروني مطلوب",
        emailInvalid: "صيغة البريد الإلكتروني غير صحيحة",
        phoneRequired: "الهاتف مطلوب",
        phoneInvalid: "صيغة الهاتف غير صحيحة",
        phoneMinDigits: "الرقم يجب أن يحتوي على 8 أرقام على الأقل",
        addressRequired: "العنوان مطلوب",
        addressMinLength: "العنوان يجب أن يحتوي على 5 أحرف على الأقل",
        passwordRequired: "كلمة المرور مطلوبة",
        passwordMinLength: "كلمة المرور يجب أن تحتوي على 6 أحرف على الأقل",
        passwordRecommendLength: "لمزيد من الأمان، استخدم 8 أحرف على الأقل",
        confirmPasswordRequired: "يرجى تأكيد كلمة المرور",
        passwordMismatch: "كلمات المرور غير متطابقة"
      },
      captcha: {
        pleaseValidate: "يرجى إكمال التحقق الأمني (CAPTCHA).",
        pleaseComplete: "يرجى إكمال التحقق الأمني",
        devMode: "🔧 وضع التطوير: CAPTCHA معطل"
      },
      cta: {
        loading: "جاري التحميل...",
        submit: "إنشاء حسابي"
      },
      footer: {
        haveAccount: "لديك حساب بالفعل؟",
        loginLink: "سجل دخولك هنا",
        agreePrefix: "بإنشائك حساباً، فإنك توافق على",
        termsLink: "شروط الاستخدام",
        and: "و",
        privacyLink: "سياسة الخصوصية"
      }
    },
    LandingPage: {
      badges: {
        securePayment: "دفع آمن",
        instantDelivery: "توصيل فوري",
        support24_7: "دعم 24/7"
      },
      hero: {
        badge: "المنصة الأولى في تونس",
        title: "خدماتك الرقمية",
        titleHighlight: "توصيل في ثوانٍ",
        subtitle: "بطاقات هدايا، رموز ألعاب، تراخيص برمجيات، اشتراكات بث... اشترِ بأمان واستلم فوراً عبر البريد. آلي 100%، على مدار الساعة.",
        ctaPrimary: "إنشاء حساب مجاني",
        ctaSecondary: "استكشف خدماتنا",
        deliveryLabel: "التوصيل",
        deliveryValue: "فوري ⚡"
      },
      favorites: {
        badge: "المفضلة لديك",
        title: "المنتجات التي تعجبك",
        subtitle: "اكتشف منتجاتك المفضلة",
        scrollPrev: "التمرير في المفضلة إلى اليسار",
        scrollNext: "التمرير في المفضلة إلى اليمين"
      },
      categories: {
        badge: "خدماتنا",
        title: "الفئات الشائعة",
        subtitle: "مئات المنتجات الرقمية متاحة، تُسلّم فوراً إلى بريدك",
        gaming: { title: "بطاقات ورموز الألعاب", desc: "PlayStation, Xbox, Steam, Nintendo, Free Fire, PUBG..." },
        giftCards: { title: "بطاقات الهدايا", desc: "Amazon, Google Play, App Store, Spotify, Netflix..." },
        mobile: { title: "شحن رصيد الهاتف", desc: "أوريدو، أورنج، تونسي تيليكوم، باقات الإنترنت..." },
        licenses: { title: "التراخيص والاشتراكات", desc: "Windows, Office, Antivirus, VPN, Canva Pro, Adobe..." }
      },
      steps: {
        step1: { title: "اختر منتجك", desc: "تصفح الكتالوج واختر الخدمة الرقمية التي تحتاجها. رموز ألعاب، بطاقات هدايا، تراخيص..." },
        step2: { title: "ادفع بأمان", desc: "الدفع بالرصيد الداخلي أو بطاقة D17 أو التحويل البنكي. جميع المعاملات مؤمنة ومشفرة." },
        step3: { title: "استلم فوراً", desc: "يُسلّم رمزك أو ترخيصك تلقائياً بالبريد وفي حسابك. دون انتظار، على مدار الساعة." }
      },
      howItWorks: {
        badge: "بسيط وسريع",
        title: "كيف يعمل؟",
        subtitle: "3 خطوات بسيطة لاستلام منتجاتك الرقمية في أقل من دقيقة"
      },
      features: {
        badge: "مزايانا",
        title: "لماذا تختار «ء خدمات»؟",
        subtitle: "منصة مصممة لراحتك وأمانك ورضاك",
        instant: { title: "توصيل فوري", desc: "استلم رموزك وتراخيصك فوراً بعد الدفع. نظام آلي 100%، متاح على مدار الساعة." },
        secure: { title: "مدفوعات آمنة 100%", desc: "معاملات مشفرة SSL، حماية Cloudflare، والامتثال لأعلى معايير الأمان." },
        variety: { title: "تشكيلة واسعة من الخدمات", desc: "مئات المنتجات: ألعاب، بث، برمجيات، بطاقات هدايا، شحن رصيد والمزيد." },
        automated: { title: "نظام آلي 24/7", desc: "لا حاجة لتدخل بشري. اطلب في أي وقت، استلم فوراً، ليلاً أو في عطلة نهاية الأسبوع." },
        support: { title: "دعم عملاء متجاوب", desc: "فريق مخصص للرد على استفساراتك عبر نظام التذاكر وفيسبوك وإنستغرام." },
        pricing: { title: "أسعار تنافسية", desc: "أفضل الأسعار في السوق التونسي. بدون رسوم خفية، الأسعار بالدينار التونسي (د.ت)." }
      },
      testimonials: {
        badge: "آراء موثقة",
        title: "ماذا يقول عملاؤنا",
        subtitle: "انضم إلى آلاف العملاء الراضين في جميع أنحاء تونس",
        reviewsCount: "أكثر من 2000 تقييم إيجابي",
        roles: { gamer: "لاعب شغوف", entrepreneur: "رائدة أعمال", student: "طالب" },
        reviews: {
          review1: "خدمة رائعة! استلمت رمز PlayStation Store في أقل من 30 ثانية. أصبح مرجعي لجميع مشترياتي من الألعاب.",
          review2: "أستخدم eServices لتراخيصي المهنية. أسعار لا تُقارن وتوصيل فوري. أنصح بها جميع زملائي!",
          review3: "مثالي لبطاقات Netflix وSpotify. الدعم سريع جداً والأسعار الأفضل التي وجدتها في تونس."
        }
      },
      security: {
        badge: "آمن 100%",
        title: "أمانك هو أولويتنا القصوى",
        subtitle: "نستخدم أحدث التقنيات لحماية بياناتك الشخصية ومعاملاتك المالية.",
        encryption: { title: "تشفير SSL 256 بت", desc: "جميع بياناتك ومعاملاتك محمية بتشفير بمستوى البنوك." },
        cloudflare: { title: "حماية Cloudflare", desc: "منصتنا محمية من هجمات DDoS والتهديدات الإلكترونية عبر Cloudflare." },
        supabase: { title: "قاعدة بيانات آمنة", desc: "بنية Supabase مع مصادقة معززة ونسخ احتياطي تلقائي." },
        automated: { title: "توصيل دون تدخل", desc: "نظام آلي بالكامل. رموزك تُولّد وتُسلّم دون تدخل بشري." },
        uptime: "ضمان التوفر",
        ssl: "تشفير متقدم"
      },
      cta: {
        badge: "تسجيل 100% مجاني",
        title: "مستعد لاستلام خدماتك الرقمية في ثوانٍ؟",
        subtitle: "انضم إلى آلاف العملاء الراضين. أنشئ حسابك في 30 ثانية واستمتع بالتوصيل الفوري.",
        button: "إنشاء حسابي مجاناً",
        trust: "✓ دون التزام  ✓ دون بطاقة بنكية  ✓ وصول فوري لجميع الخدمات"
      }
    },
    Profile: {
      appName: "ء خدمات",
      header: {
        title: "ملفي الشخصي"
      },
      subtitle: "حساب عميل ء خدمات.tn",
      state: {
        loading: "جاري تحميل الملف..."
      },
      success: {
        message: "تم تحديث الملف الشخصي بنجاح!"
      },
      section: {
        title: "المعلومات الشخصية",
        personal: "المعلومات الشخصية",
        contact: "الاتصال والأمان"
      },
      actions: {
        cancel: "إلغاء",
        saving: "جاري الحفظ...",
        save: "حفظ",
        edit: "تعديل"
      },
      avatar: {
        change: "تغيير"
      },
      form: {
        firstName: "الاسم الأول",
        lastName: "اسم العائلة",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        address: "العنوان",
        phoneEmpty: "غير مذكور"
      },
      security: {
        note: "تُستخدم هذه المعلومات لتسجيل الدخول، واسترجاع الحساب، والإشعارات المهمة."
      },
      validation: {
        phoneInvalid: "تنسيق رقم الهاتف غير صالح. استخدم +216 XX XXX XXX"
      }
    },
    ClientServices: {
      header: {
        title: "الخدمات"
      },
      Categories: {
        section: {
          mobileTopups: "إعادات الشحن والباقات لجميع المشغلين.",
          internationalPayments: "يمكنك الشراء من أي موقع دولي والدفع بالدينار التونسي.",
          customDocuments: "خصّص مستنداتك الرسومية والتعليمية والإدارية.",
          subscriptions: "خدمات البث والألعاب والمزيد."
        }
      },
      SubCategories: {
        section: {
          graphicDesign: "خدمات التصميم الجرافيكي والإبداع البصري",
          tunisieTelecom: "خدمات وإعادات شحن تونس تيليكوم",
          internationalTransactions: "حلول دفع للمعاملات الدولية",
          ooredooTunisie: "خدمات وإعادات شحن أوريدو تونس",
          localTransactions: "حلول دفع للمعاملات المحلية",
          orangeTunisie: "خدمات وإعادات شحن أورنج تونس",
          streamingVideoMusic: "خدمات بث الفيديو والموسيقى",
          gamingServices: "ألعاب فيديو وخدمات الألعاب",
          appsAndSoftware: "تطبيقات وبرامج متنوعة",
          educationalResources: "وثائق وموارد تعليمية",
          certificatesGeneration: "إصدار الشهادات والإثباتات",
          administrativeDocuments: "معالجة الوثائق الإدارية",
          secureOnlinePayments: "خدمات دفع إلكتروني آمنة",
          onlineCourses: "دورات وتكوينات عبر الإنترنت",
          productivityTools: "أدوات لتحسين الإنتاجية"
        }
      },
      navigation: {
        back: "رجوع",
        allCategories: "كل الفئات"
      },
      state: {
        loading: "جارٍ التحميل...",
        loadError: "يتعذر تحميل الخدمات.",
        emptyProducts: "لم يتم العثور على منتجات."
      }
    },
    CategoryCard: {
      content: {
        noDescription: "لا يوجد وصف"
      }
    },
    MyCodes: {
      appName: "ء خدمات",
      header: {
        title: "رموزي"
      },
      actions: {
        refreshTitle: "تحديث القائمة"
      },
      alert: {
        deliveryPendingTitle: "التسليم قيد الانتظار",
        deliveryPendingMessage: "لم يتم تسليم بعض رموزك الأخيرة تلقائياً بسبب مشكلة تقنية. لا تقلق: تم إبلاغ المسؤولين وسيتم تعيين رموزك يدوياً قريباً جداً بعد التحقق من طلبك.",
        checkOrders: "التحقق من طلباتي",
        openTicket: "فتح تذكرة دعم"
      },
      sidebar: {
        history: "السجل"
      },
      state: {
        loading: "جاري التحميل..."
      },
      empty: {
        message: "لم يتم العثور على رموز."
      },
      badges: {
        code: "رمز",
        licence: "ترخيص",
        compte: "حساب",
        acces: "وصول",
        lien: "رابط"
      },
      fallback: {
        product: "منتج"
      },
      security: {
        title: "إرشادات الأمان",
        description: "هذا الرمز سري للغاية. لا تشارك أبداً لقطات الشاشة أو نص هذا الرمز مع أطراف ثالثة. لأي مشكلة تقنية، تواصل مع دعم العملاء.",
        refLabel: "المرجع:",
        batchIdLabel: "معرف الدفعة:"
      },
      selectHint: {
        title: "اختر رمزاً من القائمة لرؤية التفاصيل.",
        description: "يرجى اختيار رمز أو وصول من القائمة لرؤية التفاصيل."
      }
    },
    MobileManageOrders: {
      list: {
        title: "الطلبات",
        subtitle: "إدارة طلبات العملاء",
        totalAmount: "المبلغ الإجمالي",
        paymentMethod: "طريقة الدفع",
        itemsCount: "العناصر ({{count}})",
        moreItems_one: "+عنصر آخر",
        moreItems_other: "+{{count}} عناصر أخرى",
        details: "التفاصيل",
        detailsA11y: "عرض تفاصيل الطلب"
      },
      empty: {
        title: "لا توجد طلبات",
        description: "لم يتم استلام أي طلبات."
      },
      modal: {
        orderTitle: "الطلب رقم {{id}}",
        close: "إغلاق",
        client: "العميل",
        deliveryPerProduct: "التسليم لكل منتج",
        accountEmail: "المعرّف / البريد الإلكتروني",
        pAccountEmail: "email@example.com",
        password: "كلمة المرور",
        invitationUrl: "رابط الدعوة / البريد الإلكتروني",
        licenceKey: "مفتاح الترخيص",
        certificateLink: "رابط الشهادة (اختياري)",
        trackingLink: "رابط التتبع",
        pTracking: "رقم التتبع أو رابط",
        clientNote: "ملاحظة للعميل",
        pNote: "مثال: قيد التنفيذ، تم...",
        code: "الرمز",
        pCode: "الرمز المرسل عبر البريد الإلكتروني",
        assignedCodes: "الأكواد المعينة",
        deliveryStatus: "حالة التسليم",
        inDelivery: "قيد التسليم",
        delivered: "تم التسليم",
        payment: "الدفع",
        status: "الحالة",
        items: "العناصر",
        total: "الإجمالي",
        unsavedConfirm: "بيانات غير محفوظة. إغلاق على أي حال؟"
      },
      status: {
        instantCodesDone: "تم تسليم الأكواد الفورية في هذا الطلب مسبقاً. لا يمكن تطبيق حالة 'مكتملة' مرة ثانية."
      }
    },
    MobileTicketClients: {
      header: {
        title: "العملاء ذوو التذاكر"
      },
      search: {
        placeholder: "البحث بالاسم أو البريد الإلكتروني..."
      },
      filters: {
        all: "الكل",
        active: "النشطة",
        inProgress: "قيد التنفيذ",
        closed: "المغلقة"
      },
      empty: {
        noClients: "لا يوجد أي عميل",
        noResultsSearch: "لا توجد نتائج لبحثك.",
        noResults: "لا يوجد عملاء بتذاكر."
      },
      client: {
        activeCount: "نشطة",
        lastActivity: "آخر نشاط",
        totalTickets: "تذكرة",
        closedCount: "مغلقة",
        unknownEmail: "بريد إلكتروني غير معروف",
        guestClient: "عميل زائر"
      }
    },
    MobileCheckout: {
      nav: {
        back: "عودة"
      }
    },
    ClientCheckout: {
      appName: "ء خدمات",
      header: {
        title: "إتمام الدفع"
      },
      summary: {
        title: "ملخص الطلب",
        preview: "ملخص",
        edit: "تعديل",
        totalToPay: "المجموع المستحق",
        itemsCount: "{{count}} عنصر",
        delivery: "التوصيل",
        stampFee: "الطابع الجبائي",
        remise: "خصم",
        quantity: "الكمية",
        securePayment: "شامل الضرائب · دفع آمن",
        estimateHomeDelivery: "التوصيل المتوقع 2-4 أيام",
        estimateInstant: "توصيل فوري",
        estimateDigital: "توصيل رقمي 1-24 ساعة"
      },
      deliveryNotice: {
        instantTitle: "توصيل فوري",
        instantMessage: "سلة التسوق الخاصة بك تحتوي على منتجات ذات توصيل فوري. يجب دفع جميع منتجات هذا الطلب فوراً عبر الرصيد الداخلي.",
        homeTitle: "توصيل إلى المنزل",
        homeMessage: "سيتم معالجة طلبك في أقرب وقت ممكن.",
        emailTitle: "توصيل",
        emailMessage: "سيتم إرسال الأكواد ومعلومات الوصول عبر البريد الإلكتروني بعد التحقق من الدفع."
      },
      deliveryInstructions: {
        code_instantane: "رمز فوري",
        mail_compte_code: "حساب + رمز (بريد)",
        mail_code: "رمز (بريد)",
        mail_acces: "وصول (بريد)",
        mail_licence: "ترخيص (بريد)",
        traitement_lien: "معالجة عن بُعد",
        livraison_domicile: "توصيل منزلي",
        free: "مجاني"
      },
      payment: {
        title: "طريقة الدفع"
      },
      selectSpecificMethod: "يرجى تحديد طريقة دفع محددة",
      instructions: "تعليمات",
      paymentMethods: {
        solde: "الرصيد",
        solde_interne: "الرصيد الداخلي",
        portefeuille: "محفظة جوال",
        flouci: "فلوسي",
        d17: "D17",
        izi_pay: "IZI Pay",
        virement: "تحويل بنكي",
        carte: "بطاقة مصرفية",
        mandat: "حوالة",
        livraison: "الدفع عند الاستلام",
        p2p: "نظير لنظير"
      },
      alerts: {
        limitedMethods: "ملاحظة: سلة المشتريات تحتوي على عناصر بتوصيل فوري. طرق الدفع الفورية فقط متاحة لهذا الطلب.",
        restrictedByProduct: "بعض طرق الدفع غير متاحة لهذا النوع من المنتجات."
      },
      legal: {
        checkboxLabel: "أوافق صراحة على ",
        terms: "الشروط العامة",
        privacy: "سياسة الخصوصية",
        refund: "سياسة الاسترداد",
        delivery: "سياسة التوصيل",
        and: "و"
      },
      errors: {
        selectMethod: "يرجى اختيار طريقة دفع.",
        selectSpecificMethod: "يرجى تحديد طريقة دفع محددة.",
        acceptTermsRequired: "يرجى قبول الشروط العامة قبل المتابعة.",
        invalidInput: "يرجى التحقق من بيانات الدفع.",
        mandatNumberRequired: "يرجى إدخال رقم الحوالة التي قمت بها.",
        createError: "حدث خطأ أثناء إنشاء الطلب.",
        insufficientStock: "مخزون غير كافٍ لهذا المنتج: الكمية المطلوبة {{requested}}، الكمية المتاحة {{available}}."
      },
      success: {
        title: "تم تأكيد الطلب!",
        message: "تم تقديم طلبك بنجاح.",
        viewOrders: "عرض طلباتي"
      },
      solde: {
        current: "الرصيد الحالي:",
        insufficient: "رصيد غير كافٍ. ينقصك",
        missing: ".",
        sufficient: "الرصيد كافٍ.",
        processing: "جاري المعالجة...",
        payBtn: "الدفع من رصيدي",
        cardIcon: "💳"
      },
      flouci: {
        instructionsTitle: "تعليمات فلوسي",
        step1: "أرسل المبلغ {{amount}} د.ت إلى الحساب بالرقم التالي:",
        step2: "أدخل مرجع المعاملة:",
        refLabel: "مرجع العملية (10 أحرف وأرقام، أحرف كبيرة)",
        refPlaceholder: "مثال: ABC123XYZ9",
        verifying: "جاري التحقق...",
        confirmBtn: "تأكيد الدفع",
        validationNote: "التحقق خلال 10–30 دقيقة"
      },
      d17: {
        instructionsTitle: "تعليمات D17",
        step1: "أرسل المبلغ {{amount}} د.ت إلى الحساب بالرقم التالي:",
        step2: "أدخل رقم التفويض:",
        authLabel: "رقم التفويض (6 أرقام)",
        authPlaceholder: "مثال: 123456",
        verifying: "جاري التحقق...",
        confirmBtn: "تأكيد الدفع"
      },
      izi_pay: {
        instructionsTitle: "تعليمات IZI Pay",
        step1: "أرسل {{amount}} د.ت إلى معرف IZI Pay الموضح أدناه:",
        step2: "أدخل الرمز أو مرجع المعاملة الظاهر بعد الدفع:",
        authLabel: "رمز / مرجع المعاملة (6 أرقام)",
        authPlaceholder: "مثال: 123456",
        verifying: "جاري التحقق...",
        confirmBtn: "تأكيد الدفع"
      },
      portefeuille: {
        instructionsTitle: "الدفع عبر محفظة جوال",
        step1: "أرسل {{amount}} إلى المعرف أدناه (التطبيق أو الخدمة الدقيقة مذكورة في بيانات البائع).",
        step2: "أدخل مرجع المعاملة أو الرمز الظاهر بعد الدفع.",
        refLabel: "مرجع / رمز المعاملة",
        refPlaceholder: "مثال: ABC123XYZ9",
        verifying: "جاري التحقق...",
        confirmBtn: "تأكيد الدفع",
        validationNote: "قد يستغرق التحقق 10–30 دقيقة حسب المشغّل.",
        accountHolderSeparator: " — "
      },
       virement: {
         title: "تحويل بنكي",
         bankAccounts: "الحسابات البنكية",
         instructions: "قم بتحويل {{amount}} إلى أحد الحسابات أدناه.",
        rib: "الريب",
        iban: "الأيبان",
        labelProof: "رفع إثبات التحويل",
        chooseFile: "اختر ملفاً",
        fileTypes: "صور، PDF (الحد الأقصى 5 ميجا)",
        btnSending: "جاري الإرسال...",
        btnSend: "إرسال الإثبات",
        missingAccountHolder: "لم يتم تحديد اسم صاحب الحساب",
         accountHolder: "اسم صاحب الحساب",
         proofLabel: "إثبات الدفع (وصل)",
        bankIcon: "🏦"
      },
       selectHint: "يرجى اختيار طريقة دفع للمتابعة",
       walletLogo: "محفظة",
       missingIdentifier: "لم يتم تحديد المعرف",
       termsAcceptance: "لقد قرأت وأوافق على الشروط والأحكام وسياسة الخصوصية.",
       confirmOrder: "تأكيد الطلب",
      config: {
        keyValue: "{{key}}: {{value}}"
      },
      disabled: {
        notAllowed: "غير متاح لهذا المنتج",
        notConfigured: "غير مهيّأ",
        options: "خيار (خيارات)"
      },
      livraison: {
        desc: "الدفع نقدًا عند استلام طلبك إلى عنوانك.",
        note: "قد تُطبق رسوم توصيل إضافية. سيتم التواصل معك لتأكيد العنوان وموعد التسليم.",
        processing: "جارٍ المعالجة...",
        confirmBtn: "طلب — الدفع عند الاستلام"
      },
      carte: {
        desc: "الدفع بالبطاقة البنكية. ستتلقى تعليمات الدفع بعد تأكيد الطلب.",
        note: "سيتم تزويدك بتفاصيل الدفع بالبطاقة البنكية بعد التحقق من طلبك.",
        processing: "جارٍ المعالجة...",
        confirmBtn: "الدفع بالبطاقة البنكية"
      },
      mandat: {
        instructionsTitle: "الدفع عبر الحوالة",
        desc: "أرسل المبلغ عبر حوالة بريدية أو بنكية (حوالة عادية، حوالة بريد فورية أو MoneyGram) إلى أحد المستلمين أدناه، ثم أدخل رقم الحوالة.",
        refLabel: "رقم الحوالة",
        refPlaceholder: "مثال: 123456789",
        numberHint: "أدخل رقم الحوالة فقط (أرقام)، وسيُمكِّن فريقنا من التحقق من معاملتك.",
        verifying: "جارٍ التحقق...",
        confirmBtn: "تأكيد الدفع",
        validationNote: "التحقق يستغرق 30–60 دقيقة حسب المشغّل."
      },
       p2p: {
         desc: "تحويل مباشر من شخص لآخر. تواصل معنا للحصول على بيانات المستلم.",
         note: "هذه الطريقة تتطلب تواصلًا مسبقًا مع فريقنا لترتيب التحويل.",
         processing: "جارٍ المعالجة...",
         confirmBtn: "تأكيد التحويل المباشر"
       }
    },
    NewOrder: {
      appName: "ء خدمات",
      header: {
        title: "تقديم طلب"
      },
      browser: {
        back: "رجوع",
        categories: "الفئات"
      },
      state: {
        loading: "جاري التحميل...",
        loadError: "تعذر تحميل الخدمات."
      },
      cart: {
        title: "طلبك",
        empty: "سلة المشتريات فارغة.",
        emptyHint: "اختر فئة للبدء.",
        removeItem: "إزالة",
        total: "المجموع"
      },
      errors: {
        selectMethod: "يرجى اختيار طريقة دفع.",
        proofRequired: "يرجى رفع إثبات الدفع لهذه الطريقة.",
        insufficientBalance: "رصيد غير كافٍ. يرجى شحن حسابك.",
        createError: "حدث خطأ أثناء إنشاء الطلب.",
        paymentConfig: "خطأ في إعداد الدفع. يرجى الاتصال بالدعم."
      },
      success: {
        message: "تم تقديم الطلب بنجاح!"
      },
      payment: {
        label: "طريقة الدفع",
        placeholder: "اختر طريقة...",
        proofLabel: "إثبات الدفع (مطلوب)",
        proofHint: "يرجى رفع لقطة شاشة أو إيصال للتحقق من المعاملة.",
        alertNote: "ملاحظة:",
        alertMessage: "بعض المنتجات في سلتك بتوصيل \"رمز فوري\". طرق الدفع الفورية فقط متاحة لهذا الطلب."
      },
      paymentMethods: {
        solde_interne: "الرصيد الداخلي",
        flouci: "فلوسي",
        d17: "D17",
        virement: "تحويل بنكي"
      },
      deliveryInstructions: {
        code_instantane: "رمز فوري",
        mail_compte_code: "حساب + رمز (بريد)",
        mail_code: "رمز (بريد)",
        mail_acces: "وصول (بريد)",
        mail_licence: "ترخيص (بريد)",
        traitement_lien: "معالجة عن بُعد",
        livraison_domicile: "توصيل منزلي"
      },
      actions: {
        submitProcessing: "جاري الإرسال...",
        submitConfirm: "تأكيد الطلب"
      }
    },
    CartPage: {
      appName: "ء خدمات",
      title: "سلة المشتريات",
      itemSingular: "منتج",
      itemPlural: "منتجات",
      inBasket: "في سلتك",
      empty: {
        title: "سلة المشتريات فارغة",
        description: "يبدو أنك لم تضف أي منتجات إلى سلتك بعد.",
        browseServices: "تصفح الخدمات"
      },
      alert: {
        instantMessage: "سلتك تحتوي على منتجات بتوصيل فوري. يجب دفع جميع عناصر هذا الطلب فوراً عبر الرصيد الداخلي."
      },
      deliveryMethods: {
        code_instantane: "رمز فوري",
        mail_compte_code: "حساب بالبريد",
        mail_code: "رمز بالبريد",
        mail_acces: "وصول بالبريد",
        mail_licence: "ترخيص بالبريد",
        traitement_lien: "معالجة برابط",
        livraison_domicile: "توصيل منزلي"
      },
      deliveryInstructions: {
        code_instantane: "رمز فوري",
        mail_compte_code: "حساب + رمز (بريد)",
        mail_code: "رمز (بريد)",
        mail_acces: "وصول (بريد)",
        mail_licence: "ترخيص (بريد)",
        traitement_lien: "معالجة عن بُعد",
        livraison_domicile: "توصيل منزلي"
      },
      groupCount: {
        article: "منتج",
        articles: "منتجات"
      },
      summary: {
        title: "ملخص الطلب",
        subtotal: "المجموع الفرعي",
        deliveryFee: "رسوم التوصيل",
        stampFee: "الطابع الجبائي",
        total: "المجموع",
        ttc: "شامل الضريبة",
        vatLabel: "منها ض.ق.م (19%) :",
        vatNote: "للإعلام فقط - الأسعار شاملة الضريبة"
      },
      actions: {
        remove: "إزالة",
        minRequired: "الحد الأدنى للكمية {{min}} مطلوب لهذا النوع من المنتج.",
        checkoutBtn: "إتمام الطلب",
        loginToCheckout: "تسجيل الدخول لإتمام الطلب",
        continueShopping: "متابعة التسوق"
      },
      unit: "وحدة",
      securePayment: "دفع آمن"
    },
    MobileDashboard: {
      appName: "ء خدمات",
      banner: {
        welcome: "مرحباً،",
        totalRevenue: "إجمالي الإيرادات",
        availableBalance: "الرصيد المتاح"
      },
      miniStats: {
        today: "اليوم",
        deposits: "الإيداعات",
        totalOrders: "إجمالي الطلبات",
        ticketsSupport: "تذاكر الدعم",
        myOrders: "طلباتي",
        myDeposits: "إيداعاتي"
      },
      adminStats: {
        pendingOrders: "طلبات قيد الانتظار",
        pendingDeposits: "إيداعات قيد الانتظار"
      },
      section: {
        seeAll: "عرض الكل",
        managementTitle: "الإدارة والتحكم",
        quickActionsTitle: "إجراءات سريعة",
        popularProducts: "المنتجات الأكثر طلباً",
        lastOrders: "آخر الطلبات",
        recentActivities: "النشاط الأخير",
        daySummary: "ملخص اليوم",
        newOrdersToday: "{{count}} طلبات جديدة اليوم."
      },
      quickActions: {
        orders: "الطلبات",
        deposits: "الإيداعات",
        tickets: "التذاكر",
        clients: "العملاء",
        products: "المنتجات",
        stock: "المخزون",
        categories: "الفئات",
        media: "الوسائط",
        recharge: "شحن",
        shop: "المتجر",
        support: "الدعم",
        history: "السجل"
      },
      promotion: {
        limitedOffer: "عرض محدود",
        title: "Netflix Premium -20%",
        description: "استمتع بأفضل البث بأسعار مخفضة."
      },
      empty: {
        noRecentOrders: "لا توجد طلبات حديثة"
      },
      fallback: {
        product: "منتج"
      },
      orderTitlePrefix: "طلب #"
    },
    errors: {
      network: "مشكلة في الاتصال. يرجى التحقق من الإنترنت.",
      timeout: "الخادم يستغرق وقتا طويلا للرد.",
      auth: {
        invalid: "البريد أو كلمة المرور غير صحيحة.",
        not_found: "لم يتم العثور على حساب.",
        unconfirmed: "حسابك غير مؤكد بعد. يرجى التحقق من صندوق الوارد الخاص بك والنقر على رابط التأكيد. تذكر أيضًا التحقق من مجلد الرسائل غير المرغوب فيها (البريد العشوائي).",
        exists: "الحساب موجود بالفعل.",
        signup_failed: "تعذر إنشاء الحساب. البريد الإلكتروني أو رقم الهاتف مستخدم مسبقاً. تحقق من البيانات أو أعد المحاولة لاحقاً.",
        too_short: "كلمة المرور قصيرة جداً.",
        expired: "انتهت الجلسة.",
        rate_limit: "محاولات كثيرة."
      }
    },
    nav: {
      home: "الرئيسية",
      services: "خدماتنا",
      about: "من نحن",
      contact: "اتصل بنا",
      cart: "السلة",
      favorites: "المفضلة",
      my_orders: "طلباتي",
      my_deposits: "إيداعاتي",
      my_codes: "أكوادي",
      my_tickets: "تذاكري",
      site_home: "العودة للموقع",
      support: "الدعم",
      admin_panel: "الإدارة",
      search_order: "بحث عن طلب..."
    },
    dashboard: {
      welcome: "مرحباً، {{name}}!",
      current_balance: "الرصيد الحالي",
      recent_deposits: "الإيداعات الأخيرة",
      recent_orders: "الطلبات الأخيرة",
      last_30_days: "آخر 30 يومًا",
      download_invoice: "تحميل الفاتورة",
      no_data: "لا توجد بيانات متاحة",
      items_count: "{{count}} منتجات",
      view_invoice: "فاتورة",
      loading: "جاري تحميل لوحة التحكم...",
      available_balance: "الرصيد المتاح"
    },
    Dashboard: {
      header: {
        appBadge: "ء خدمات",
        securityBadge: "خزنة آمنة",
        clientOverviewTitle: "نظرة عامة للعميل {{name}}",
        activeStatus: "الحساب نشط"
      },
      stats: {
        balance: "الرصيد المتاح",
        deposits: "الإيداعات الأخيرة",
        orders: "الطلبات الأخيرة",
        pending: "عمليات قيد الانتظار"
      },
      alerts: {
        lowBalance: "تنبيه: رصيدك غير كافٍ. يرجى إجراء إيداع.",
        pendingOperations: "تحذير: لديك {{count}} عملية قيد الانتظار."
      },
      orders: {
        invoiceFileLabel: "PDF"
      }
    },
    landing: {
      hero_title: "جميع خدماتك الرقمية",
      hero_subtitle: "في مكان واحد",
      hero_desc: "eServices تصبح منصتك الكاملة لشراء الخدمات الرقمية وأكثر من ذلك بكثير. أدر جميع طلباتك بسهولة.",
      cta_start: "ابدأ الآن",
      cta_services: "خدماتنا",
      features: {
        fast: "سريع وموثوق",
        secure: "دفع آمن",
        support: "دعم 24/7",
        operators: "جميع المشغلين"
      },
      how_it_works: "كيف يعمل؟",
      steps: {
        1: "أنشئ حساباً",
        2: "قم بالإيداع",
        3: "اطلب خدمتك"
      },
      testimonials: {
        1: {
        },
        2: {
        },
        3: {
        },
        4: {
        },
        5: {
        },
        title: "ماذا يقول عملاؤنا"
      },
      cta_footer: {
        title: "مستعد لتبسيط عمليات الشحن؟"
      },
      hero_image_alt: "رسم توضيحي eServices"
    },
    cart: {
      title: "سلة التسوق",
      empty_title: "سلتك فارغة",
      empty_desc: "يبدو أنك لم تقم بإضافة أي شيء بعد.",
      browse_services: "تصفح الخدمات",
      mode: "الطريقة:",
       remove: "إزالة",
       pay: "دفع",
       min_required: "الحد الأدنى للكمية {{min}} مطلوب لهذا النوع من المنتجات.",
      summary_title: "ملخص الطلب",
      subtotal: "المجموع الفرعي",
      total: "الإجمالي",
      checkout_btn: "إتمام الطلب",
      login_to_checkout: "سجل الدخول للطلب",
      continue_shopping: "متابعة التسوق",
      in_your_basket: "في سلة تسوقك",
      extra_fees: "مصاريف الخدمة"
    },
    checkout: {
      title: "الدفع",
      summary_title: "ملخص الطلب",
      edit: "تعديل",
      total_to_pay: "الإجمالي للدفع",
      payment_method_title: "طريقة الدفع",
      alerts: {
        limited_methods: "ملاحظة: تحتوي سلة التسوق على عناصر للتسليم الفوري. فقط المدفوعات الفورية مسموح بها لهذا الطلب."
      },
      errors: {
        select_method: "يرجى اختيار طريقة دفع.",
        invalid_input: "يرجى التحقق من معلومات الدفع الخاصة بك.",
        create_error: "خطأ أثناء إنشاء الطلب.",
        insufficient_stock: "مخزون غير كافٍ لهذا المنتج: الكمية المطلوبة {{requested}}، الكمية المتاحة {{available}}.",
        accept_terms_required: "يرجى قبول الشروط العامة قبل المتابعة."
      },
      select_hint: "يرجى اختيار طريقة دفع للمتابعة",
      view_orders: "عرض طلباتي",
      solde: {
        current: "الرصيد الحالي:",
        insufficient: "الرصيد غير كاف. ينقصك",
        sufficient: "الرصيد كاف.",
        processing: "جاري المعالجة...",
        pay_btn: "الدفع بالرصيد"
      },
      flouci: {
        title: "الدفع عبر Flouci",
        instructions: "أرسل الدفع إلى أحد الحسابات التالية:",
        step1: "1. افتح",
        no_account: "لم يتم تكوين حساب Flouci.",
        label_id: "معرف المعاملة الخاص بك",
        placeholder_id: "مثال: ABC123XYZ",
        btn_verifying: "جاري التحقق...",
        btn_confirm: "تأكيد الدفع"
      },
      d17: {
        title: "الدفع عبر D17",
        instructions: "أرسل الدفع إلى أحد الحسابات التالية:",
        step1: "1. افتح",
        no_account: "لم يتم تكوين حساب D17.",
        step2: "2. أدخل رمز المعاملة المستلم عبر الرسائل النصية.",
        label_code: "رمز المعاملة (SMS)",
        placeholder_code: "مثال: 12345678",
        btn_verifying: "جاري التحقق...",
        btn_confirm: "تأكيد الدفع"
      },
      izi_pay: {
        title: "الدفع عبر IZI Pay",
        instructions: "أرسل الدفع إلى معرف IZI Pay المعروض.",
        step1: "1. افتح تطبيق IZI Pay وأرسل {{amount}} إلى المعرف أدناه.",
        no_account: "لم يتم تكوين حساب IZI Pay.",
        step2: "2. أدخل رمز المعاملة أو المرجع.",
        label_code: "رمز / مرجع المعاملة",
        placeholder_code: "مثال: 123456",
        btn_verifying: "جاري التحقق...",
        btn_confirm: "تأكيد الدفع"
      },
      portefeuille: {
        title: "الدفع عبر محفظة جوال",
        instructions: "أرسل المبلغ إلى الرقم أو المعرف أدناه.",
        step1: "1. افتح تطبيق المشغّل وأرسل {{amount}} إلى المعرف أدناه.",
        no_account: "لم يتم تكوين حساب محفظة لهذا الإيداع.",
        step2: "2. أدخل مرجع المعاملة أو الرمز المقدّم بعد الدفع.",
        label_code: "مرجع / رمز المعاملة",
        placeholder_code: "مثال: ABC123 أو 123456",
        btn_verifying: "جاري التحقق...",
        btn_confirm: "تأكيد الإيداع"
      },
      virement: {
        title: "تحويل بنكي",
        instructions: "قم بتحويل {{amount}} إلى أحد الحسابات أدناه:",
        rib: "RIB:",
        iban: "IBAN:",
        holder: "المستفيد:",
        no_account: "لم يتم تكوين حساب بنكي.",
        label_proof: "رفع إثبات التحويل",
        choose_file: "اختر ملف",
        file_selected: "تم اختيار الملف: {{name}}",
        no_file: "لم يتم اختيار ملف",
        btn_sending: "جاري الإرسال...",
        btn_send: "إرسال الإثبات"
      },
      success: {
        title: "تم تأكيد الطلب!",
        message: "تم تقديم طلبك بنجاح."
      },
      legal: {
        checkbox_label: "أوافق صراحةً على "
      }
    },
    transactionOTP: {
      title: "تأكيد بالرمز",
      subtitle: "سيتم إرسال الرمز إلى {{phone}}.",
      subtitleWithAmount: "أكد {{label}} بقيمة {{amount}} باستخدام الرمز الذي سيتم إرساله إلى {{phone}}.",
      sendCode: "إرسال الرمز",
      sending: "جاري الإرسال...",
      confirm: "تأكيد",
      verifying: "جاري التحقق...",
      resend: "إعادة الإرسال",
      cancel: "إلغاء",
      expiresIn: "ينتهي خلال {{seconds}} ث",
      errorExpired: "انتهت صلاحية الرمز. اطلب رمزاً جديداً.",
      errorTooMany: "محاولات كثيرة. أعد المحاولة لاحقاً.",
      errorInvalid: "رمز غير صحيح. تحقق وأعد المحاولة.",
      phoneRequired: "أضف رقم هاتفك في الملف الشخصي لتأكيد المعاملات."
    },
    TransactionOTPModal: {
      a11y: {
        close: "إغلاق"
      },
      header: {
        title: "تأكيد عبر الرمز",
        subtitle:
          "سنرسل رمزاً مكوّناً من 6 أرقام إلى {{phone}} (عبر الرسائل النصية أو واتساب حسب الإعداد).",
        subtitleWithAmount:
          "لتأكيد {{label}} بقيمة {{amount}}، سنرسل رمزاً من 6 أرقام إلى {{phone}}."
      },
      send: {
        sendCode: "إرسال الرمز",
        sending: "جارٍ إرسال الرمز…",
        phoneInvalid:
          "لا يمكن إرسال الرمز: يبدو أن رقم الهاتف غير مضاف أو غير صحيح. راجعه في ملفك الشخصي."
      },
      testAccount: {
        a11yTitle: "تأكيد المعاملة (حساب تجريبي)",
        loading: "جارٍ إتمام طلبك…",
        error:
          "تعذر إكمال هذه الخطوة. اضغط «إعادة المحاولة» أو أغلق النافذة.",
        retry: "إعادة المحاولة",
        close: "إغلاق"
      },
      postVerify: {
        error:
          "الرمز صحيح، لكن لم تكتمل المعاملة. أعد المحاولة. إن استمرت المشكلة، اتصل بالدعم."
      },
      code: {
        expiresIn: "ينتهي الرمز خلال {{seconds}} ث",
        verifying: "جارٍ التحقق من الرمز…",
        confirm: "تأكيد",
        resend: "إرسال رمز جديد",
        resendWithCountdown: "{{label}} ({{seconds}}ث)"
      },
      footer: {
        cancelDecorated: "─── إلغاء ───"
      }
    },
    otpErrors: {
      send: {
        invalid_phone: "رقم الهاتف غير صالح أو ناقص. تحقق من التنسيق (مثال: 216 XXXXXXXX).",
        rate_limited: "طلبات رموز كثيرة. انتظر دقائق قبل طلب رمز جديد.",
        api_error: "تعذر إرسال الرمز حالياً. أعد المحاولة لاحقاً أو اتصل بالدعم.",
        ip_blocked: "طلبات كثيرة من اتصالك. أعد المحاولة بعد ساعة أو لاحقاً. إن استمرت المشكلة، اتصل بالدعم.",
        network: "مشكلة في الاتصال. تحقق من الإنترنت وأعد المحاولة."
      },
      verify: {
        invalid_code: "الرمز المدخل غير صحيح. تحقق من الأرقام الستة وأعد المحاولة.",
        expired: "انتهت صلاحية هذا الرمز. انقر « إعادة الإرسال » لاستلام رمز جديد.",
        too_many_attempts: "تم بلوغ الحد الأقصى من المحاولات لهذا الرمز. يرجى طلب رمز جديد.",
        ip_blocked: "طلبات كثيرة من اتصالك. أعد المحاولة بعد ساعة أو لاحقاً.",
        network: "مشكلة في الاتصال. تحقق من الإنترنت وأعد المحاولة."
      },
      code_length: "يجب أن يتضمن الرمز 6 أرقام بالضبط."
    },
    rateLimitingPolicy: {
      title: "حدود الاستخدام وسياسة الأمان",
      subtitle: "معلومات عن حدود الطلبات وإجراءات الأمان المطبقة على المنصة.",
      lastUpdate: "آخر تحديث:",
      intro: "لحماية المنصة وجميع المستخدمين من إساءة الاستخدام (إرسال رموز بشكل مكثف، تسجيلات احتيالية، إلخ)، نطبق حدوداً حسب عنوان IP والإجراء. فيما يلي تفاصيل السياسات المعمول بها.",
      tips: {
        sectionTitle: "لتجربة سلسة: كيف تتجنب الحظر",
        intro: "باتباع هذه القواعد البسيطة تتجنب أي حظر أو رسالة تجاوز الحد.",
        tip1: "أدخل الرمز المستلم (SMS/واتساب) خلال 10 دقائق وبانتباه — بحد أقصى 5 محاولات لكل رمز.",
        tip2: "انتظر 10 دقائق على الأقل بين طلبي « رمز جديد » لنفس الرقم.",
        tip3: "تجنب تنفيذ الكثير من العمليات في وقت قصير (طلب + إيداع + إعادة إرسال)؛ فرّق بينها بضع دقائق إن أمكن.",
        tip4: "استخدم اتصالاً مستقراً (واي‑فاي أو 4G) لتجنب محاولات متكررة غير ضرورية.",
        tip5: "إن ظهرت رسالة حظر، انتظر المدة المذكورة (مثلاً 10 دقائق، ساعة، 24 ساعة) أو اتصل بالدعم إن رأيت أن الأمر خطأ."
      },
      otp: {
        sectionTitle: "1. رموز التحقق (OTP)",
        intro: "الرموز المكونة من 6 أرقام المرسلة عبر واتساب (أو SMS) لتسجيل الدخول وتأكيد الهاتف والتحقق من المعاملات (الإيداع، الشراء) تخضع للقواعد التالية:",
        limit10m: "حد أقصى 5 إرسالات لكل نوع إجراء (تسجيل الدخول، إيداع، طلب، إدارة) خلال 10 دقائق.",
        limit10mBlock: "كل نوع إجراء له حصته؛ بعد 5 إرسالات لنفس الإجراء في 10 دقائق، يُطبّق حظر 10 دقائق لهذا الإجراء.",
        limitPerAction: "العدادات منفصلة حسب الإجراء: تسجيل الدخول والإيداع والطلب والإدارة لا تتشارك نفس الحصة خلال 10 دقائق.",
        limitDay: "حد يومي 20 إرسالاً لكل رقم خلال 24 ساعة (جميع الإجراءات مجتمعة).",
        limitDayBlock: "عند بلوغ 20 إرسالاً، حظر تلقائي لمدة 24 ساعة.",
        oneCodeActive: "رمز واحد نشط فقط في نفس الوقت لكل رقم.",
        maxAttemptsPerCode: "5 محاولات كحد أقصى لكل رمز.",
        maxAttemptsBlock: "بعد 5 محاولات خاطئة، يصبح الرمز غير صالح ويجب طلب رمز جديد.",
        blockVerify: "تجاوز 5 محاولات تحقق: رمز OTP ملغى، اطلب رمزاً جديداً.",
        codeValidity: "صلاحية الرمز: 10 دقائق بعد الإنشاء.",
        blockTitle: "في حال تجاوز الحدود:",
        block10m: "تجاوز 5 إرسالات / 10 دقائق لإجراء واحد: حظر 10 دقائق لهذا الإجراء.",
        blockDay: "تجاوز 20 إرسالاً / 24 ساعة: حظر 24 ساعة.",
        blockExtreme: "إساءة استعمال واضحة: حظر ممتد محتمل."
      },
      register: {
        sectionTitle: "2. التسجيل (إنشاء الحساب)",
        intro: "محاولات إنشاء الحساب من نفس الاتصال محدودة كما يلي:",
        limit1h: "حد أقصى 3 تسجيلات في الساعة.",
        limitDay: "حد يومي 10 تسجيلات في اليوم.",
        blockTitle: "في حال تجاوز الحدود:",
        block1h: "حظر ساعة واحدة بعد 3 تسجيلات في ساعة.",
        block1hAfter: "بعد 3 تسجيلات في ساعة، حظر ساعة واحدة.",
        blockDay: "عند بلوغ 10 تسجيلات، حظر 24 ساعة.",
        blockExtreme: "إساءة استعمال واضحة: حظر ممتد محتمل.",
        waitTime: "وقت انتظار موصى به: 20 دقيقة على الأقل بين كل تسجيل."
      },
      general: {
        sectionTitle: "3. السلوك العام",
        byIp: "الحدود تُحسب حسب عنوان IP بشكل فردي. نفس شبكة Wi‑Fi أو مشاركة الاتصال تشترك في هذه الحدود.",
        noAccount: "تطبق القيود حتى دون حساب مستخدم: أي طلب إلى الخدمات المعنية يُحتسب.",
        contact: "إذا تم حظرك أثناء استخدام المنصة بشكل طبيعي، اتصل بالدعم (contact@eservices.tn) مع وصف وضعك.",
        tableNote: "أوقات الانتظار المذكورة توصيات لتجنب الحظر التلقائي؛ تطبق المنصة مدد الحظر."
      },
      table: {
        title: "ملخص الحدود",
        action: "الإجراء",
        limit: "الحد",
        waitTime: "وقت الانتظار الموصى به",
        blockDuration: "الحظر عند التجاوز",
        rowSendOtp: "إرسال OTP",
        sendOtpLimit: "5 / 10 دقائق (لكل إجراء)",
        rowValidateOtp: "التحقق من OTP",
        validateOtpLimit: "5 محاولات لكل رمز",
        validateOtpWait: "اطلب رمزاً جديداً إن تجاوزت المحاولات",
        validateOtpBlock: "رمز OTP ملغى",
        rowDailyOtp: "الإرسالات اليومية OTP",
        rowRegister: "التسجيل",
        rowDailyRegister: "التسجيلات اليومية",
        waitExpiration: "انتظار انتهاء صلاحية الرمز",
        spaceOut: "تفريق الإرسالات",
        limitCreations: "الحد من الإنشاءات",
        rowIpBlock: "حظر IP (عمليات متتالية دون انتظار)",
        limitSuccessive: "طلبات أو إجراءات كثيرة في وقت قصير",
        waitBetweenActions: "دقائق بين كل إجراء",
        blockIpDuration: "ساعة إلى 24 ساعة (حسب الحالة)"
      },
      footer: "قد تُعدّل هذه السياسات لتحسين الأمان أو تجربة المستخدم. القيم المذكورة أعلاه تعكس الإعداد الحالي."
    },
    contact: {
      page_title: "اتصل بنا",
      page_subtitle: "نحن هنا لمساعدتك. أرسل لنا رسالة وسنرد عليك في أقرب وقت ممكن.",
      info_emails_title: "راسلنا",
      info_label_general: "عام",
      info_label_support: "الدعم",
      info_label_sales: "المبيعات",
      info_phones_title: "اتصل بنا",
      info_address_title: "زرنا",
      form_title: "أرسل رسالة",
      label_name: "الاسم",
      placeholder_name: "اسمك",
      label_email: "البريد الإلكتروني",
      placeholder_email: "votre@email.com",
      label_phone: "الهاتف",
      placeholder_phone: "+216 21 380 039",
      label_subject: "الموضوع",
      subject_general: "استفسار عام",
      subject_support: "دعم فني",
      subject_sales: "مبيعات وشراكات",
      subject_other: "أخرى",
      label_message: "الرسالة",
      placeholder_message: "كيف يمكننا مساعدتك؟",
      btn_sending: "جاري الإرسال...",
      btn_submit: "إرسال الرسالة",
      footer_text: "فريقنا متاح 24/7 للرد على أسئلتك.",
      error_required: "يرجى ملء جميع الحقول الإلزامية.",
      ticket_subject: "{{theme}} - {{name}}",
      success_message: "تم إرسال رسالتك بنجاح!"
    },
    faq: {
      title: "الأسئلة الشائعة",
      subtitle: "إجابات على جميع استفساراتكم حول استخدام منصة ء خدمات.",
      question: "كيف أنشئ حسابًا؟"
    },
    servicesPage: {
      hero: {
        titleFavorites: "المفضلة لديك",
        titleAll: "اكتشف خدماتنا",
        subtitleFavorites: "ستجد هنا جميع المنتجات التي أعجبتك.",
        subtitleAll: "حلول لجميع احتياجاتك الرقمية والاتصالية."
      },
      filters: {
        category: "الفئة",
        categoryAll: "جميع الفئات",
        subcategory: "الفئة الفرعية",
        subcategoryAll: "الكل",
        availability: "التوفر",
        availabilityAll: "جميع الحالات",
        search: "بحث",
        searchPlaceholder: "الاسم، القيمة..."
      },
      state: {
        loading: "جاري التحميل..."
      },
      empty: {
        favorites: "ليس لديك منتجات في المفضلة.",
        search: "لا يوجد منتج يطابق معاييرك."
      }
    },
    ServicesPage: {
      hero: {
        logo: "ء خدمات",
        titleFavorites: "المفضلة لديك",
        titleAll: "اكتشف خدماتنا",
        subtitleFavorites: "ستجد هنا جميع المنتجات التي أعجبتك.",
        subtitleAll: "حلول لجميع احتياجاتك الرقمية والاتصالية."
      },
      filters: {
        category: "الفئة",
        categoryAll: "جميع الفئات",
        subcategory: "الفئة الفرعية",
        subcategoryAll: "الكل",
        availability: "التوفر",
        availabilityAll: "جميع الحالات",
        saleType: "نوع البيع",
        saleTypeAll: "جميع الأنواع",
        saleTypeDetail: "بيع بالتجزئة",
        saleTypeGros: "بيع بالجملة",
        search: "بحث",
        searchPlaceholder: "الاسم، القيمة..."
      },
      state: {
        loading: "جاري التحميل..."
      },
      empty: {
        favorites: "ليس لديك منتجات في المفضلة.",
        search: "لا يوجد منتج يطابق معاييرك."
      }
    },
    product: {
      product: "المنتج",
      price_total: "السعر الإجمالي",
      item: "منتج",
      items: "منتجات",
      delivery_method: "طريقة التسليم",
      similar_products: "منتجات مشابهة",
      adding: "جاري الإضافة...",
      added: "تمت الإضافة",
      add_to_cart: "أضف إلى السلة",
      unavailable: "المنتج غير متوفر",
      add: "إضافة",
      soon_available: "قريبا",
      out_of_stock: "نفذت الكمية",
      see_options: "عرض الخيارات",
      badges: {
        wholesale: "جملة (أدنى {{min}})",
        sold_out: "نفذت الكمية",
        incoming: "وصل حديثاً",
        best_seller: "الأكثر مبيعاً",
        soon: "قريبا"
      },
      card: {
        decrease_qty: "إنقاص الكمية",
        increase_qty: "زيادة الكمية",
        remove_favorite: "إزالة من المفضلة",
        add_favorite: "إضافة للمفضلة"
      },
      alerts: {
        min_qty: "الحد الأدنى للكمية لهذا المنتج هو {{min}}.",
        required_field: "يرجى ملء الحقل: {{label}}",
        select_option: "يرجى تحديد خيار لـ: {{label}}",
        upload_login: "يجب تسجيل الدخول لرفع الملفات.",
        upload_error: "فشل الرفع لـ {{label}}.",
        add_error: "خطأ في الإضافة للسلة.",
        rating_required: "يرجى تقديم تقييم."
      },
      breadcrumb: {
        home: "الرئيسية",
        services: "الخدمات",
        category: "الفئة"
      },
      preferences: {
        required: "(مطلوب)",
        included_features: "الميزات المضمنة:"
      },
      gallery: {
        view: "عرض",
        unavailable: "الصورة غير متوفرة"
      },
      reviews: {
        title: "آراء العملاء",
        based_on: "بناءً على {{count}} تقييم",
        write_review: "اكتب تقييمًا",
        rating_label: "التقييم",
        comment_label: "تعليق",
        comment_placeholder: "شارك تجربتك...",
        submitting: "جاري الإرسال...",
        submit: "إرسال التقييم",
        login_to_review: "يرجى تسجيل الدخول لترك تقييم.",
        login_link: "تسجيل الدخول",
        count: "({{count}} تقييم)",
        empty: "لا توجد تقييمات بعد."
      }
    },
    ProductDetailPage: {
      state: {
        loading: "جاري التحميل...",
        notFound: "المنتج غير موجود."
      },
      hero: {
        reviewsCount: "{{count}} تقييم"
      },
      description: {
        title: "ما الذي تحصل عليه",
        subtitle: "الميزات المضمنة"
      },
      configurator: {
        title: "التخصيص والخيارات",
        required: "مطلوب",
        amountPlaceholder: "أدخل المبلغ",
        currencyUnit: "د.ت",
        fileUploading: "جاري التحميل...",
        fileAdded: "تمت إضافة الملف",
        addFile: "إضافة ملف",
        uploadError: "خطأ في الرفع.",
        includedWithChoices: "مشمول مع خياراتك",
        unitPrice: "السعر الوحدوي",
        estimatedTotal: "المجموع التقديري",
        minQuantityGros: "الحد الأدنى للكمية: {{min}} (بيع بالجملة)"
      },
      cta: {
        soldOut: "نفذت الكمية",
        orderNow: "اطلب الآن"
      },
      similar: {
        title: "منتجات مشابهة",
        items: "منتجات"
      },
      preferences: {
        labels: {
          typeDeCompte: "نوع الحساب",
          fullName: "الاسم الكامل",
          phone: "الهاتف",
          email: "البريد الإلكتروني",
          duree: "المدة",
          productLink: "رابط المنتج للشراء",
          productPriceTnd: "سعر المنتج (د.ت)",
          productScreenshot: "لقطة شاشة المنتج",
          intlDelivery: "التوصيل الدولي",
          subscriptionDuration: "مدة الاشتراك",
          language: "اللغة",
          regionalAdmin: "الإدارة الجهوية",
          school: "المؤسسة التعليمية",
          teacherName: "اسم المعلّم",
          levelsTaught: "المستويات المُدرّسة",
          sheetCount: "عدد الأوراق (وجه / ظهر)",
          spiralBinding: "التغليف الحلزوني",
          templateNumber: "رقم القالب",
          otherInstructions: "تعليمات أخرى",
          printing: "الطباعة"
        },
        options: {
          yearlyOffer: "العرض السنوي",
          lifetimeOffer: "العرض مدى الحياة",
          oneYear: "سنة واحدة",
          oneMonth: "شهر واحد",
          threeMonths: "3 أشهر",
          fourMonths: "4 أشهر",
          sixMonths: "6 أشهر",
          twelveMonths: "12 شهراً",
          essentiel: "أساسي",
          standard: "قياسي",
          premium: "بريميوم",
          free: "مجاني",
          paid: "مدفوع",
          french: "الفرنسية",
          english: "الإنجليزية",
          arabic: "العربية",
          sheets40: "40",
          sheets60: "60",
          sheets80: "80",
          spiralPlastic: "حلزون بلاستيك",
          spiralMetal: "حلزون معدني",
          hotBinding: "تغليف حراري",
          blackWhite: "أبيض وأسود",
          color: "ملون",
          shared: "مشترك",
          personal: "شخصي"
        },
        features: {
          productPriceInflated: "سعر المنتج سيُرفع",
          productPriceReduced: "سعر المنتج سيُخفض",
          smallPrice90Days: "سعر منخفض لمدة 90 يوماً",
          bestValue: "أفضل قيمة",
          upTo2MonthsFree: "حتى شهرين مجاناً",
          netflix1Device: "شاهد Netflix تونس على جهاز واحد متوافق في كل مرة",
          netflix2Devices: "شاهد Netflix تونس على جهازين متوافقين في كل مرة",
          netflix4Devices: "شاهد Netflix تونس على 4 أجهزة متوافقة في كل مرة",
          netflix720p: "شاهد Netflix تونس بدقة 720p (HD)",
          netflix1080p: "شاهد Netflix تونس بدقة 1080p (Full HD)",
          netflix4k: "شاهد Netflix تونس بدقة 4K (Ultra HD) + HDR",
          download1Device: "حمّل العناوين على جهاز واحد متوافق في كل مرة",
          download2Devices: "حمّل العناوين على جهازين متوافقين في كل مرة",
          download6Devices: "حمّل العناوين على 6 أجهزة متوافقة في كل مرة"
        }
      }
    },
    orders: {
      page_title: "طلباتي",
      empty: "لم يتم العثور على طلب.",
      processing_message: "طلبك قيد المعالجة. سيتم إشعارك عبر البريد الإلكتروني قريبًا.",
      view_codes: "عرض الأكواد",
      track_package: "رقم التتبع"
    },
    deposits: {
      page_title: "إيداعاتي",
      new_deposit: "إيداع جديد",
      amount_label: "المبلغ",
      payment_method: "طريقة الدفع",
      instructions_header: "تعليمات الدفع",
      proof_label: "إثبات الدفع",
      history_title: "سجل الإيداعات",
      empty: "لم يتم العثور على إيداع.",
      submit_btn: "إرسال الإيداع"
    },
    my_codes: {
      title: "أكوادي",
      history: "السجل",
      select_hint: "اختر رمزاً من القائمة لرؤية التفاصيل.",
      empty_codes: "لم يتم العثور على رمز.",
      security_title: "تعليمات الأمان",
      security_desc: "هذا الرمز سري للغاية. لا تشارك أبداً لقطات الشاشة",
      history_desc: "يرجى اختيار رمز من القائمة لرؤية التفاصيل."
    },
    tickets: {
      page_title: "تذاكر الدعم",
      open_new: "فتح تذكرة جديدة",
      subject: "الموضوع",
      type: "النوع",
      status: "الحالة",
      last_update: "آخر تحديث",
      no_tickets: "لم يتم العثور على تذاكر.",
      form_title: "تذكرة جديدة",
      message_placeholder: "اوصف مشكلتك...",
      attachment: "مرفق (اختياري)",
      back_to_list: "← العودة للقائمة",
      reply_placeholder: "إجابة...",
      sending: "جاري الإرسال...",
      reply_btn: "إرسال الرد",
      close_ticket: "إغلاق التذكرة",
      close_confirm_title: "تأكيد الإغلاق",
      close_confirm_message: "هل أنت متأكد من رغبتك في إغلاق هذه التذكرة؟ بمجرد إغلاقها، لن تتمكن من الرد عليها بعد الآن."
    },
    SupportTickets: {
      table: {
        id: "المعرف",
        title: "تذاكري",
        lastUpdate: "آخر تحديث:",
        ticketSingular: "تذكرة",
        ticketPlural: "تذاكر"
      },
      empty: {
        description: "أنشئ تذكرة لأي استفسار أو مشكلة تقنية أو شكوى، وسيرد فريقنا عليك سريعًا."
      },
      context: {
        orderRef: "مرجع الطلب:",
        module: "الوحدة المعنية:",
        environment: "البيئة:"
      },
      modal: {
        info: {
          autoContactInfo: "سيتم ربط حسابك تلقائياً بهذه التذكرة (الاسم، البريد الإلكتروني)."
        }
      },
      form: {
        type: {
          orderIssue: "مشكلة في الطلب"
        },
        order: {
          relatedOrderLabel: "الطلب المعني",
          selectOrderPlaceholder: "اختر طلباً",
          noOrders: "ليس لديك أي طلبات."
        },
        support: {
          moduleLabel: "الوحدة المعنية (اختياري)",
          modulePlaceholder: "مثال: الدفع، أكوادي، التسليم...",
          environmentLabel: "البيئة (اختياري)",
          environmentPlaceholder: "مثال: Chrome 120، Windows 11 / Safari iOS 17..."
        }
      },
      messages: {
        selectOrderRequired: "يرجى اختيار الطلب المعني.",
        createdRef: "تم إنشاء التذكرة #{{ref}} بنجاح. يمكنك متابعة تقدمها أدناه."
      }
    },
    profile: {
      information: "المعلومات",
      balance: "الرصيد دت",
      orders: "الطلبات",
      update_success: "تم تحديث الملف الشخصي!",
      settings: {
        language: "اللغة",
        theme: {
          dark: "الوضع الداكن",
          light: "الوضع الفاتح"
        },
        notifications: "الإشعارات",
        notifications_desc: "تلقي الإشعارات"
      },
      security: {
        title: "الأمان",
        change_password: {
          desc: "قم بتحديث كلمة المرور بانتظام"
        },
        current_password: "كلمة المرور الحالية",
        new_password: "كلمة المرور الجديدة",
        confirm_password: "تأكيد كلمة المرور",
        forgot_password: "نسيت كلمة المرور؟",
        update_password: "تحديث كلمة المرور",
        tips: {
          1: "استخدم كلمة مرور قوية وفريدة",
          2: "غيّر كلمة المرور بانتظام",
          3: "لا تشارك كلمة المرور أبداً",
          title: "نصائح الأمان"
        },
        "2fa": {
          title: "المصادقة الثنائية",
          disabled: "حماية إضافية لحسابك",
          enable: "تفعيل المصادقة الثنائية",
          enabled: "الحماية مفعلة",
          regenerate_codes: "إعادة إنشاء رموز الاسترداد",
          disable: {
            title: "تعطيل المصادقة الثنائية",
            warning: "لأسباب أمنية، يرجى تأكيد كلمة المرور لتعطيل المصادقة الثنائية.",
            confirm: "تعطيل"
          },
          setup: {
            title: "إعداد Google Authenticator",
            step1: "الخطوة 1: إضافة إلى Google Authenticator",
            step1_1: "افتح Google Authenticator على هاتفك",
            step1_2: "اضغط على",
            step1_3: "اختر",
            step2: "الخطوة 2: أدخل المفتاح السري",
            secret_warning: "مهم: أدخل المفتاح بدون شرطات أو مسافات أو فواصل",
            secret_note: "النوع: قائم على الوقت | الخوارزمية: SHA1",
            step3: "الخطوة 3: التحقق من الرمز"
          },
          verify: "التحقق والتفعيل",
          recovery_codes: {
            title: "رموز الاسترداد",
            warning: "⚠️ مهم: احفظ هذه الرموز في مكان آمن. لن يتم عرضها مرة أخرى.",
            saved: "تم الحفظ"
          }
        }
      }
    },
    AdminDashboard: {
      header: {
        title: "لوحة تحكم المسؤول"
      },
      noData: "لا توجد بيانات متاحة",
      filters: {
        period: "الفترة",
        today: "اليوم",
        last7Days: "آخر 7 أيام",
        last30Days: "آخر 30 يومًا",
        last90Days: "آخر 90 يومًا",
        clientType: "النوع",
        all: "الكل",
        allFeminine: "الكل",
        new: "جدد",
        loyal: "مخلصون",
        inactive: "غير نشطين",
        spending: "الإنفاق",
        low: "منخفض",
        medium: "متوسط",
        high: "مرتفع"
      },
      exportCsv: "تصدير CSV",
      kpi: {
        totalClients: "إجمالي العملاء",
        newRegistrations: "تسجيلات جديدة",
        activeClients: "عملاء نشطون",
        inactiveClients: "عملاء غير نشطين",
        usersWithoutAction: "مسجلون دون نشاط",
        revenueGenerated: "الإيرادات المحققة",
        retentionRate: "معدل الاحتفاظ",
        mostLoyalClient: "أكثر العملاء ولاءً",
        orders: "طلبات"
      },
      chartLabels: {
        active: "نشطون",
        inactive: "غير نشطين",
        noAction: "بدون نشاط"
      },
      charts: {
        registrationsEvolution: "تطور التسجيلات",
        revenueEvolution: "تطور الإيرادات",
        topLoyalClients: "أفضل العملاء المخلصين",
        clientDistribution: "توزيع العملاء"
      },
      insights: {
        title: "تحليلات العملاء",
        mostLoyal: "أكثر العملاء ولاءً",
        atRisk: "عملاء في دائرة الخطر",
        noRisk: "لا يوجد عملاء في دائرة الخطر",
        highPotential: "جدد ذوو إمكانات عالية",
        noPotential: "لا يوجد جدد ذوو إمكانات عالية",
        totalSpent: "إجمالي المنفق",
        daysAgo: "أيام"
      },
      clientsTable: {
        title: "ملخص العملاء",
        name: "الاسم",
        email: "البريد الإلكتروني",
        registrationDate: "تاريخ التسجيل",
        lastActivity: "آخر نشاط",
        ordersCount: "عدد الطلبات",
        totalSpent: "إجمالي المنفق",
        status: "الحالة",
        actions: "إجراءات"
      },
      status: {
        new: "جديد",
        loyal: "مخلص",
        inactive: "غير نشط"
      },
      never: "أبدًا",
      viewProfile: "عرض الملف",
      notAvailable: "—",
      unknown: "غير معروف",
      exportHeaders: {
        name: "الاسم",
        email: "البريد الإلكتروني",
        registrationDate: "تاريخ التسجيل",
        lastActivity: "آخر نشاط",
        ordersCount: "عدد الطلبات",
        totalSpent: "إجمالي المنفق",
        status: "الحالة"
      }
    },
    SecurityDashboard: {
      header: {
        title: "الأمان والجودة"
      },
      ipBlocked: {
        title: "عناوين IP المحظورة",
        last24h: "عناوين IP جديدة محظورة خلال 24 ساعة"
      },
      ipActivity: {
        title: "نشاط IP (24 ساعة)",
        hint: "عناوين IP التي وصلت إلى نقاط حساسة"
      },
      otp: {
        title: "OTP (الإجمالي)",
        sent: "مرسلة",
        validationRate: "معدل التحقق"
      },
      tickets: {
        openTickets: "تذاكر مفتوحة",
        firstResponse: "متوسط وقت الرد الأول"
      },
      reviews: {
        title: "آراء العملاء (30 يومًا)",
        avgRating: "متوسط التقييم"
      },
      twoFa: {
        title: "حسابات مفعّل عليها 2FA",
        hint: "مستخدمون مع مصادقة قوية"
      },
      expired: {
        expired24h: "حسابات منتهية (24 ساعة)",
        hint: "تم إنشاؤها ولم تُفعّل في الوقت المحدد",
        total: "حسابات منتهية (الإجمالي)",
        totalHint: "سجل الحسابات المُنظّفة تلقائيًا"
      },
      notAvailable: "—"
    },
    ManageUsers: {
      header: {
        title: "إدارة المستخدمين"
      },
      addButton: "إضافة عميل",
      filters: {
        searchPlaceholder: "بحث...",
        statusLabel: "تصفية حسب الحالة",
        all: "الكل",
        showAllAccounts: "عرض جميع الحسابات",
        showExpiredOnly: "عرض الحسابات المنتهية فقط",
        deleteSelected: "حذف الحسابات المحددة"
      },
      table: {
        client: "العميل",
        status: "الحالة",
        balance: "الرصيد",
        activity: "النشاط",
        registration: "التسجيل",
        actions: "إجراءات",
        orders: "طلبات",
        deposits: "إيداعات"
      },
      loading: "جاري التحميل...",
      emptyState: "لم يتم العثور على عملاء.",
      messages: {
        fetchError: "فشل تحميل المستخدمين",
        bulkDeleteSuccess: "تم حذف الحسابات المنتهية بنجاح.",
        bulkDeleteError: "خطأ أثناء الحذف الجماعي.",
        statusUpdated: "تم تحديث الحالة.",
        checkDepsError: "تعذر التحقق من التبعيات.",
        deleteSuccess: "تم حذف المستخدم بنجاح.",
        deleteError: "خطأ أثناء الحذف."
      },
      bulkDelete: {
        confirm: "حذف {{count}} حسابًا منتهيًا نهائيًا؟ لا يمكن التراجع عن هذا الإجراء."
      },
      deleteModal: {
        title: "حذف {{name}}؟",
        analyzing: "جاري تحليل البيانات...",
        hasDependencies: "تحذير: هذا العميل لديه {{count}} عنصر مرتبط.",
        orders: "طلبات",
        deposits: "إيداعات",
        tickets: "تذاكر",
        reviews: "آراء",
        forceDeleteWarning: "سيؤدي الحذف القسري إلى محو كل السجل المرتبط نهائيًا.",
        noDependencies: "لا توجد بيانات مرتبطة. الحذف آمن.",
        cancel: "إلغاء",
        deleting: "جاري الحذف...",
        forceDelete: "حذف (قسرًا)",
        confirm: "تأكيد"
      },
      addModal: {
        title: "عميل جديد",
        firstName: "الاسم الأول",
        lastName: "اللقب",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        phonePlaceholder: "+216 XX XXX XXX",
        address: "العنوان",
        cancel: "إلغاء",
        createAccount: "إنشاء الحساب",
        emailInvalid: "صيغة البريد الإلكتروني غير صالحة.",
        phoneInvalid: "رقم الهاتف غير صالح. استخدم +216 XX XXX XXX"
      }
    },
    ManageOrders: {
      modal: {
        orderTitle: "طلب #{{id}}",
        close: "إغلاق",
        subtotal: "المجموع الفرعي",
        deliveryFee: "رسوم التوصيل",
        stampFee: "الطابع الجبائي",
        total: "المجموع",
        deliveryAction: "إجراء التسليم",
        productConcerned: "المنتج المعني",
        identifierEmail: "المعرف / البريد الإلكتروني",
        emailPlaceholder: "email@example.com",
        password: "كلمة المرور",
        passwordPlaceholder: "••••••••",
        licenceKey: "مفتاح الترخيص",
        licencePlaceholder: "XXXXX-XXXXX-XXXXX-...",
        certificateLink: "رابط الشهادة (اختياري)",
        urlPlaceholder: "https://...",
        invitationUrl: "رابط الدعوة (Canva، Google Family، إلخ.)",
        trackingLink: "رابط التتبع",
        trackingPlaceholder: "رقم التتبع أو الرابط",
        noteToClient: "ملاحظة للعميل",
        notePlaceholder: "تعليمات أو رسالة للعميل...",
        codeLabel: "الرمز (بطاقة هدية / قسيمة)",
        codePlaceholder: "الرمز المرسل بالبريد",
        codesAssigned: "رموز معينة (تسليم تلقائي)",
        codesAssignedShort: "رموز معينة:",
        codeInstantInfo: "رمز فوري: يُسلّم تلقائيًا عند التحقق من الطلب أو يظهر في قائمة المنتجات أدناه.",
        saving: "جاري الحفظ...",
        saveAndSend: "حفظ وإرسال",
        productsCount: "منتجات ({{count}})",
        ship: "شحن",
        delivered: "تم التسليم",
        resolveProblem: "حل المشكلة",
        resolveTitle: "حل المشكلة — طلب #{{id}}",
        step: "الخطوة {{step}}",
        problemType: "نوع المشكلة:",
        action: "الإجراء:",
        quantityToReplace: "الكمية المراد استبدالها لكل سطر (التحقق من المخزون عند الإنشاء):",
        max: "الحد الأقصى {{count}}",
        compensationCart: "سلة التعويض (التحقق من المخزون عند الإنشاء):",
        chooseProduct: "اختر منتجًا",
        add: "إضافة",
        summaryAndOptions: "الملخص والخيارات:",
        problem: "المشكلة:",
        actionLabel: "الإجراء:",
        quantities: "الكميات:",
        compensationLines: "{{count}} سطر تعويض",
        internalNote: "ملاحظة داخلية (اختياري)",
        internalNotePlaceholder: "تعليق للتدقيق...",
        riskLevel: "مستوى المخاطر (اختياري)",
        notSpecified: "— غير محدد —",
        riskLow: "منخفض",
        riskMedium: "متوسط",
        riskHigh: "مرتفع",
        evidenceRequested: "طلب إثبات من العميل",
        cancel: "إلغاء",
        back: "رجوع",
        sending: "جاري الإرسال...",
        confirm: "تأكيد",
        next: "التالي",
        remove: "إزالة",
        indicateQuantity: "حدد كمية واحدة على الأقل للاستبدال.",
        addCompensation: "أضف منتجًا واحدًا على الأقل للتعويض.",
        instantCodesDelivered: "تم تسليم الأكواد الفورية في هذا الطلب مسبقًا. لا يمكن تطبيق حالة «مكتملة» مرة ثانية.",
        trackingNumber: "رقم التتبع"
      },
      filters: {
        searchPlaceholder: "بحث برقم الطلب، العميل، البريد...",
        reset: "إعادة تعيين",
        type: "النوع",
        all: "الكل",
        standard: "قياسي",
        replacement: "استبدال",
        compensation: "تعويض",
        paid: "مدفوع",
        free: "مجاني (0)",
        allStatus: "الكل",
        ordersCount: "{{count}} / {{total}} طلب"
      },
      table: {
        typeInfo: "النوع / المعلومات",
        replacement: "استبدال",
        compensation: "تعويض",
        originalOrder: "الطلب الأصلي",
        problemResolved: "تم حل المشكلة"
      }
    },
    AdminProfile: {
      header: {
        title: "الملف الشخصي للمسؤول",
        cancel: "إلغاء",
        saving: "جاري الحفظ...",
        save: "حفظ",
        editProfile: "تعديل الملف الشخصي"
      },
      loading: "جاري تحميل الملف الشخصي...",
      banner: {
        avatar: "الصورة الشخصية",
        adminSpace: "مساحة المسؤول",
        backOffice: "إدارة المكتب الخلفي ء خدمات.tn",
        securityTitle: "أمان الحساب",
        securityDescription: "حافظ على تحديث بريدك الإلكتروني ورقم هاتفك لتجربة أكثر أمانًا."
      },
      messages: {
        success: "تم تحديث الملف الشخصي بنجاح!",
        error: "خطأ أثناء تحديث الملف الشخصي."
      },
      personalInfo: {
        title: "المعلومات الشخصية",
        firstName: "الاسم الأول",
        lastName: "اللقب",
        address: "العنوان البريدي"
      },
      contact: {
        title: "جهة الاتصال وتسجيل الدخول",
        loginEmail: "البريد الإلكتروني لتسجيل الدخول",
        phone: "رقم الهاتف",
        notProvided: "غير مذكور",
        usageNote: "تُستخدم معلومات الاتصال لاسترداد الحساب والإشعارات الحرجة والتحقق المزدوج من هويتك."
      }
    },
    admin: {
      nav: {
        dashboard: "لوحة التحكم",
        deposits: "إدارة الإيداعات",
        orders: "إدارة الطلبات",
        stock: "إدارة المخزون",
        products: "إدارة المنتجات",
        categories: "إدارة الفئات",
        media: "مكتبة الوسائط",
        security: "الأمان",
        users: "المستخدمين",
        tickets: "تذاكر الدعم",
        payment_methods: "طرق الدفع",
        delivery_settings: "التوصيل",
        settings: "إعدادات الموقع",
        view_site: "عرض الموقع"
      },
      dashboard: {
        title: "لوحة الإدارة",
        total_revenue: "إجمالي الإيرادات",
        total_users: "المشتركين",
        total_orders: "إجمالي الطلبات",
        pending_deposits: "إيداعات معلقة",
        revenue_by_operator: "الإيرادات حسب المشغل",
        orders_status: "حالة الطلبات",
        revenue: "إيراد",
        orders: "طلبات"
      },
      profile: {
        title: "الملف الشخصي للمسؤول",
        cancel: "إلغاء",
        saving: "جاري الحفظ...",
        save: "حفظ",
        edit: "تعديل",
        success: "تم تحديث الملف الشخصي بنجاح!",
        error: "خطأ في تحديث الملف الشخصي.",
        loading: "جاري التحميل...",
        first_name: "الاسم الأول",
        last_name: "اللقب",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        address: "العنوان",
        avatar: "الصورة الشخصية"
      },
      preferences: {
        title: "تفضيلات الدفع",
        add_method: "إضافة وسيلة",
        update_success: "تم تحديث التفضيل.",
        create_success: "تمت إضافة تفضيل جديد.",
        delete_success: "تم حذف التفضيل.",
        load_error: "خطأ في تحميل التفضيلات.",
        delete_confirm: "هل أنت متأكد من حذف هذا السجل؟",
        edit_title: "تعديل",
        add_title: "إضافة",
        method_subtitle: "وسيلة دفع",
        category: "الفئة",
        category_bank: "بنك",
        category_ccp: "بريد (CCP)",
        category_wallet: "محفظة",
        provider_name: "اسم المزود",
        identifier: "المعرف (RIB، هاتف)",
        iban_optional: "IBAN (اختياري)",
        account_holder_optional: "المستفيد (اختياري)",
        cancel: "إلغاء",
        save: "حفظ",
        edit_tooltip: "تعديل",
        duplicate_tooltip: "تكرار",
        delete_tooltip: "حذف",
        identifier_label: "المعرف / RIB / هاتف",
        iban_label: "IBAN",
        holder_label: "المستفيد"
      },
      payment_methods: {
        page_title: "طرق الدفع",
        page_subtitle:
          "اضبط بيانات الدفع (الحسابات، المحافظ، البريد…) الظاهرة للعملاء. القواعد التفصيلية (المسارات، الأنواع، السلة) موثقة في docs/paiement-moyens.md.",
        section_deposits: "شحن الرصيد (إيداعات)",
        section_deposits_hint: "نوع deposit_method في قاعدة البيانات — بدون الرصيد الداخلي.",
        section_orders: "دفع الطلبات",
        section_orders_hint: "نوع order_payment_method — يشمل الدفع عند التسليم.",
        section_products: "الطرق المسموحة لكل منتج",
        section_products_hint: "مصفوفة payment_method على المنتجات.",
        rules_title: "القواعد المطبقة في التطبيق",
        rule_deposits: "الإيداعات تستخدم deposit_method فقط (تحويل إلى معرف، حوالة بريدية، فلوسي، D17، تحويل بنكي) — لا يُستخدم الرصيد الداخلي.",
        rule_instant: "منتج «رمز فوري»: الرصيد الداخلي فقط عند الدفع.",
        rule_non_instant: "أنماط تسليم أخرى: كل طرق الطلب المناسبة (رصيد، عند التسليم، فلوسي، D17، تحويل) حسب قواعد السلة والمنتج.",
        rule_admin_table: "كل صف له رمز يطابق قيم enum في PostgreSQL، مع خيارات طلب / إيداع / كتالوج لتحديد أين تظهر الإحداثيات.",
        credentials_title: "بيانات الدفع (admin_payment_settings)",
        disabled_badge: "معطّل",
        scope_short_order: "طلب",
        scope_short_deposit: "إيداع",
        scope_short_product: "كتالوج",
        card: {
          sort: "الترتيب",
          created: "تاريخ الإنشاء",
        },
        payment_setting_category: {
          carte_bancaire: "بطاقة بنكية",
          carte_prepayee: "بطاقة مسبقة الدفع",
          carte_credit: "بطاقة ائتمان",
          carte_debit: "بطاقة خصم",
          virement_bancaire: "تحويل بنكي",
          virement_postal: "تحويل بريدي / حساب بريدي",
          p2p: "دفع بين الأفراد (P2P)",
          portefeuille_electronique: "محفظة إلكترونية",
          portefeuille_mobile: "محفظة جوال",
          solde_interne: "رصيد داخلي",
          mandat_cash: "حوالة نقدية",
          mandat_compte: "حوالة على حساب",
          mandat_postal: "حوالة بريدية",
          mandat_bancaire: "أمر / تحويل بنكي (مثل MoneyGram)",
          cheque_bancaire: "شيك بنكي",
          cheque_postal: "شيك بريدي",
          cheque_vacances: "شيك إجازات",
          especes: "نقد",
          prelevement_automatique: "خصم تلقائي",
          cryptomonnaie: "عملة مشفرة",
          autre: "أخرى",
        },
        form: {
          category_group_enum: "الفئات (enum في PostgreSQL)",
          category_group_legacy: "فئات قديمة (نص)",
          method_code: "الرمز المهني (enum)",
          method_code_hint:
            "رموز الإدارة: virement_bancaire، virement_postal، mandat_postal، mandat_bancaire. لدى العميل تبقى قيم الطلب/الإيداع virement / postal.",
          optgroup_order_product: "الطلب والكتالوج — تحويلات بنكية وبريدية",
          optgroup_deposit_extra: "إيداعات — أمر بريدي، أمر بنكي، P2P",
          scope_order: "استخدامه لدفع الطلبات",
          scope_deposit: "استخدامه لإيداعات / شحن الرصيد",
          scope_product: "مرجع لطرق المنتج المسموحة (عرض / قواعد)",
          sort_order: "ترتيب العرض",
          instructions: "تعليمات (اختياري)",
          instructions_placeholder: "نص اختياري يظهر للعميل لهذا الصف.",
          enabled: "نشط",
          error_method_code: "رمز مهني غير صالح.",
          error_scope: "اختر نطاقًا واحدًا على الأقل: طلب أو إيداع أو كتالوج.",
          error_identifier_portefeuille:
            "للمحفظة الجوالة، رقم الهاتف إلزامي.",
          error_identifier_phone:
            "أدخل رقم جوال تونسي صالح (8 أرقام، البادئات 2 أو 3 أو 4 أو 5 أو 9 بعد +216).",
          error_identifier_rib_required: "الريب إلزامي للتحويل البنكي.",
          error_identifier_rib_format: "يجب أن يتكوّن الريب من 20 رقماً بالضبط.",
          error_identifier_ccp_required: "رقم الحساب البريدي / CCP إلزامي للتحويل البريدي.",
          error_identifier_ccp_format: "يجب أن يتراوح طول الـ CCP بين 10 و 16 رقماً.",
          identifier_label_portefeuille: "رقم الهاتف (جوال تونسي) — إلزامي",
          identifier_label_virement: "RIB (20 رقماً) — إلزامي",
          identifier_label_virement_postal: "CCP / حساب بريدي — إلزامي",
          identifier_label_mandat: "بطاقة تعريف أو مرجع (اختياري)",
          identifier_label_optional: "معرف (اختياري)",
          error_provider: "اسم الحساب / المزود مطلوب."
        }
      },
      categories: {
        title: "إدارة الفئات",
        add: "إضافة فئة",
        new_category: "فئة جديدة",
        name: "الاسم",
        desc: "الوصف",
        cover_image: "صورة الغلاف",
        subcategories_list: "الفئات الفرعية:",
        new_subcategory: "فئة فرعية جديدة",
        add_sub: "إضافة فئة فرعية"
      },
      products: {
        title: "إدارة المنتجات",
        add: "إضافة",
        edit: "تعديل",
        form: {
          title_new: "منتج جديد",
          title_edit: "تعديل المنتج",
          name: "اسم المنتج",
          category: "الفئة",
          price: "السعر الأساسي (دت)",
          subcategory: "الفئة الفرعية",
          description: "الوصف",
          description_placeholder: "وصف تفصيلي للمنتج...",
          status_label: "الحالة",
          status: {
            on_sale: "معروض للبيع",
            incoming: "قيد الوصول",
            sold_out: "نفدت الكمية"
          },
          value: "القيمة",
          value_placeholder: "مثال: 1 جيجا، 5 د.ت...",
          min_quantity: "الكمية الدنيا",
          delivery_method: "طريقة التسليم",
          sale_type: "نوع البيع",
          payment_methods: "طرق الدفع",
          validated: "منتج معتمد",
          best_seller: "الأكثر مبيعاً",
          duplicate_suffix: "(نسخة)",
          show_preview: "معاينة المنتج",
          hide_preview: "إخفاء المعاينة",
          desc: "الوصف",
          delivery_mode: "طريقة التسليم",
          best_seller_old: "🔥 الأكثر مبيعاً",
          active_product: "منتج نشط",
          save: "حفظ",
          images: {
            logo: "1. الشعار / العلامة التجارية",
            main: "2. الصورة الرئيسية",
            gallery: "3. صور أخرى (معرض)"
          },
          preferences: {
            title: "خيارات التسعير",
            add_group: "+ مجموعة خيارات",
            group_placeholder: "مثال: نوع التغليف",
            option_placeholder: "مثال: صلب",
            required: "مطلوب",
            features_label: "الخدمات المدرجة (سطر واحد لكل خدمة)",
            features_placeholder: "أدخل الوظائف...",
            add_value: "+ قيمة جديدة",
            conditions: {
              if: "إذا",
              group_select: "مجموعة...",
              value_select: "القيمة...",
              then_price: "= إذن الزيادة",
              features_label: "الخدمات المدرجة (في حالة الشرط)",
              features_placeholder: "وظائف محددة...",
              add: "+ شرط تسعير"
            }
          },
          delivery_methods: {
            code_instantane: "رمز فوري",
            mail_compte_code: "بريد حساب رمز",
            mail_code: "بريد رمز",
            mail_acces: "بريد وصول",
            mail_licence: "بريد ترخيص",
            traitement_lien: "معالجة رابط",
            livraison_domicile: "تسليم إلى المنزل"
          },
          sale_types: {
            detail: "التفصيل",
            gros: "الجملة"
          },
          payment_methods_labels: {
            solde: "الرصيد",
            livraison: "التسليم",
            carte: "البطاقة",
            mandat: "حوالة بريدية",
            p2p: "بين المستخدمين",
            solde_interne: "الرصيد الداخلي",
            portefeuille: "محفظة جوال",
            virement: "تحويل بنكي",
            flouci: "فلوسي",
            d17: "د17",
            izi_pay: "IZI Pay",
            carte_bancaire: "بطاقة بنكية"
          },
          preview: {
            title: "المعاينة",
            preferences: "التخصيص",
            product_name_placeholder: "اسم المنتج",
            value_label: "القيمة",
            select_placeholder: "اختر...",
            input_placeholder: "أدخل {{field}}",
            amount_placeholder: "المبلغ",
            estimated_total: "السعر الإجمالي المقدر",
            file_placeholder: "ملف للرفع"
          },
          validation: {
            name_required: "اسم المنتج مطلوب",
            price_required: "يجب أن يكون السعر أكبر من 0",
            subcategory_required: "الفئة الفرعية مطلوبة",
            min_quantity_invalid: "يجب أن تكون الكمية الدنيا على الأقل 1",
            preference_label_required: "تسمية التفضيل {{index}} مطلوبة",
            preference_options_required: "التفضيل \\",
            option_name_required: "اسم الخيار {{optionIndex}} من \\"
          },
          submit: {
            processing: "جاري المعالجة...",
            update: "تحديث",
            create: "حفظ المنتج"
          }
        },
        main_image_section: {
          no_image: "لا توجد صورة",
          upload_pc: "رفع من الكمبيوتر",
          choose_library: "اختر من المكتبة",
          format: "التنسيق: JPG، PNG أو SVG. الحد الأقصى 2 ميجابايت."
        },
        gallery: {
          add: "+ إضافة صور",
          empty: "لا توجد صور في المعرض.",
          new_label: "جديد",
          view: "عرض"
        },
        filter_title: "تصفية المنتجات",
        filters: {
          search_label: "بحث",
          search_placeholder: "اسم المنتج...",
          category_label: "الفئة",
          subcategory_label: "الفئة الفرعية",
          all: "الكل"
        },
        list: {
          empty: "لم يتم العثور على منتجات",
          base_price_suffix: "(الأساسي)",
          duplicate: "تكرار",
          edit: "تعديل",
          delete: "حذف"
        },
        messages: {
          confirm_delete: "حذف هذا المنتج؟",
          required_error: "حقول مطلوبة مفقودة."
        },
        main_image: "الصورة الرئيسية",
        validation: {
          name_required: "اسم المنتج مطلوب",
          price_required: "يجب أن يكون السعر أكبر من 0",
          subcategory_required: "الفئة الفرعية مطلوبة",
          min_quantity_invalid: "يجب أن تكون الكمية الدنيا على الأقل 1",
          preference_label_required: "تسمية التفضيل {{index}} مطلوبة",
          preference_options_required: "La تفضيل \\",
          option_name_required: "Le اسم de l"
        }
      },
      media: {
        title: "مكتبة الوسائط",
        sync: "مزامنة",
        upload: "رفع",
        search: "بحث عن صورة...",
        filename: "اسم الملف",
        type: "Type",
        size: "الحجم",
        added_on: "تاريخ الإضافة",
        delete_confirm: "حذف نهائي؟",
        details: "التفاصيل",
        usage: "الاستخدام",
        bucket: "الحاوية",
        all_buckets: "جميع الحاويات"
      },
      tickets: {
        title: "إدارة الدعم",
        status_tabs: {
          open: "مفتوحة",
          in_progress: "قيد المعالجة",
          closed: "مغلقة",
          all: "الكل"
        },
        filters: {
          all_types: "جميع الأنواع",
          all_priorities: "جميع الأولويات"
        },
        table: {
          id: "المعرف",
          client: "العميل",
          subject: "الموضوع",
          type: "النوع",
          priority: "الأولوية",
          status: "الحالة",
          last_update: "تحديث"
        },
        no_results: "لم يتم العثور على تذاكر.",
        ticket_prefix: "تذكرة #",
        status_label: "الحالة:",
        load_error: "خطأ في التحميل.",
        loading: "جاري التحميل...",
        not_found: "لم يتم العثور على التذكرة.",
        reply_placeholder: "رد المسؤول...",
        sending: "جاري الإرسال...",
        send_reply: "إرسال الرد",
        back_to_list: "← العودة للقائمة",
        client_info: "بيانات العميل",
        view_profile: "عرض الملف",
        guest_title: "زائر (غير مسجل)",
        name_label: "الاسم:",
        email_label: "البريد:",
        source_label: "المصدر:",
        created_label: "تاريخ الإنشاء:",
        configuration: "الإعدادات",
        priority_label: "الأولوية",
        type_label: "النوع",
        support_name: "دعم ء خدمات",
        guest_name: "زائر",
        conversations: {
          no_conversations: "لا توجد محادثات",
          no_conversations_desc: "هذا العميل لا",
          no_conversations_filter: "لا توجد محادثات بهذه الحالة",
          create_new: "محادثة جديدة",
          you: "أنت",
          created: "تم الإنشاء",
          create_desc: "ميزة قيد التنفيذ - إنشاء تذكرة من إدارة الهاتف المحمول"
        },
        messages: {
          attachment: "مرفق",
          no_messages: "لا توجد رسائل في هذه المحادثة",
          reply_placeholder: "إجابة...",
          change_status: "تغيير الحالة"
        },
        clients: {
          title: "العملاء مع التذاكر",
          search_placeholder: "الاسم، القيمة...",
          no_clients: "لم يتم العثور على عميل",
          no_results_search: "لا توجد نتائج لبحثك.",
          no_results: "لم يتم العثور على تذكرة.",
          active: "نشط(ة)",
          last_activity: "آخر نشاط",
          total_tickets: "تذكرة(ات)",
          closed: "مغلق(ة)"
        }
      },
      deposits: {
        title: "إدارة الإيداعات",
        pending: "قيد الانتظار",
        all: "الكل",
        allMethods: "كل الطرق",
        filterByMethod: "تصفية حسب الطريقة",
        client: "العميل",
        amount: "المبلغ",
        method: "الطريقة",
        date: "التاريخ",
        confirm_refuse: "هل أنت متأكد من رفض الإيداع؟",
        confirm_validate: "تأكيد التحقق من إيداع بقيمة",
        proof: "عرض الإثبات",
        validate: "تأكيد",
        refuse: "رفض",
        proof_viewer: "إثبات الدفع",
        code_viewer: "رمز المعاملة",
        transactionRef: "مرجع المعاملة",
        mandatType: "نوع الحوالة",
        clientName: "اسم العميل",
      },
      stock: {
        title: "إدارة المخزون",
        sync_btn: "مزامنة الحالات",
        digital_tab: "مخزون رقمي",
        physical_tab: "مخزون مادي",
        import_title: "استيراد أكواد",
        import_desc: "استيراد عبر CSV (كود;سلسلة)",
        product: "المنتج",
        choose: "اختر...",
        file_csv: "ملف CSV",
        import_btn: "استيراد",
        state_title: "حالة المخزون الرقمي",
        available: "متاح",
        sold: "مباع",
        status_base: "الحالة (الأساسية)",
        inventory_title: "المخزون المادي / المعالجة",
        history: "History",
        adjust: "تعديل",
        movement_type: "نوع الحركة",
        reason: "السبب",
        sync_statuses: "مزامنة الحالات",
        digital_stock: "المخزون الرقمي",
        physical_stock: "المخزون المادي",
        import_codes: "استيراد",
        digital_stock_status: "حالة المخزون",
        product_header: "المنتج",
        available_header: "متاح",
        sold_header: "مباع",
        status_base_header: "الحالة",
        import: "استيراد",
        no_instant_product: "لا يوجد منتج كود فوري",
        import_instant_only: "الاستيراد مخصص لمنتجات « الكود الفوري » فقط.",
        instant_codes: "كود فوري",
        manual_digital: "إدارة يدوية (كود مؤجل)",
        set_sold_out: "تعيين نفد",
        set_on_sale: "تعيين معروض"
      },
      users: {
        title: "إدارة العملاء",
        add: "إضافة عميل",
        search: "بحث...",
        filter_status: "تصفية الحالة",
        all: "الكل",
        details: "التفاصيل",
        suspended_btn: "تعليق",
        active_btn: "تنشيط",
        activity: "النشاط",
        registered: "تاريخ التسجيل",
        detail: {
          save_success: "تم الحفظ بنجاح.",
          status_success: "تم التحديث بنجاح.",
          confirm_reset: "إرسال رابط استعادة إلى {{email}}؟",
          reset_sent: "تم الإرسال بنجاح.",
          delete_title: "حذف العميل {{name}}؟",
          checking_deps: "جاري التحقق...",
          deps_warning: "تحذير: هذا العميل يملك:",
          tabs: {
            orders: "طلبات",
            deposits: "إيداعات",
            tickets: "تذاكر"
          },
          reviews: "تقييمات",
          deps_loss: "الحذف سيؤدي لمحو كل السجل المرتبط.",
          no_deps: "لا توجد بيانات مرتبطة. الحذف آمن.",
          force_delete: "حذف الكل (إجباري)",
          deleting: "جاري الحذف...",
          balance_modal: {
            title: "إدارة الرصيد",
            current: "الرصيد الحالي:",
            operation: "العملية",
            add: "إضافة",
            subtract: "خصم",
            set: "تعيين",
            new_balance: "الرصيد الجديد",
            amount: "المبلغ",
            success: "تم تحديث الرصيد: {{amount}}"
          },
          loading: "جاري التحميل...",
          not_found: "لم يتم العثور على العميل.",
          edit_profile: "تعديل الملف",
          personal_info: "البيانات الشخصية",
          account_management: "إدارة الحساب",
          account_status: "حالة الحساب",
          manage_balance: "إدارة الرصيد",
          reset_password: "استعادة كلمة المرور",
          delete_client: "حذف العميل"
        }
      },
      settings: {
        title: "الإعدادات العامة",
        app_prefs: "تفضيلات التطبيق",
        interface_theme: "المظهر",
        sticky_bar: "شريط تصفية ثابت",
        language: "اللغة"
      },
      deliverySettings: {
        title: "إعدادات التوصيل",
        baseFeeLabel: "رسوم التوصيل الأساسية",
        baseFeeHint: "المبلغ الافتراضي للتوصيل إلى المنزل. ينطبق على جميع المناطق ما لم يتم تجاوزه.",
        stampFeeLabel: "الطابع الجبائي",
        stampFeeHint: "الطابع الجبائي بقيمة 0.100 د.ت يطبق لكل طلب يحتوي على توصيل منزلي.",
        saveBtn: "حفظ",
        saving: "جاري الحفظ...",
        saved: "تم حفظ الإعدادات بنجاح.",
        error: "خطأ في حفظ الإعدادات."
      },
      orders: {
        title: "إدارة الطلبات",
        duplicate: "تكرار",
        delete: "حذف",
        details: "التفاصيل",
        confirm_delete: "حذف الطلب؟",
        confirm_delete_bulk: "حذف {{count}} طلب(ات)؟ هذا الإجراء لا رجعة فيه.",
        confirm_duplicate: "تكرار الطلب؟",
        client: "العميل",
        total: "الإجمالي",
        payment: "الدفع",
        status: "الحالة",
        ref_trans: "مرجع المعاملة",
        transactionRef: "مرجع المعاملة",
        clientName: "اسم العميل",
        mandatNumber: "رقم الحوالة",
        proof: "إثبات الدفع",
        openProof: "فتح الإثبات",
        paymentDetail: "تفاصيل الدفع",
        generate_invoice: "فاتورة",
        generate_bl: "إذن تسليم",
        view_invoice: "عرض الفاتورة",
        ref: "المرجع",
        deleted_one: "تم حذف الطلب.",
        deleted_bulk: "تم حذف {{count}} طلب(ات).",
        select_all: "تحديد الكل",
        clear_selection: "إلغاء التحديد",
        delete_selection: "حذف المحدد",
        selected_one: "طلب محدد",
        selected_bulk: "طلبات محددة"
      }
    },
    delivery: {
      instructions: {
        code_instantane: "يظهر الكود فوراً في حسابك.",
        mail_compte_code: "يتم إرسال الحساب والكود عبر البريد.",
        mail_code: "يتم إرسال الكود عبر البريد.",
        mail_acces: "بيانات الدخول ترسل عبر البريد.",
        mail_licence: "الترخيص يرسل عبر البريد.",
        traitement_lien: "تتم المعالجة عن بعد بعد تأكيد الطلب.",
        livraison_domicile: "توصيل مادي لعنوانك.",
        default: "طريقة تسليم قياسية."
      },
      methods: {
        code_instantane: "كود فوري",
        mail_compte_code: "حساب (بريد)",
        mail_code: "كود (بريد)",
        mail_acces: "دخول (بريد)",
        mail_licence: "ترخيص (بريد)",
        traitement_lien: "خدمة / معالجة",
        livraison_domicile: "توصيل مادي"
      }
    },
    payment: {
      methods: {
        solde_interne: "الرصيد الداخلي",
        carte_bancaire: "بطاقة بنكية",
        flouci: "فلوسي",
        d17: "D17",
        izi_pay: "IZI Pay",
        virement: "تحويل بنكي"
      }
    },
    payment_methods: {
      solde: "الدفع بالرصيد",
      mandat: "حوالة بريدية",
      carte: "الدفع بالبطاقة",
      solde_interne: "الرصيد الداخلي",
      livraison: "الدفع عند التسليم",
      portefeuille: "محفظة جوال",
      p2p: "تحويل إلى معرف (إيداع)",
      postal: "أمر بريدي",
      mandat_postal: "أمر بريدي (رمز إداري)",
      mandat_bancaire: "أمر بنكي (مثل MoneyGram)",
      carte_bancaire: "بطاقة بنكية",
      flouci: "فلوسي",
      d17: "D17",
      izi_pay: "IZI Pay",
      virement: "تحويل بنكي",
      virement_bancaire: "تحويل بنكي (رمز إداري)",
      virement_postal: "تحويل بريدي (حساب بريدي / CCP)"
    },
    delivery_instructions: {
      code_instantane: "كود فوري",
      mail_compte_code: "حساب + كود (بريد)",
      mail_code: "كود (بريد)",
      mail_acces: "دخول (بريد)",
      mail_licence: "ترخيص (بريد)",
      traitement_lien: "معالجة عن بعد",
      livraison_domicile: "توصيل للمنزل"
    },
    ticket_types: {
      SUPPORT: "دعم",
      COMMANDE: "طلب",
      CONTACT: "اتصال"
    },
    product_names: {
    },
    categories: {
      Recharge: "شحن رصيد",
      "Recharge Mobile": "شحن رصيد الهاتف",
      "Documents personnalisés": "مستندات مخصصة",
      "Paiement International": "الدفع الدولي",
      Jeux: "ألعاب فيديو",
      Streaming: "بث وتلفزيون",
      Logiciels: "برامج و VPN",
      Paiement: "بطاقات دفع",
      Divers: "متنوعات",
      Abonnements: "اشتراكات"
    },
    categories_desc: {
      Abonnements: "خدمات البث، الألعاب وأكثر."
    },
    subcategories: {
      Ooredoo: "أوريدو",
      Orange: "أورنج",
      Streaming: "بث مباشر",
      Gaming: "ألعاب",
      "Conception graphisque": "تصميم جرافيك",
      "Tunisie Télécom": "اتصالات تونس",
      "Paiement Internationale": "دفع دولي",
      "Paiement Nationale": "دفع محلي",
      "Applications & Logiciels": "تطبيقات وبرامج",
      "Documents éducatifs": "مستندات تعليمية",
      "Certificats & Attestations": "شهادات وإثباتات",
      "Documents administratifs": "مستندات إدارية",
      "Paiement en ligne": "دفع عبر الإنترنت",
      "Cours en ligne": "دورات عبر الإنترنت",
      "Outils de productivité": "أدوات الإنتاجية"
    },
    footer: {
      brand_desc: "شريكك الموثوق لجميع خدماتك الرقمية. إعادة شحن الهاتف المحمول، الاشتراكات، والمزيد.",
      rating: {
        excellent: "ممتاز",
        based_on: "بناءً على"
      },
      sections: {
        navigation: "التنقل",
        legal: "قانوني",
        newsletter: "النشرة الإخبارية"
      },
      links: {
        faq: "الأسئلة الشائعة",
        terms: "الشروط والأحكام",
        privacy: "سياسة الخصوصية",
        refund: "سياسة الاسترجاع",
        delivery: "سياسة التوصيل",
        legal_notice: "الإشعارات القانونية",
        cookies: "سياسة الكوكيز",
        terms_desc: "اطلع على شروطنا",
        privacy_desc: "اكتشف كيف نحمي بياناتك الشخصية وحقوقك في الخصوصية",
        refund_desc: "معلومات مفصلة حول شروط الاسترداد والضمانات وإجراءات الإرجاع",
        delivery_desc: "أوقات التسليم، الرسوم، مناطق التسليم وتتبع الطلب",
        legal_notice_desc: "معلومات قانونية وتنظيمية حول",
        cookies_desc: "معلومات حول",
        rate_limiting: "حدود الاستخدام والأمان",
        rate_limiting_desc: "سياسات حدود الطلبات (OTP، التسجيل) والحظر المؤقت.",
        faq_desc: "أسئلة متكررة وإجابات حول خدماتنا"
      },
      newsletter: {
        desc: "ابق على اطلاع بآخر أخبارنا",
        placeholder: "بريدك الإلكتروني",
        btn: {
          subscribe: "اشتراك",
          loading: "جاري الإرسال...",
          success: "تم الاشتراك!"
        },
        error: "حدث خطأ",
        disclaimer: "نحن نحترم خصوصيتك. يمكنك إلغاء الاشتراك في أي وقت."
      },
      download_app: {
        title: "تحميل التطبيق",
        cta: "احصل عليه من Google Play",
        apple: "تحميل من App Store"
      },
      copyright: "جميع الحقوق محفوظة",
      legal: {
        view_all: "اطلع على جميع وثائقنا السياسية"
      }
    },
    about: {
      title: "من نحن",
      subtitle: "شريكك الموثوق لحياة رقمية مبسطة في تونس.",
      mission_title: "مهمتنا",
      mission_desc: "في ء حدمات، مهمتنا هي تبسيط الحياة الرقمية للمستخدمين التونسيين. لقد أنشأنا منصة مركزية وبديهية لتوفير وصول فوري إلى مجموعة واسعة من الخدمات الأساسية، من إعادة شحن الهاتف إلى الاشتراكات الرقمية، مروراً بإنشاء المستندات المخصصة. نحن ملتزمون بجعل كل تفاعل سلساً وممتعاً قدر الإمكان.",
      values_title: "قيمنا",
      values: {
        reliability: {
          title: "الموثوقية",
          desc: "نضمن معاملات آمنة وخدمات يتم تسليمها في الوقت المحدد، في كل مرة."
        },
        speed: {
          title: "السرعة",
          desc: "منصتنا محسّنة لتقديم تجربة فائقة السرعة، من الطلب إلى التسليم."
        },
        accessibility: {
          title: "إمكانية الوصول",
          desc: "نصمم خدماتنا لتكون بسيطة ومتاحة للجميع، أينما كنت في تونس."
        },
        innovation: {
          title: "الابتكار",
          desc: "نسعى باستمرار لتحسين وتوسيع عرضنا للاستجابة لاحتياجات عملائنا المتغيرة."
        }
      },
      quote: "في  ء خدمات، نضع رضا عملائنا في قلب كل ما نقوم به."
    },
    AboutPage: {
      header: {
        logo: "ء خدمات"
      },
      team: {
        imageAlt: "فريقنا"
      },
      mission: {
        quote: "الابتكار لجعل الرقمي في متناول كل تونسي."
      }
    },
    MobileAboutPage: {
      header: {
        logo: "ء خدمات"
      },
      team: {
        imageAlt: "فريقنا"
      },
      mission: {
        quote: "الابتكار لجعل الرقمي في متناول كل تونسي."
      }
    },
    MobileSecurity: {
      header: {
        title: "الأمان"
      },
      password: {
        changeTitle: "تغيير كلمة المرور",
        changeDesc: "حدّث كلمة المرور بانتظام",
        cancel: "إلغاء",
        edit: "تعديل",
        currentPassword: "كلمة المرور الحالية",
        newPassword: "كلمة المرور الجديدة",
        confirmPassword: "تأكيد كلمة المرور",
        placeholder: "••••••••",
        hide: "إخفاء",
        show: "إظهار",
        minChars: "6 أحرف على الأقل",
        forgotPassword: "نسيت كلمة المرور؟",
        updateButton: "تحديث كلمة المرور",
        changingInProgress: "جاري التحديث...",
        errorAllRequired: "جميع الحقول مطلوبة",
        errorMinLength: "يجب أن تحتوي كلمة المرور الجديدة على 6 أحرف على الأقل",
        errorMismatch: "كلمتا المرور غير متطابقتين",
        errorSameAsOld: "يجب أن تكون كلمة المرور الجديدة مختلفة عن الحالية",
        errorCurrentIncorrect: "كلمة المرور الحالية غير صحيحة",
        errorUpdate: "خطأ أثناء تغيير كلمة المرور",
        successUpdated: "تم تحديث كلمة المرور بنجاح"
      },
      tips: {
        title: "نصائح أمنية",
        item1: "استخدم كلمة مرور قوية وفريدة",
        item2: "غيّر كلمة المرور بانتظام",
        item3: "لا تشارك كلمة المرور أبداً"
      },
      twoFa: {
        title: "المصادقة الثنائية",
        disabledDesc: "حماية إضافية لحسابك",
        enableButton: "تفعيل المصادقة الثنائية",
        enabledLabel: "الحماية مفعّلة",
        enabledOn: "تم التفعيل في",
        enabledBadge: "مفعّل",
        enabledMessage: "حسابك محمي بالمصادقة الثنائية. ستُطلب منك إدخال رمز التحقق عند كل تسجيل دخول.",
        actionsLabel: "إجراءات",
        regenerateCodes: "إعادة إنشاء رموز الاسترداد",
        regenerateCodesDesc: "إنشاء رموز احتياطية جديدة",
        disableButton: "إلغاء تفعيل المصادقة الثنائية",
        disableButtonDesc: "إزالة الحماية الإضافية",
        setup: {
          title: "إعداد Google Authenticator",
          step1Title: "الخطوة 1: الإضافة إلى Google Authenticator",
          step1_1: "افتح Google Authenticator على هاتفك",
          step1_2: "اضغط \"+\" لإضافة حساب",
          step1_3: "اختر \"إدخال مفتاح الإعداد\"",
          step2Title: "الخطوة 2: إدخال المفتاح السري",
          secretWarning: "مهم: أدخل المفتاح بدون شرطات أو مسافات أو فواصل",
          secretNote: "النوع: زمني | الخوارزمية: SHA1",
          step3Title: "الخطوة 3: التحقق من الرمز",
          codePlaceholder: "000000"
        },
        verify: "التحقق والتفعيل",
        recoveryCodes: {
          title: "رموز الاسترداد",
          warning: "مهم: احفظ هذه الرموز في مكان آمن. لن تُعرض مرة أخرى.",
          saved: "لقد حفظت الرموز"
        },
        disable: {
          title: "إلغاء تفعيل المصادقة الثنائية",
          warning: "لأسباب أمنية، يرجى تأكيد كلمة المرور لإلغاء تفعيل المصادقة الثنائية.",
          success: "تم إلغاء تفعيل المصادقة الثنائية بنجاح",
          inProgress: "جاري الإلغاء...",
          confirm: "إلغاء التفعيل"
        },
        errorGenerate: "خطأ عند إنشاء المفتاح السري",
        errorCode6Digits: "يرجى إدخال رمز من 6 أرقام",
        errorCodeIncorrect: "الرمز غير صحيح. يرجى المحاولة مرة أخرى.",
        errorVerify: "خطأ أثناء التحقق من الرمز",
        errorPasswordRequired: "يرجى إدخال كلمة المرور",
        errorDisable: "خطأ عند إلغاء التفعيل",
        errorRegenerate: "خطأ عند إعادة إنشاء الرموز"
      }
    },
    MobileFavorites: {
      header: {
        title: "المفضلة",
        subtitle: "استرجع المنتجات التي أعجبتك."
      },
      state: {
        loading: "جاري التحميل..."
      },
      empty: {
        title: "لا مفضلات",
        description: "تصفح الكتالوج وأضف منتجات إلى مفضلتك."
      }
    },
    MobileManageDeposits: {
      header: {
        title: "إدارة الإيداعات"
      },
      confirm: {
        refuse: "هل أنت متأكد من رفض هذا الإيداع؟",
        validate: "التحقق من هذا الإيداع بقيمة {{amount}}؟"
      },
      filters: {
        pending: "قيد الانتظار",
        validated: "مُتحقق منها",
        refused: "مرفوضة",
        all: "الكل"
      },
      card: {
        amount: "المبلغ",
        method: "الطريقة",
        proofLabel: "إثبات الدفع",
        viewImage: "عرض الصورة",
        viewCode: "عرض الرمز",
        proofAlt: "إثبات الإيداع",
        imageUnavailable: "الصورة غير متوفرة",
        clickToViewCode: "انقر لعرض الرمز الكامل"
      },
      actions: {
        validate: "تحقق",
        refuse: "رفض"
      },
      empty: {
        title: "لا إيداعات",
        pending: "لا إيداعات قيد التحقق.",
        noMatch: "لم يتم العثور على إيداعات لهذا الفلتر."
      },
      modal: {
        proofTitle: "إثبات الدفع",
        codeTitle: "رمز المعاملة",
        openFullScreen: "فتح بملء الشاشة",
        copied: "تم النسخ",
        copy: "نسخ",
        close: "إغلاق"
      },
      error: "خطأ"
    },
    Wallet: {
      card: {
        revenue: "حجم المبيعات",
        myBalance: "رصيدي",
        recharge: "الشحن"
      },
      stats: {
        depositsThisMonth: "الإيداعات هذا الشهر",
        spendingThisMonth: "المصروفات هذا الشهر"
      },
      section: {
        depositManagement: "إدارة الإيداعات",
        transactionHistory: "سجل المعاملات",
        pendingCount: "{{count}} قيد الانتظار"
      },
      list: {
        rechargeVia: "إعادة شحن عبر {{method}}"
      },
      empty: {
        noDeposits: "لم يتم العثور على إيداعات"
      },
      modal: {
        stepAmount: "مبلغ الإيداع",
        stepMethod: "طريقة الدفع",
        stepInstructions: "إتمام الإيداع",
        customAmount: "مبلغ مخصص",
        placeholderAmount: "0.000",
        continue: "متابعة",
        chooseMethod: "اختر طريقة",
        submitting: "جاري المعالجة...",
        submitDeposit: "إرسال الإيداع"
      },
      instructions: {
        title: "تعليمات الدفع",
        portefeuilleIntro: "افتح التطبيق الذي يحدده البائع وأرسل {{amount}} د.ت إلى المعرف أدناه.",
        flouciStep1: "افتح تطبيق Flouci وأرسل {{amount}} د.ت",
        d17Step1: "افتح تطبيق D17 وأرسل المبلغ",
        iziStep1: "افتح تطبيق IZI Pay وأرسل {{amount}} د.ت",
        transactionIdLabel: "2. أدخل معرف المعاملة",
        transactionIdPlaceholder: "معرف المعاملة",
        bankTransferTitle: "تحويل بنكي",
        bankTransferStep1: "1. قم بتحويل {{amount}} د.ت إلى أحد الحسابات أدناه:",
        rib: "الريب:",
        iban: "الأيبان:",
        accountHolder: "صاحب الحساب:",
        proofLabel: "2. إثبات الدفع (رفع ملف الإثبات)"
      },
      success: {
        depositSubmitted: "تم إرسال الإيداع بنجاح!"
      },
      error: {
        submitError: "خطأ أثناء الإرسال. يرجى المحاولة مرة أخرى."
      },
      methods: {
        portefeuille: "محفظة جوال",
        flouci: "Flouci",
        d17: "D17",
        izi_pay: "IZI Pay",
        virement: "تحويل بنكي"
      }
    },
    hardcoded: {
      notre_quipe: "فريقنا",
      profil_administrateur: "ملف المدير",
      avatar: "الصورة الرمزية",
      chargement_du_profil_: "جاري تحميل الملف الشخصي...",
      pr_nom: "الاسم الأول",
      email: "البريد الإلكتروني",
      t_l_phone: "الهاتف",
      adresse: "العنوان",
      preuve: "الإثبات",
      scanner_le_stockage: "فحص التخزين",
      sync_: "مزامنة؟",
      invit_: "ضيف",
      nom: "الاسم",
      mot_de_passe: "كلمة المرور",
      activit_: "النشاط",
      actions: "الإجراءات",
      chargement_: "جاري التحميل...",
      aucun_client_trouv_: "لم يتم العثور على عميل.",
      analyse_des_: "جاري تحليل البيانات...",
      forcer_la_suppression_effacera_d_finitivement_tout: "إجبار الحذف سيمحو بشكل نهائي كل السجل المرتبط.",
      aucune_donn_e_li_e_trouv_e_la_suppression_est_sans: "لم يتم العثور على بيانات مرتبطة. الحذف آمن.",
      nouveau_client: "عميل جديد",
      annuler: "إلغاء",
      cr_er_le_compte: "إنشاء الحساب",
      logo_light: "الشعار الفاتح",
      logo_dark: "الشعار الداكن",
      logo_mode_clair_: "الشعار (الوضع الفاتح)",
      ce_logo_s_affichera_sur_les_fonds_clairs_ex_th_me_: "سيظهر هذا الشعار على الخلفيات الفاتحة (مثال: المظهر الفاتح).",
      logo_mode_sombre_: "الشعار (الوضع الداكن)",
      ce_logo_s_affichera_sur_les_fonds_sombres_ex_th_me: "سيظهر هذا الشعار على الخلفيات الداكنة (مثال: المظهر الداكن).",
      utiliser_le_th_me_sombre: "استخدام المظهر الداكن",
      garder_la_barre_de_recherche_visible_lors_du_d_fil: "إبقاء شريط البحث مرئياً أثناء التمرير (الخدمات).",
      activer_la_barre_fixe: "تفعيل الشريط الثابت",
      choisir_la_langue_de_l_interface_: "اختر لغة الواجهة.",
      fran_ais: "Français",
      english: "English",
      inscription: "التسجيل",
      utilisateur_introuvable_: "المستخدم غير موجود.",
      enregistrer: "حفظ",
      solde: "الرصيد",
      actions_rapides: "إجراءات سريعة",
      supprimer_client: "حذف عميل",
      analyse_de_l_historique_: "جاري تحليل السجل...",
      forcer_la_suppression_effacera_tout_l_historique_d: "إجبار الحذف سيمحو كل السجل بشكل نهائي.",
      aucune_donn_e_li_e_trouv_e_suppression_s_curis_e_: "لم يتم العثور على بيانات مرتبطة. الحذف آمن.",
      g_rer_le_solde: "إدارة الرصيد",
      valider: "التحقق",
      offerts: "عروض",
      ttc_livraison_comprise: "شامل الضريبة / التسليم مشمول",
      paiement_100_s_curis_: "دفع آمن 100%",
      validation_sous_10_30_minutes: "التحقق خلال 10-30 دقيقة",
      images_pdf_max_5mb_: "صور، PDF (حد أقصى 5 ميجابايت)",
      articles_livraison: "العناصر والتسليم",
      codes_assign_s_: "الرموز المخصصة:",
      documents_administratifs: "المستندات الإدارية",
      facture_officielle: "فاتورة رسمية",
      barre_de_filtre_fixe: "شريط التصفية الثابت",
      actualiser_la_liste: "تحديث القائمة",
      livraison_automatique_en_attente: "التسليم التلقائي في الانتظار",
      v_rifier_mes_commandes: "التحقق من طلباتي",
      ouvrir_un_ticket_d_aide: "فتح تذكرة مساعدة",
      passer_une_commande: "تقديم طلب",
      cat_gories: "الفئات",
      votre_commande: "طلبك",
      votre_panier_est_vide_: "سلة التسوق فارغة.",
      s_lectionnez_une_cat_gorie_pour_commencer_: "اختر فئة للبدء.",
      total: "الإجمالي",
      mode_de_paiement: "طريقة الدفع",
      note_: "ملاحظة:",
      choisir_une_m_thode_: "اختر طريقة...",
      veuillez_uploader_une_capture_d_cran_ou_un_re_u_po: "يرجى رفع لقطة شاشة أو إيصال للتحقق من المعاملة.",
      mon_profil: "ملفي الشخصي",
      informations_personnelles: "المعلومات الشخصية",
      changer: "تغيير",
      votre_nom: "اسمك",
      probl_me_commande: "مشكلة الطلب",
      email_de_contact_optionnel_: "البريد الإلكتروني للاتصال (اختياري)",
      nom_de_contact_optionnel_: "اسم الاتصال (اختياري)",
      ticket_non_trouv_: "التذكرة غير موجودة.",
      lien_de_r_cup_ration_s_curis_: "رابط الاسترداد الآمن",
      email_envoy_instantan_ment: "تم إرسال البريد الإلكتروني فوراً",
      envoi_en_cours_: "جاري الإرسال...",
      envoyer_le_lien_de_r_cup_ration: "إرسال رابط الاسترداد",
      chrome_: "Chrome :",
      firefox_: "Firefox :",
      safari_: "Safari :",
      edge_: "Edge :",
      a_cookie_is_a_small_text_file_stored_on_your_devic: "ملف تعريف الارتباط هو ملف نصي صغير يتم تخزينه على جهازك (كمبيوتر، جهاز لوحي، هاتف ذكي) عند زيارة موقع ويب. تسمح ملفات تعريف الارتباط للموقع بتذكر إجراءاتك وتفضيلاتك على مدى فترة من الزمن.",
      enhance_your_user_experience_and_personalize_the_i: "تحسين تجربة المستخدم وتخصيص الواجهة",
      ensure_the_technical_functioning_of_the_site_login: "ضمان الأداء التقني للموقع (تسجيل الدخول، إدارة السلة، أمان المعاملات)",
      analyze_site_traffic_and_audience_to_optimize_our_: "تحليل حركة المرور والجمهور لتحسين خدماتنا",
      remember_your_preferences_language_dark_mode_displ: "تذكر تفضيلاتك (اللغة، الوضع الداكن، إعدادات العرض)",
      protect_the_platform_against_fraudulent_activities: "حماية المنصة من الأنشطة الاحتيالية",
      tunisian_law_no_2018_20: "القانون التونسي رقم 2018-20",
      essential_cookies_technical_: "ملفات تعريف الارتباط الأساسية (تقنية)",
      indispensable_for_platform_functionality_: "ضرورية لوظائف المنصة:",
      user_authentication_and_session_management: "المصادقة وإدارة الجلسات",
      maintaining_account_and_transaction_security: "الحفاظ على أمان الحساب والمعاملات",
      preserving_items_in_your_cart_between_sessions: "الحفاظ على العناصر في سلة التسوق بين الجلسات",
      remembering_your_privacy_preferences: "تذكر تفضيلات الخصوصية الخاصة بك",
      these_cookies_cannot_be_disabled_via_our_interface: "لا يمكن تعطيل ملفات تعريف الارتباط هذه عبر واجهتنا.",
      analytical_cookies_statistical_: "ملفات تعريف الارتباط التحليلية (إحصائية)",
      we_use_internal_analytics_tools_to_: "نستخدم أدوات التحليل الداخلية لـ:",
      measure_audience_and_site_performance: "قياس الجمهور وأداء الموقع",
      understand_how_users_interact_with_the_platform: "فهم كيفية تفاعل المستخدمين مع المنصة",
      detect_and_resolve_technical_issues: "اكتشاف وحل المشاكل التقنية",
      continuously_improve_user_experience: "تحسين تجربة المستخدم باستمرار",
      these_cookies_are_anonymized_and_do_not_allow_pers: "ملفات تعريف الارتباط هذه مجهولة ولا تسمح بالتعريف الشخصي.",
      preference_cookies: "ملفات تعريف الارتباط للتفضيلات",
      they_remember_your_personal_choices_: "تتذكر خياراتك الشخصية:",
      interface_language_french_arabic_english_: "لغة الواجهة (الفرنسية، العربية، الإنجليزية)",
      display_mode_dark_light_: "وضع العرض (داكن/فاتح)",
      regional_settings: "الإعدادات الإقليمية",
      notification_preferences: "تفضيلات الإشعارات",
      some_services_integrated_into_eservices_may_deposi: "قد تودع بعض الخدمات المدمجة في eServices ملفات تعريف الارتباط الخاصة بها:",
      payment_services_: "خدمات الدفع:",
      analytics_tools_: "أدوات التحليل:",
      transactional_email_services_: "خدمات البريد الإلكتروني للمعاملات:",
      we_carefully_select_our_partners_and_ensure_they_c: "نختار شركاءنا بعناية ونتأكد من امتثالهم لمعايير حماية البيانات. تخضع ملفات تعريف الارتباط هذه لسياسات الخصوصية الخاصة بمصدرها.",
      you_have_control_over_cookie_usage_: "لديك سيطرة على استخدام ملفات تعريف الارتباط:",
      via_our_consent_banner: "عبر لافتة الموافقة الخاصة بنا",
      during_your_first_visit_a_banner_allows_you_to_acc: "خلال زيارتك الأولى، تسمح لك لافتة بقبول أو رفض ملفات تعريف الارتباط غير الأساسية. يمكنك تعديل خياراتك في أي وقت بالنقر على رابط \"إدارة ملفات تعريف الارتباط\" في أسفل الصفحة.",
      via_your_browser_settings: "عبر إعدادات المتصفح الخاصة بك",
      you_can_configure_your_browser_to_: "يمكنك تكوين متصفحك لـ:",
      refuse_all_cookies: "رفض جميع ملفات تعريف الارتباط",
      accept_only_essential_cookies: "قبول ملفات تعريف الارتباط الأساسية فقط",
      be_notified_each_time_a_cookie_is_deposited: "تلقي إشعار في كل مرة يتم فيها إيداع ملف تعريف ارتباط",
      automatically_delete_cookies_upon_closing: "حذف ملفات تعريف الارتباط تلقائياً عند الإغلاق",
      the_procedure_varies_by_browser_: "تختلف الإجراءات حسب المتصفح:",
      consequences_of_refusal: "عواقب الرفض",
      if_you_disable_cookies_: "إذا قمت بتعطيل ملفات تعريف الارتباط:",
      you_will_need_to_log_in_on_each_visit: "ستحتاج إلى تسجيل الدخول في كل زيارة",
      your_cart_will_not_be_saved_between_sessions: "لن يتم حفظ سلة التسوق بين الجلسات",
      your_preferences_language_dark_mode_will_not_be_re: "لن يتم تذكر تفضيلاتك (اللغة، الوضع الداكن)",
      some_features_may_be_limited: "قد تكون بعض الميزات محدودة",
      security_of_certain_transactions_may_be_reduced: "قد يتم تقليل أمان بعض المعاملات",
      cookies_have_varying_lifespans_: "ملفات تعريف الارتباط لها أعمار مختلفة:",
      session_cookies_: "ملفات تعريف الارتباط للجلسة:",
      persistent_cookies_: "ملفات تعريف الارتباط المستمرة:",
      authentication_cookies_: "ملفات تعريف الارتباط للمصادقة:",
      analytical_cookies_: "ملفات تعريف الارتباط التحليلية:",
      privacy_policy: "سياسة الخصوصية",
      data_collected_via_cookies_is_processed_securely: "يتم معالجة البيانات المجمعة عبر ملفات تعريف الارتباط بشكل آمن",
      we_do_not_share_your_browsing_data_for_commercial_: "لا نشارك بيانات التصفح الخاصة بك لأغراض تجارية دون موافقتك",
      analytical_cookies_are_anonymized: "ملفات تعريف الارتباط التحليلية مجهولة",
      we_retain_technical_logs_related_to_cookies_for_a_: "نحتفظ بالسجلات التقنية المتعلقة بملفات تعريف الارتباط لمدة أقصاها سنة واحدة",
      you_have_the_right_to_access_rectify_and_object_to: "لديك الحق في الوصول إلى بياناتك وتصحيحها والاعتراض على معالجتها",
      we_may_update_this_cookie_policy_to_reflect_: "قد نحدث سياسة ملفات تعريف الارتباط هذه لتعكس:",
      technical_evolution_of_the_platform: "التطور التقني للمنصة",
      tunisian_or_international_regulatory_changes: "التغييرات التنظيمية التونسية أو الدولية",
      addition_of_new_features_or_services: "إضافة ميزات أو خدمات جديدة",
      changes_will_be_published_on_this_page_with_the_up: "سيتم نشر التغييرات على هذه الصفحة مع تاريخ التحديث. في حالة التغييرات المهمة، سنخطرك عبر البريد الإلكتروني أو إشعار المنصة.",
      for_any_questions_regarding_our_use_of_cookies_or_: "لأي أسئلة بخصوص استخدامنا لملفات تعريف الارتباط أو لممارسة حقوقك:",
      dpo_email_: "بريد مسؤول حماية البيانات:",
      support_tickets_: "تذاكر الدعم:",
      postal_address_: "العنوان البريدي:",
      national_authority_for_personal_data_protection_in: "السلطة الوطنية لحماية البيانات الشخصية (INPDP)",
      last_updated_: "آخر تحديث:",
      version_: "الإصدار:",
      applicable_to_: "ينطبق على:",
      my_codes: "رموزي",
      reveal: "إظهار",
      article_1_scope: "المادة 1 - النطاق",
      digital_services: "الخدمات الرقمية",
      article_2_digital_services_top_ups_codes_subscript: "المادة 2 - الخدمات الرقمية (إعادة الشحن، الرموز، الاشتراكات)",
      mobile_top_up_: "إعادة شحن الهاتف المحمول:",
      digital_codes_gaming_streaming_licenses_: "الرموز الرقمية (الألعاب، البث، التراخيص):",
      masked_code_: "الرمز المقنع:",
      pdf_export_: "تصدير PDF:",
      article_3_customized_and_physical_products: "المادة 3 - المنتجات المخصصة والمادية",
      processing_: "المعالجة:",
      shipped_: "تم الشحن:",
      delivered_: "تم التسليم:",
      preparation_: "التحضير:",
      transport_: "النقل:",
      article_4_responsibilities: "المادة 4 - المسؤوليات",
      risk_on_physical_products_: "المخاطر على المنتجات المادية:",
      digital_service_not_received_: "الخدمة الرقمية غير المستلمة:",
      customization_files_: "ملفات التخصيص:",
      article_5_delivery_address: "المادة 5 - عنوان التسليم",
      article_6_right_of_withdrawal: "المادة 6 - حق الانسحاب",
      digital_services_provided_immediately_after_the_or: "الخدمات الرقمية المقدمة فوراً بعد الطلب (إعادة الشحن، الرموز المسلمة)",
      goods_made_to_the_customer_s_specifications_or_cle: "البضائع المصنوعة حسب مواصفات العميل أو المخصصة بوضوح",
      perishable_products_or_products_with_a_limited_val: "المنتجات القابلة للتلف أو المنتجات ذات تاريخ صلاحية محدود",
      refund_policy: "سياسة الاسترداد",
      response_time_: "وقت الاستجابة:",
      publishing_company: "شركة النشر",
      company_name_: "اسم الشركة:",
      legal_form_: "الشكل القانوني:",
      share_capital_: "رأس المال:",
      registration_: "التسجيل:",
      vat_number_: "رقم ضريبة القيمة المضافة:",
      headquarters: "المقر الرئيسي",
      address_: "العنوان:",
      location_: "الموقع:",
      management_and_publication: "الإدارة والنشر",
      publication_director_: "مدير النشر:",
      editorial_manager_: "مدير التحرير:",
      data_protection_officer_: "مسؤول حماية البيانات:",
      technical_and_commercial_support: "الدعم التقني والتجاري",
      email_: "البريد الإلكتروني:",
      phone_: "الهاتف:",
      business_hours_: "ساعات العمل:",
      monday_to_friday_9_am_6_pm_tunisian_local_time_: "من الاثنين إلى الجمعة، من 9 صباحاً إلى 6 مساءً (التوقيت المحلي التونسي)",
      recommendation_: "التوصية:",
      legal_and_compliance_services: "الخدمات القانونية والامتثال",
      legal_email_: "البريد الإلكتروني القانوني:",
      data_protection_: "حماية البيانات:",
      dispute_service_: "خدمة النزاعات:",
      main_infrastructure: "البنية التحتية الرئيسية",
      database_and_authentication: "قاعدة البيانات والمصادقة",
      provider_: "المزود:",
      security_: "الأمان:",
      certifications_: "الشهادات:",
      complementary_services: "الخدمات التكميلية",
      transactional_email_: "البريد الإلكتروني للمعاملات:",
      audience_analysis_: "تحليل الجمهور:",
      monitoring_: "المراقبة:",
      cdn_: "CDN:",
      availability_and_maintenance: "التوفر والصيانة",
      guaranteed_uptime_rate: "معدل وقت التشغيل المضمون",
      monitoring_and_technical_support: "المراقبة والدعم التقني",
      certified_tls_1_3_encryption: "تشفير TLS 1.3 معتمد",
      trademarks_and_logos: "العلامات التجارية والشعارات",
      registration_with_innorpi_national_institute_of_st: "التسجيل لدى INNORPI (المعهد الوطني للتقييس والملكية الصناعية)",
      international_protection_via_the_madrid_system: "الحماية الدولية عبر نظام مدريد",
      any_reproduction_without_express_authorization_is_: "أي استنساخ دون ترخيص صريح محظور",
      copyright: "حقوق النشر",
      source_code_and_algorithms: "الكود المصدري والخوارزميات",
      design_and_user_interface: "التصميم وواجهة المستخدم",
      technical_documentation_and_editorial_content: "الوثائق التقنية والمحتوى التحريري",
      database_sui_generis_protection_: "قاعدة البيانات (حماية sui generis)",
      exception_: "الاستثناء:",
      usage_licenses: "تراخيص الاستخدام",
      allowed: "مسموح",
      personal_and_non_commercial_use: "الاستخدام الشخصي وغير التجاري",
      access_via_browser_or_official_application: "الوصول عبر المتصفح أو التطبيق الرسمي",
      creation_of_a_single_account_per_person: "إنشاء حساب واحد لكل شخص",
      prohibited: "محظور",
      reverse_engineering_or_decompilation: "الهندسة العكسية أو إلغاء التجميع",
      unauthorized_commercial_use: "الاستخدام التجاري غير المصرح به",
      creation_of_multiple_accounts: "إنشاء حسابات متعددة",
      mass_data_extraction: "استخراج البيانات بكميات كبيرة",
      domain: "النطاق",
      legal_framework: "الإطار القانوني",
      compliance: "الامتثال",
      reference: "المرجع",
      e_commerce: "التجارة الإلكترونية",
      tunisian_law_no_2000_83: "القانون التونسي رقم 2000-83",
      full: "كامل",
      articles_54_55: "المادتان 54-55",
      data_protection: "حماية البيانات",
      organic_law_no_2018_20: "القانون الأساسي رقم 2018-20",
      inpdp_declaration: "إعلان INPDP",
      file_no_number_: "ملف رقم [الرقم]",
      payment_services: "خدمات الدفع",
      bct_regulation: "تنظيم البنك المركزي التونسي",
      compliant_with_practices: "متوافق مع الممارسات",
      circular_xx_2022: "المنشور XX/2022",
      consumption: "الاستهلاك",
      consumer_protection_code: "مدونة حماية المستهلك",
      respect_of_deadlines: "احترام المواعيد النهائية",
      articles_35_42: "المادتان 35-42",
      taxation: "الضرائب",
      customs_and_tax_code: "مدونة الجمارك والضرائب",
      vat_collected: "ضريبة القيمة المضافة المحصلة",
      vat_no_vat_number_: "رقم ضريبة القيمة المضافة: [الرقم]",
      law_no_94_36: "القانون رقم 94-36",
      partner_licenses: "تراخيص الشركاء",
      innorpi: "INNORPI",
      regulatory_authorities: "السلطات التنظيمية",
      inpdp: "INPDP",
      national_authority_for_the_protection_of_personal_: "السلطة الوطنية لحماية البيانات الشخصية",
      central_bank_of_tunisia: "البنك المركزي التونسي",
      national_institute_of_standardization_and_industri: "المعهد الوطني للتقييس والملكية الصناعية",
      intermediary_role: "الدور الوسيط",
      important_: "مهم:",
      warranty_exclusions: "استثناءات الضمان",
      digital_services_: "الخدمات الرقمية:",
      service_interruptions_: "انقطاعات الخدمة:",
      user_data_: "بيانات المستخدم:",
      fraudulent_use_: "الاستخدام الاحتيالي:",
      liability_cap: "حد المسؤولية",
      order_amount: "مبلغ الطلب",
      cap_for_digital_services: "حد للخدمات الرقمية",
      last_deposit: "آخر إيداع",
      cap_for_processing_errors: "حد لأخطاء المعالجة",
      applicable_law: "القانون المعمول به",
      tunisian_law: "القانون التونسي",
      competent_courts: "المحاكم المختصة",
      amicable_settlement: "التسوية الودية",
      mediation: "الوساطة",
      modification_notification: "إشعار التعديل",
      publication_on_this_page_with_update_date_indicati: "النشر على هذه الصفحة مع مؤشر تاريخ التحديث",
      email_notification_to_active_users: "إشعار بالبريد الإلكتروني للمستخدمين النشطين",
      display_of_an_information_banner_in_the_applicatio: "عرض لافتة معلوماتية في التطبيق",
      effective_date: "تاريخ السريان",
      general_terms: "الشروط العامة",
      tunisian_organic_law_no_2018_20_of_april_25_2018: "القانون الأساسي التونسي رقم 2018-20 المؤرخ في 25 أبريل 2018",
      data_controller_: "مسؤول البيانات:",
      data_protection_officer_dpo_: "مسؤول حماية البيانات (DPO):",
      when_you_use_our_platform_we_may_collect_the_follo: "عند استخدامك لمنصتنا، قد نجمع الفئات التالية من البيانات:",
      identification_data: "بيانات التعريف",
      first_and_last_name: "الاسم الأول والاسم الأخير",
      email_address: "عنوان البريد الإلكتروني",
      tunisian_mobile_phone_number: "رقم الهاتف المحمول التونسي",
      delivery_address_for_physical_products_: "عنوان التسليم (للمنتجات المادية)",
      financial_data: "البيانات المالية",
      deposit_history_amount_method_anonymized_payment_p: "سجل الإيداعات (المبلغ، الطريقة، إثبات الدفع المجهول)",
      order_history_and_internal_balance_deductions: "سجل الطلبات وخصومات الرصيد الداخلي",
      electronic_invoices: "الفواتير الإلكترونية",
      user_content_data: "بيانات محتوى المستخدم",
      files_uploaded_for_product_customization: "الملفات المرفوعة لتخصيص المنتج",
      avatar_and_profile_preferences: "الصورة الرمزية وتفضيلات الملف الشخصي",
      technical_data: "البيانات التقنية",
      ip_address_and_connection_logs: "عنوان IP وسجلات الاتصال",
      device_type_browser_and_operating_system: "نوع الجهاز، المتصفح ونظام التشغيل",
      preferences_language_dark_mode_: "التفضيلات (اللغة، الوضع الداكن)",
      navigation_data_via_cookies: "بيانات التنقل عبر ملفات تعريف الارتباط",
      your_data_is_processed_based_on_legal_grounds_defi: "يتم معالجة بياناتك بناءً على أسس قانونية محددة في القانون التونسي:",
      purpose: "الغرض",
      legal_basis_law_2018_20_: "الأساس القانوني (القانون 2018-20)",
      details: "التفاصيل",
      account_and_internal_balance_management: "إدارة الحساب والرصيد الداخلي",
      contract_performance_art_13_: "تنفيذ العقد (المادة 13)",
      creation_of_eservices_wallet_deposit_validation_ba: "إنشاء محفظة eServices، التحقق من الإيداع، تتبع الرصيد، المصادقة",
      order_processing: "معالجة الطلب",
      delivery_of_digital_codes_product_customization_in: "تسليم الرموز الرقمية، تخصيص المنتج، الفوترة، دعم ما بعد البيع",
      payment_proof_archiving: "أرشفة إثبات الدفع",
      legal_obligation_art_15_: "الالتزام القانوني (المادة 15)",
      retention_of_financial_records_according_to_tunisi: "الاحتفاظ بالسجلات المالية وفقاً لمدونة التجارة التونسية (10 سنوات)",
      fraud_prevention: "منع الاحتيال",
      legitimate_interest_art_14_: "المصلحة المشروعة (المادة 14)",
      behavior_analysis_to_secure_the_platform_and_prote: "تحليل السلوك لتأمين المنصة وحماية مستخدمينا",
      customer_support_improvement: "دعم العملاء والتحسين",
      responding_to_requests_via_tickets_improving_inter: "الرد على الطلبات عبر التذاكر، تحسين الواجهة والخدمات",
      marketing_newsletters_: "التسويق (النشرات الإخبارية)",
      explicit_consent_art_12_: "الموافقة الصريحة (المادة 12)",
      only_if_you_checked_the_acceptance_box_during_regi: "فقط إذا قمت بتحديد مربع القبول أثناء التسجيل",
      supabase_inc_: "Supabase Inc.",
      transactional_email_services: "خدمات البريد الإلكتروني للمعاملات",
      shipping_providers: "مزودو الشحن",
      retention_periods: "فترات الاحتفاظ",
      active_account_data: "بيانات الحساب النشط",
      transactional_data_and_invoices: "البيانات المعاملاتية والفواتير",
      uploaded_customization_files: "ملفات التخصيص المرفوعة",
      security_logs: "سجلات الأمان",
      deletion_procedure: "إجراءات الحذف",
      anonymized: "مجهول",
      securely_destroyed: "تم التدمير بشكل آمن",
      right_of_access: "حق الوصول",
      obtain_confirmation_that_your_data_is_being_proces: "الحصول على تأكيد بأن بياناتك قيد المعالجة واستلام نسخة.",
      right_to_rectification: "حق التصحيح",
      have_inaccurate_or_incomplete_data_corrected_: "تصحيح البيانات غير الدقيقة أو غير المكتملة.",
      right_to_erasure: "حق المحو",
      request_deletion_of_your_data_under_certain_condit: "طلب حذف بياناتك في ظل ظروف معينة.",
      right_to_restriction: "حق التقييد",
      temporarily_suspend_processing_of_your_data_: "تعليق معالجة بياناتك مؤقتاً.",
      right_to_object: "حق الاعتراض",
      object_to_processing_for_legitimate_reasons_: "الاعتراض على المعالجة لأسباب مشروعة.",
      right_to_data_portability: "حق قابلية نقل البيانات",
      receive_your_data_in_a_structured_commonly_used_fo: "استلام بياناتك بتنسيق منظم وشائع الاستخدام.",
      how_to_exercise_your_rights_: "كيف تمارس حقوقك؟",
      technical_measures: "الإجراءات التقنية",
      ssl_tls_encryption_for_all_communications: "تشفير SSL/TLS لجميع الاتصالات",
      firewalls_and_intrusion_detection_systems: "جدران الحماية وأنظمة كشف التسلل",
      regular_encrypted_backups: "نسخ احتياطية مشفرة منتظمة",
      passwords_stored_in_hashed_form_bcrypt_: "كلمات المرور مخزنة بشكل مشفر (bcrypt)",
      two_factor_authentication_for_administrative_team: "المصادقة الثنائية لفريق الإدارة",
      organizational_measures: "الإجراءات التنظيمية",
      restricted_data_access_based_on_need_to_know_princ: "الوصول المقيّد للبيانات بناءً على مبدأ \"الحاجة للمعرفة\"",
      mandatory_staff_training_on_data_protection: "التدريب الإلزامي للموظفين حول حماية البيانات",
      regular_security_audits: "تدقيقات أمنية منتظمة",
      documented_procedures_in_case_of_data_breach: "إجراءات موثقة في حالة خرق البيانات",
      breach_notification: "إشعار الخرق",
      cookie_type: "نوع ملف تعريف الارتباط",
      retention: "الاحتفاظ",
      essential_cookies: "ملفات تعريف الارتباط الأساسية",
      maintain_your_login_session_manage_your_cart_ensur: "الحفاظ على جلسة تسجيل الدخول، إدارة سلة التسوق، ضمان الأمان",
      session_duration: "مدة الجلسة",
      analytical_cookies: "ملفات تعريف الارتباط التحليلية",
      measure_audience_understand_platform_usage_anonymi: "قياس الجمهور، فهم استخدام المنصة (مجهول)",
      maximum_13_months: "حد أقصى 13 شهراً",
      remember_your_language_dark_light_mode: "تذكر لغتك، الوضع الداكن/الفاتح",
      european_commission_standard_contractual_clauses: "بنود العقد القياسية للمفوضية الأوروبية",
      data_protection_certifications_e_g_privacy_shield_: "شهادات حماية البيانات (مثل Privacy Shield للولايات المتحدة، عند الاقتضاء)",
      strict_confidentiality_agreements_with_our_subcont: "اتفاقيات سرية صارمة مع مقاولينا من الباطن",
      effective_date_: "تاريخ السريان:",
      general_email_: "البريد الإلكتروني العام:",
      deposit_issue: "مشكلة الإيداع",
      non_functional_code: "رمز غير وظيفي",
      service_discontinued: "الخدمة متوقفة",
      terms_and_conditions_of_use: "شروط وأحكام الاستخدام",
      important_note_: "ملاحظة مهمة:",
      article_1_general_principle_no_refund: "المادة 1 - المبدأ العام: لا استرداد",
      the_eservices_internal_balance_is_non_refundable_: "الرصيد الداخلي لـ eServices غير قابل للاسترداد.",
      article_2_exceptional_cases_for_credit_or_refund: "المادة 2 - الحالات الاستثنائية للائتمان أو الاسترداد",
      status_pending_: "الحالة \"في الانتظار\":",
      status_validated_: "الحالة \"محقق\":",
      exception_for_double_bank_transfer_: "استثناء للتحويل البنكي المزدوج:",
      timeframe_: "الإطار الزمني:",
      verification_: "التحقق:",
      solution_: "الحل:",
      article_3_procedure_for_admitted_exceptional_cases: "المادة 3 - الإجراءات للحالات الاستثنائية المعترف بها",
      open_a_support_ticket: "فتح تذكرة دعم",
      provide_all_necessary_evidence_: "تقديم جميع الأدلة اللازمة:",
      complete_screenshots: "لقطات شاشة كاملة",
      transaction_identification_number_d17_flouci_: "رقم تعريف المعاملة (D17/Flouci)",
      bank_transfer_proof: "إثبات التحويل البنكي",
      relevant_order_number: "رقم الطلب ذي الصلة",
      request_review_: "طلب المراجعة:",
      decision_and_compensation_: "القرار والتعويض:",
      article_4_applicable_fees: "المادة 4 - الرسوم المعمول بها",
      no_fees: "بدون رسوم",
      processing_a_replacement_credit_request_defective_: "معالجة طلب استبدال الائتمان (رمز معيب) مجانية.",
      bank_transaction_fees: "رسوم المعاملات البنكية",
      article_5_contact_and_processing_modalities: "المادة 5 - طرق الاتصال والمعالجة",
      the_ticket_system_ensures_organized_follow_up_secu: "يضمن نظام التذاكر المتابعة المنظمة، التبادلات الآمنة، وإمكانية إرفاق المستندات الداعمة.",
      you_can_track_the_progress_of_your_request_at_any_: "يمكنك تتبع تقدم طلبك في أي وقت من واجهتك.",
      related_documents: "المستندات ذات الصلة",
      delivery_policy: "سياسة التسليم",
      last_updated_date_: "تاريخ آخر تحديث:",
      publisher: "الناشر",
      legal_name_: "الاسم القانوني:",
      registered_office_: "المقر المسجل:",
      legal_contact_: "جهة الاتصال القانونية:",
      art_1_purpose: "المادة 1. الغرض",
      these_general_terms_and_conditions_gtc_aim_to_defi: "تهدف هذه الشروط والأحكام العامة (GTC) إلى تحديد حقوق والتزامات الأطراف في إطار استخدام منصة eServices ونموذجها الاقتصادي القائم على رصيد داخلي مسبق الدفع. تحكم الوصول إلى موقع eservices.tn والتطبيق المحمول المرتبط به، وإنشاء حساب محفظة eServices، وإيداع الأموال، وشراء الخدمات الرقمية والمنتجات المخصصة.",
      art_2_definitions: "المادة 2. التعريفات",
      platform_: "المنصة:",
      user_client_: "المستخدم/العميل:",
      account_eservices_wallet_: "الحساب / محفظة eServices:",
      internal_balance_: "الرصيد الداخلي:",
      services_: "الخدمات:",
      deposit_: "الإيداع:",
      order_: "الطلب:",
      art_3_acceptance_and_capacity: "المادة 3. القبول والأهلية",
      art_4_service_description_and_role_of_eservices: "المادة 4. وصف الخدمة ودور eServices",
      the_management_of_a_prepaid_electronic_wallet_inte: "إدارة محفظة إلكترونية مسبقة الدفع (الرصيد الداخلي).",
      the_purchase_of_services_provided_by_third_party_p: "شراء الخدمات المقدمة من شركاء طرف ثالث (مشغلو الاتصالات، ناشرو الألعاب، خدمات البث) أو المنتجة من قبل eServices (التخصيص).",
      art_5_account_creation_and_security: "المادة 5. إنشاء الحساب والأمان",
      art_6_internal_balance_top_up_nature_irrevocabilit: "المادة 6. الرصيد الداخلي: إعادة الشحن، الطبيعة، عدم القابلية للإلغاء",
      validation_of_the_deposit_is_conditional_upon_rece: "التحقق من الإيداع مشروط باستلام والتحقق اليدوي من قبل eServices من إثبات الدفع الصالح.",
      the_internal_balance_is_strictly_attached_to_the_a: "الرصيد الداخلي مرتبط بشكل صارم بالحساب ولا يمكن نقله أو بيعه أو تحويله إلى طرف ثالث.",
      art_7_order_placement_and_payment: "المادة 7. تقديم الطلب والدفع",
      art_8_delivery: "المادة 8. التسليم",
      the_right_of_withdrawal_is_excluded_: "حق الانسحاب مستبعد.",
      delivery_according_to_the_terms_indicated_on_the_p: "التسليم وفقاً للشروط المذكورة في ورقة المنتج. تبدأ أوقات التسليم بعد التحقق من التخصيص من قبل فريقنا. يتم تحديد تكاليف الشحن والمخاطر في وقت الطلب.",
      art_9_right_of_withdrawal_and_warranties: "المادة 9. حق الانسحاب والضمانات",
      services_fully_performed_before_the_end_of_the_wit: "الخدمات المنفذة بالكامل قبل نهاية فترة الانسحاب (إعادة الشحن، الرموز المسلمة)",
      goods_or_services_whose_price_depends_on_financial: "البضائع أو الخدمات التي يعتمد سعرها على تقلبات السوق المالية",
      goods_made_to_their_specifications_or_clearly_cust: "البضائع المصنوعة حسب مواصفاتها أو المخصصة بوضوح",
      the_provisions_of_the_tunisian_code_of_obligations: "تظل أحكام مدونة الالتزامات والعقود التونسية المتعلقة بالعيوب الخفية قابلة للتطبيق. بالنسبة للرمز الرقمي المعيب، يجب على العميل فتح تذكرة خلال 48 ساعة للحصول على رمز بديل.",
      art_10_intellectual_property: "المادة 10. الملكية الفكرية",
      the_platform_its_design_source_code_databases_logo: "المنصة، تصميمها، الكود المصدري، قواعد البيانات، الشعارات، والمحتوى التحريري هي ملكية حصرية لـ eServices أو المرخصين لها ومحمية بموجب قانون حقوق النشر التونسي والاتفاقيات الدولية (INNORPI). أي ملف تم رفعه من قبل العميل يبقى ملكيته الفكرية؛ يمنحون eServices ترخيص استخدام محدود للتنفيذ الصارم للطلب.",
      art_11_client_obligations_and_responsibilities: "المادة 11. التزامات ومسؤوليات العميل",
      the_client_undertakes_not_to_: "يتعهد العميل بعدم:",
      use_the_platform_for_illegal_or_fraudulent_purpose: "استخدام المنصة لأغراض غير قانونية أو احتيالية",
      attempt_to_hack_disassemble_or_overload_the_infras: "محاولة اختراق أو تفكيك أو تحميل البنية التحتية بشكل زائد",
      upload_files_containing_viruses_or_illicit_content: "رفع ملفات تحتوي على فيروسات أو محتوى غير مشروع",
      bypass_the_internal_balance_system: "تجاوز نظام الرصيد الداخلي",
      art_12_limitation_of_eservices_s_liability: "المادة 12. تحديد مسؤولية eServices",
      interruptions_due_to_maintenance_or_force_majeure: "الانقطاعات بسبب الصيانة أو القوة القاهرة",
      data_loss_related_to_client_s_fault: "فقدان البيانات المتعلق بخطأ العميل",
      content_or_availability_of_services_provided_by_th: "محتوى أو توفر الخدمات المقدمة من شركاء طرف ثالث (المشغلون، الناشرون)",
      indirect_damages_loss_of_profits_loss_of_opportuni: "الأضرار غير المباشرة (فقدان الأرباح، فقدان الفرصة)",
      art_13_personal_data: "المادة 13. البيانات الشخصية",
      art_14_suspension_and_termination: "المادة 14. التعليق والإنهاء",
      art_15_modifications: "المادة 15. التعديلات",
      art_16_applicable_law_and_disputes: "المادة 16. القانون المعمول به والنزاعات",
      courts_of_registered_office_city_: "محاكم [مدينة المقر المسجل]",
      un_cookie_est_un_petit_fichier_texte_stock_sur_vot: "ملف تعريف الارتباط هو ملف نصي صغير يتم تخزينه على جهازك (كمبيوتر، جهاز لوحي، هاتف ذكي) عند زيارة موقع ويب. تسمح ملفات تعريف الارتباط للموقع بتذكر إجراءاتك وتفضيلاتك على مدى فترة من الزمن.",
      am_liorer_votre_exp_rience_utilisateur_et_personna: "تحسين تجربة المستخدم وتخصيص الواجهة",
      assurer_le_fonctionnement_technique_du_site_connex: "ضمان الأداء التقني للموقع (الاتصال، إدارة السلة، أمان المعاملات)",
      analyser_le_trafic_et_l_audience_du_site_pour_opti: "تحليل حركة المرور والجمهور لتحسين خدماتنا",
      enregistrer_vos_pr_f_rences_langue_mode_sombre_par: "حفظ تفضيلاتك (اللغة، الوضع الداكن، إعدادات العرض)",
      prot_ger_la_plateforme_contre_les_activit_s_fraudu: "حماية المنصة من الأنشطة الاحتيالية",
      loi_tunisienne_n_2018_20: "القانون التونسي رقم 2018-20",
      cookies_essentiels_techniques_: "ملفات تعريف الارتباط الأساسية (تقنية)",
      indispensables_au_fonctionnement_de_la_plateforme_: "ضرورية لوظائف المنصة:",
      authentification_et_gestion_de_session_utilisateur: "المصادقة وإدارة الجلسات",
      maintien_de_la_s_curit_de_votre_compte_et_de_vos_t: "الحفاظ على أمان الحساب والمعاملات",
      conservation_des_articles_dans_votre_panier_entre_: "الحفاظ على العناصر في سلة التسوق بين الجلسات",
      m_morisation_de_vos_pr_f_rences_de_confidentialit_: "تذكر تفضيلات الخصوصية الخاصة بك",
      ces_cookies_ne_peuvent_pas_tre_d_sactiv_s_via_notr: "لا يمكن تعطيل ملفات تعريف الارتباط هذه عبر واجهتنا.",
      cookies_analytiques_statistiques_: "ملفات تعريف الارتباط التحليلية (إحصائية)",
      nous_utilisons_des_outils_d_analyse_internes_pour_: "نستخدم أدوات التحليل الداخلية لـ:",
      mesurer_l_audience_et_les_performances_du_site: "قياس الجمهور وأداء الموقع",
      comprendre_comment_les_utilisateurs_interagissent_: "فهم كيفية تفاعل المستخدمين مع المنصة",
      d_tecter_et_r_soudre_les_probl_mes_techniques: "اكتشاف وحل المشاكل التقنية",
      am_liorer_continuellement_l_exp_rience_utilisateur: "تحسين تجربة المستخدم باستمرار",
      ces_cookies_sont_anonymis_s_et_ne_permettent_pas_v: "ملفات تعريف الارتباط هذه مجهولة ولا تسمح بالتعريف الشخصي.",
      cookies_de_pr_f_rences: "ملفات تعريف الارتباط للتفضيلات",
      ils_m_morisent_vos_choix_personnels_: "تتذكر خياراتك الشخصية:",
      langue_de_l_interface_fran_ais_arabe_anglais_: "لغة الواجهة (الفرنسية، العربية، الإنجليزية)",
      mode_d_affichage_sombre_clair_: "وضع العرض (داكن/فاتح)",
      param_tres_r_gionaux: "الإعدادات الإقليمية",
      pr_f_rences_de_notification: "تفضيلات الإشعارات",
      certains_services_int_gr_s_eservices_peuvent_d_pos: "قد تودع بعض الخدمات المدمجة في eServices ملفات تعريف الارتباط الخاصة بها:",
      services_de_paiement_: "خدمات الدفع:",
      outils_d_analyse_: "أدوات التحليل:",
      services_d_email_transactionnel_: "خدمات البريد الإلكتروني للمعاملات:",
      nous_s_lectionnons_rigoureusement_nos_partenaires_: "نختار شركاءنا بعناية ونتأكد من امتثالهم لمعايير حماية البيانات. تخضع ملفات تعريف الارتباط هذه لسياسات الخصوصية الخاصة بمصدرها.",
      vous_avez_le_contr_le_sur_l_utilisation_des_cookie: "لديك سيطرة على استخدام ملفات تعريف الارتباط:",
      via_notre_bandeau_de_consentement: "عبر لافتة الموافقة الخاصة بنا",
      lors_de_votre_premi_re_visite_un_bandeau_vous_perm: "خلال زيارتك الأولى، تسمح لك لافتة بقبول أو رفض ملفات تعريف الارتباط غير الأساسية. يمكنك تعديل خياراتك في أي وقت بالنقر على رابط \"إدارة ملفات تعريف الارتباط\" في أسفل الصفحة.",
      via_les_param_tres_de_votre_navigateur: "عبر إعدادات المتصفح الخاصة بك",
      vous_pouvez_configurer_votre_navigateur_pour_: "يمكنك تكوين متصفحك لـ:",
      refuser_tous_les_cookies: "رفض جميع ملفات تعريف الارتباط",
      accepter_uniquement_les_cookies_essentiels: "قبول ملفات تعريف الارتباط الأساسية فقط",
      _tre_averti_chaque_d_p_t_de_cookie: "تلقي إشعار في كل مرة يتم فيها إيداع ملف تعريف ارتباط",
      supprimer_automatiquement_les_cookies_la_fermeture: "حذف ملفات تعريف الارتباط تلقائياً عند الإغلاق",
      la_proc_dure_varie_selon_les_navigateurs_: "تختلف الإجراءات حسب المتصفح:",
      cons_quences_du_refus: "عواقب الرفض",
      si_vous_d_sactivez_les_cookies_: "إذا قمت بتعطيل ملفات تعريف الارتباط:",
      vous_devrez_vous_reconnecter_chaque_visite: "ستحتاج إلى تسجيل الدخول في كل زيارة",
      votre_panier_ne_sera_pas_sauvegard_entre_les_sessi: "لن يتم حفظ سلة التسوق بين الجلسات",
      vos_pr_f_rences_langue_mode_sombre_ne_seront_pas_m: "لن يتم تذكر تفضيلاتك (اللغة، الوضع الداكن)",
      certaines_fonctionnalit_s_pourraient_tre_limit_es: "قد تكون بعض الميزات محدودة",
      la_s_curit_de_certaines_transactions_pourrait_tre_: "قد يتم تقليل أمان بعض المعاملات",
      les_cookies_ont_des_dur_es_de_vie_variables_: "ملفات تعريف الارتباط لها أعمار مختلفة:",
      cookies_de_session_: "ملفات تعريف الارتباط للجلسة:",
      cookies_persistants_: "ملفات تعريف الارتباط المستمرة:",
      cookies_d_authentification_: "ملفات تعريف الارتباط للمصادقة:",
      cookies_analytiques_: "ملفات تعريف الارتباط التحليلية:",
      politique_de_confidentialit_: "سياسة الخصوصية",
      les_donn_es_collect_es_via_les_cookies_sont_trait_: "يتم معالجة البيانات المجمعة عبر ملفات تعريف الارتباط بشكل آمن",
      nous_ne_partageons_pas_vos_donn_es_de_navigation_d: "لا نشارك بيانات التصفح الخاصة بك لأغراض تجارية دون موافقتك",
      les_cookies_analytiques_sont_anonymis_s: "ملفات تعريف الارتباط التحليلية مجهولة",
      nous_conservons_les_logs_techniques_li_s_aux_cooki: "نحتفظ بالسجلات التقنية المتعلقة بملفات تعريف الارتباط لمدة أقصاها سنة واحدة",
      vous_disposez_d_un_droit_d_acc_s_de_rectification_: "لديك الحق في الوصول إلى بياناتك وتصحيحها والاعتراض على معالجتها",
      nous_pouvons_mettre_jour_cette_politique_de_cookie: "قد نحدث سياسة ملفات تعريف الارتباط هذه لتعكس:",
      les_volutions_techniques_de_la_plateforme: "التطور التقني للمنصة",
      les_changements_r_glementaires_tunisiens_ou_intern: "التغييرات التنظيمية التونسية أو الدولية",
      l_ajout_de_nouvelles_fonctionnalit_s_ou_services: "إضافة ميزات أو خدمات جديدة",
      les_modifications_seront_publi_es_sur_cette_page_a: "سيتم نشر التغييرات على هذه الصفحة مع مؤشر تاريخ التحديث. في حالة التغييرات المهمة، سنخطرك عبر البريد الإلكتروني أو عبر إشعار على المنصة.",
      pour_toute_question_concernant_notre_utilisation_d: "لأي أسئلة بخصوص استخدامنا لملفات تعريف الارتباط أو لممارسة حقوقك:",
      email_du_dpo_: "بريد مسؤول حماية البيانات:",
      tickets_de_support_: "تذاكر الدعم:",
      adresse_postale_: "العنوان البريدي:",
      instance_nationale_de_protection_des_donn_es_perso: "السلطة الوطنية لحماية البيانات الشخصية (INPDP)",
      derni_re_mise_jour_: "آخر تحديث:",
      applicable_: "ينطبق على:",
      mes_codes: "رموزي",
      r_v_ler: "إظهار",
      article_1_champ_d_application: "المادة 1 - نطاق التطبيق",
      services_num_riques: "الخدمات الرقمية",
      article_2_services_num_riques_recharges_codes_abon: "المادة 2 - الخدمات الرقمية (إعادة الشحن، الرموز، الاشتراكات)",
      recharge_mobile_: "إعادة شحن الهاتف المحمول:",
      codes_num_riques_gaming_streaming_licences_: "الرموز الرقمية (الألعاب، البث، التراخيص):",
      code_masqu_: "الرمز المقنع:",
      export_pdf_: "تصدير PDF:",
      article_3_produits_personnalis_s_et_physiques: "المادة 3 - المنتجات المخصصة والمادية",
      en_traitement_: "قيد المعالجة:",
      exp_di_: "تم الشحن:",
      livr_: "تم التسليم:",
      pr_paration_: "التحضير:",
      article_4_responsabilit_s: "المادة 4 - المسؤوليات",
      risque_sur_les_produits_physiques_: "المخاطر على المنتجات المادية:",
      service_num_rique_non_re_u_: "الخدمة الرقمية غير المستلمة:",
      fichiers_de_personnalisation_: "ملفات التخصيص:",
      article_5_coordonn_es_de_livraison: "المادة 5 - معلومات التسليم",
      article_6_droit_de_r_tractation: "المادة 6 - حق الانسحاب",
      les_services_num_riques_fournis_imm_diatement_apr_: "الخدمات الرقمية المقدمة فوراً بعد الطلب (إعادة الشحن، الرموز المسلمة)",
      les_biens_confectionn_s_selon_ses_sp_cifications_o: "البضائع المصنوعة حسب مواصفاتها أو المخصصة بوضوح",
      les_produits_p_rissables_ou_ayant_une_date_de_vali: "المنتجات القابلة للتلف أو المنتجات ذات تاريخ صلاحية محدود",
      politique_de_remboursement: "سياسة الاسترداد",
      d_lai_de_r_ponse_: "وقت الاستجابة:",
      soci_t_ditrice: "شركة النشر",
      d_nomination_sociale_: "الاسم التجاري:",
      forme_juridique_: "الشكل القانوني:",
      capital_social_: "رأس المال:",
      immatriculation_: "التسجيل:",
      tva_intracommunautaire_: "ضريبة القيمة المضافة داخل الاتحاد:",
      si_ge_social: "المقر الاجتماعي",
      adresse_: "العنوان:",
      g_olocalisation_: "الموقع الجغرافي:",
      direction_et_publication: "الإدارة والنشر",
      directeur_de_la_publication_: "مدير النشر:",
      responsable_ditorial_: "مدير التحرير:",
      d_l_gu_la_protection_des_donn_es_: "المفوض لحماية البيانات:",
      support_technique_et_commercial: "الدعم التقني والتجاري",
      t_l_phone_: "الهاتف:",
      horaires_: "ساعات العمل:",
      lundi_au_vendredi_9h_18h_heure_locale_tunisienne_: "من الاثنين إلى الجمعة، من 9 صباحاً إلى 6 مساءً (التوقيت المحلي التونسي)",
      recommandation_: "التوصية:",
      service_juridique_et_conformit_: "الخدمات القانونية والامتثال",
      email_juridique_: "البريد الإلكتروني القانوني:",
      protection_des_donn_es_: "حماية البيانات:",
      service_contentieux_: "خدمة النزاعات:",
      infrastructure_principale: "البنية التحتية الرئيسية",
      base_de_donn_es_et_authentification: "قاعدة البيانات والمصادقة",
      fournisseur_: "المزود:",
      localisation_: "الموقع:",
      s_curit_: "الأمان:",
      services_compl_mentaires: "الخدمات التكميلية",
      email_transactionnel_: "البريد الإلكتروني للمعاملات:",
      analyse_d_audience_: "تحليل الجمهور:",
      disponibilit_et_maintenance: "التوفر والصيانة",
      taux_de_disponibilit_garanti: "معدل وقت التشغيل المضمون",
      surveillance_et_support_technique: "المراقبة والدعم التقني",
      chiffrement_tls_1_3_certifi_: "تشفير TLS 1.3 معتمد",
      marques_et_logos: "العلامات التجارية والشعارات",
      d_p_t_innorpi_institut_national_de_la_normalisatio: "إيداع INNORPI (المعهد الوطني للتقييس والملكية الصناعية)",
      protection_internationale_via_le_syst_me_de_madrid: "الحماية الدولية عبر نظام مدريد",
      toute_reproduction_sans_autorisation_expresse_est_: "أي استنساخ دون ترخيص صريح محظور",
      droits_d_auteur: "حقوق النشر",
      code_source_et_algorithmes: "الكود المصدري والخوارزميات",
      design_et_interface_utilisateur: "التصميم وواجهة المستخدم",
      documentation_technique_et_contenu_ditorial: "الوثائق التقنية والمحتوى التحريري",
      base_de_donn_es_protection_sui_generis_: "قاعدة البيانات (حماية sui generis)",
      licences_d_utilisation: "تراخيص الاستخدام",
      autoris_: "مسموح",
      usage_personnel_et_non_commercial: "الاستخدام الشخصي وغير التجاري",
      acc_s_via_navigateur_ou_application_officielle: "الوصول عبر المتصفح أو التطبيق الرسمي",
      cr_ation_d_un_compte_unique_par_personne: "إنشاء حساب واحد لكل شخص",
      interdit: "محظور",
      reverse_engineering_ou_d_compilation: "الهندسة العكسية أو إلغاء التجميع",
      utilisation_commerciale_non_autoris_e: "الاستخدام التجاري غير المصرح به",
      cr_ation_de_comptes_multiples: "إنشاء حسابات متعددة",
      extraction_massive_de_donn_es: "استخراج البيانات بكميات كبيرة",
      domaine: "النطاق",
      cadre_l_gal: "الإطار القانوني",
      conformit_: "الامتثال",
      r_f_rence: "المرجع",
      commerce_lectronique: "التجارة الإلكترونية",
      loi_tunisienne_n_2000_83: "القانون التونسي رقم 2000-83",
      compl_te: "كامل",
      protection_des_donn_es: "حماية البيانات",
      loi_organique_n_2018_20: "القانون الأساسي رقم 2018-20",
      d_claration_inpdp: "إعلان INPDP",
      dossier_n_num_ro_: "ملف رقم [الرقم]",
      services_de_paiement: "خدمات الدفع",
      r_glementation_bct: "تنظيم البنك المركزي التونسي",
      conforme_aux_usages: "متوافق مع الممارسات",
      circulaire_xx_2022: "المنشور XX/2022",
      consommation: "الاستهلاك",
      code_de_la_consommation: "مدونة حماية المستهلك",
      respect_des_d_lais: "احترام المواعيد النهائية",
      fiscalit_: "الضرائب",
      code_des_douanes_et_imp_ts: "مدونة الجمارك والضرائب",
      tva_collect_e: "ضريبة القيمة المضافة المحصلة",
      n_tva_num_ro_tva_: "رقم ضريبة القيمة المضافة: [الرقم]",
      droit_d_auteur: "حقوق النشر",
      loi_n_94_36: "القانون رقم 94-36",
      licences_partenaires: "تراخيص الشركاء",
      autorit_s_de_r_gulation: "السلطات التنظيمية",
      banque_centrale_de_tunisie: "البنك المركزي التونسي",
      institut_national_de_la_normalisation_et_de_la_pro: "المعهد الوطني للتقييس والملكية الصناعية",
      r_le_d_interm_diaire: "دور الوسيط",
      exclusions_de_garantie: "استثناءات الضمان",
      services_num_riques_: "الخدمات الرقمية:",
      interruptions_de_service_: "انقطاعات الخدمة:",
      donn_es_utilisateur_: "بيانات المستخدم:",
      usage_frauduleux_: "الاستخدام الاحتيالي:",
      plafonnement_de_responsabilit_: "حد المسؤولية",
      montant_de_la_commande: "مبلغ الطلب",
      plafond_pour_les_services_num_riques: "الحد الأقصى للخدمات الرقمية",
      dernier_d_p_t: "آخر إيداع",
      plafond_pour_les_erreurs_de_traitement: "الحد الأقصى لأخطاء المعالجة",
      droit_applicable: "القانون المعمول به",
      tribunaux_comp_tents: "المحاكم المختصة",
      r_glement_amiable: "التسوية الودية",
      m_diation: "الوساطة",
      notification_des_modifications: "إشعار التعديلات",
      publication_sur_cette_page_avec_indication_de_la_d: "النشر على هذه الصفحة مع إشارة تاريخ التحديث",
      notification_par_email_aux_utilisateurs_actifs: "إشعار بالبريد الإلكتروني للمستخدمين النشطين",
      affichage_d_un_bandeau_d_information_dans_l_applic: "عرض لافتة معلومات في التطبيق",
      entr_e_en_vigueur: "تاريخ السريان",
      conditions_g_n_rales: "الشروط العامة",
      loi_organique_tunisienne_n_2018_20_du_25_avril_201: "القانون الأساسي التونسي رقم 2018-20 المؤرخ في 25 أبريل 2018",
      responsable_du_traitement_: "مسؤول المعالجة:",
      d_l_gu_la_protection_des_donn_es_dpo_: "المفوض لحماية البيانات (DPO):",
      dans_le_cadre_de_l_utilisation_de_notre_plateforme: "عند استخدامك لمنصتنا، قد نقوم بجمع الفئات التالية من البيانات:",
      donn_es_d_identification: "بيانات التعريف",
      nom_et_pr_nom: "الاسم واللقب",
      adresse_e_mail: "عنوان البريد الإلكتروني",
      num_ro_de_t_l_phone_mobile_tunisien: "رقم الهاتف المحمول التونسي",
      adresse_de_livraison_pour_les_produits_physiques_: "عنوان التسليم (للمنتجات المادية)",
      donn_es_financi_res: "البيانات المالية",
      historique_des_d_p_ts_montant_m_thode_preuve_de_pa: "سجل الإيداعات (المبلغ، الطريقة، إثبات الدفع المجهول)",
      historique_des_commandes_et_d_bits_du_solde_intern: "سجل الطلبات وخصومات الرصيد الداخلي",
      factures_lectroniques: "الفواتير الإلكترونية",
      donn_es_de_contenu_utilisateur: "بيانات محتوى المستخدم",
      fichiers_upload_s_pour_la_personnalisation_de_prod: "الملفات المرفوعة لتخصيص المنتج",
      avatar_et_pr_f_rences_de_profil: "الصورة الرمزية وتفضيلات الملف الشخصي",
      donn_es_techniques: "البيانات التقنية",
      adresse_ip_et_logs_de_connexion: "عنوان IP وسجلات الاتصال",
      type_d_appareil_navigateur_et_syst_me_d_exploitati: "نوع الجهاز، المتصفح ونظام التشغيل",
      pr_f_rences_langue_mode_sombre_: "التفضيلات (اللغة، الوضع الداكن)",
      donn_es_de_navigation_via_cookies: "بيانات التصفح عبر ملفات تعريف الارتباط",
      le_traitement_de_vos_donn_es_s_effectue_sur_des_ba: "يتم معالجة بياناتك بناءً على أسس قانونية محددة بموجب القانون التونسي:",
      finalit_: "الغرض",
      base_l_gale_loi_2018_20_: "الأساس القانوني (القانون 2018-20)",
      d_tails: "التفاصيل",
      gestion_du_compte_et_du_solde_interne: "إدارة الحساب والرصيد الداخلي",
      ex_cution_du_contrat_art_13_: "تنفيذ العقد (المادة 13)",
      cr_ation_du_portefeuille_eservices_validation_des_: "إنشاء محفظة eServices، التحقق من الإيداع، تتبع الرصيد، المصادقة",
      traitement_des_commandes: "معالجة الطلبات",
      livraison_des_codes_num_riques_personnalisation_de: "تسليم الرموز الرقمية، تخصيص المنتج، الفوترة، دعم ما بعد البيع",
      archivage_des_preuves_de_paiement: "أرشفة إثبات الدفع",
      obligation_l_gale_art_15_: "التزام قانوني (المادة 15)",
      conservation_des_justificatifs_financiers_conform_: "الاحتفاظ بالسجلات المالية وفقاً للقانون التجاري التونسي (10 سنوات)",
      pr_vention_de_la_fraude: "منع الاحتيال",
      int_r_t_l_gitime_art_14_: "مصلحة مشروعة (المادة 14)",
      analyse_des_comportements_pour_s_curiser_la_platef: "تحليل السلوك لتأمين المنصة وحماية مستخدمينا",
      support_client_am_lioration: "دعم العملاء والتحسين",
      r_pondre_aux_demandes_via_tickets_am_liorer_l_inte: "الرد على الطلبات عبر التذاكر، تحسين الواجهة والخدمات",
      consentement_expr_s_art_12_: "موافقة صريحة (المادة 12)",
      uniquement_si_vous_avez_coch_la_case_d_acceptation: "فقط إذا قمت بتحديد مربع القبول أثناء التسجيل",
      services_d_envoi_d_e_mails_transactionnels: "خدمات البريد الإلكتروني للمعاملات",
      prestataires_de_transport: "مقدمو الشحن",
      dur_es_de_conservation: "فترات الاحتفاظ",
      donn_es_du_compte_actif: "بيانات الحساب النشط",
      donn_es_transactionnelles_et_factures: "بيانات المعاملات والفواتير",
      fichiers_upload_s_pour_personnalisation: "ملفات التخصيص المرفوعة",
      logs_de_s_curit_: "سجلات الأمان",
      proc_dure_de_suppression: "إجراء الحذف",
      anonymis_es: "مجهول",
      d_truites_de_mani_re_s_curis_e: "تم تدميره بشكل آمن",
      droit_d_acc_s: "حق الوصول",
      obtenir_la_confirmation_que_vos_donn_es_sont_trait: "الحصول على تأكيد بأن بياناتك قيد المعالجة وتلقي نسخة.",
      droit_de_rectification: "حق التصحيح",
      faire_corriger_des_donn_es_inexactes_ou_incompl_te: "تصحيح البيانات غير الدقيقة أو غير الكاملة.",
      droit_l_effacement: "حق المسح",
      demander_la_suppression_de_vos_donn_es_sous_certai: "طلب حذف بياناتك بموجب شروط معينة.",
      droit_la_limitation: "حق التقييد",
      suspension_temporaire_du_traitement_de_vos_donn_es: "تعليق معالجة بياناتك مؤقتاً.",
      droit_d_opposition: "حق الاعتراض",
      vous_opposer_au_traitement_pour_des_raisons_l_giti: "الاعتراض على المعالجة لأسباب مشروعة.",
      droit_la_portabilit_: "حق نقل البيانات",
      recevoir_vos_donn_es_dans_un_format_structur_et_li: "تلقي بياناتك بتنسيق منظم وشائع الاستخدام.",
      comment_exercer_vos_droits_: "كيف تمارس حقوقك؟",
      mesures_techniques: "الإجراءات التقنية",
      chiffrement_ssl_tls_pour_toutes_les_communications: "تشفير SSL/TLS لجميع الاتصالات",
      pare_feu_et_syst_mes_de_d_tection_d_intrusion: "جدران الحماية وأنظمة كشف التسلل",
      sauvegardes_r_guli_res_et_chiffr_es: "نسخ احتياطية مشفرة ومنتظمة",
      mots_de_passe_stock_s_sous_forme_hach_e_bcrypt_: "كلمات المرور المخزنة بصيغة مجزأة (bcrypt)",
      authentification_deux_facteurs_pour_l_quipe_admini: "المصادقة الثنائية للفريق الإداري",
      mesures_organisationnelles: "الإجراءات التنظيمية",
      acc_s_restreint_aux_donn_es_selon_le_principe_du_b: "وصول مقيد للبيانات بناءً على مبدأ \"الحاجة إلى المعرفة\"",
      formation_obligatoire_du_personnel_la_protection_d: "تدريب إلزامي للموظفين على حماية البيانات",
      audits_de_s_curit_r_guliers: "تدقيقات أمنية منتظمة",
      proc_dures_document_es_en_cas_de_violation_de_donn: "إجراءات موثقة في حالة خرق البيانات",
      notification_en_cas_de_violation: "إشعار بالخرق",
      type_de_cookie: "نوع ملف تعريف الارتباط",
      conservation: "الاحتفاظ",
      cookies_essentiels: "ملفات تعريف الارتباط الأساسية",
      maintenir_votre_session_de_connexion_g_rer_votre_p: "الحفاظ على جلسة تسجيل الدخول الخاصة بك، إدارة سلة التسوق الخاصة بك، ضمان الأمان",
      dur_e_de_la_session: "مدة الجلسة",
      cookies_analytiques: "ملفات تعريف الارتباط التحليلية",
      mesurer_l_audience_comprendre_l_usage_de_la_platef: "قياس الجمهور، فهم استخدام المنصة (مجهول)",
      m_moriser_votre_langue_mode_sombre_clair: "تذكر لغتك، الوضع الداكن/الفاتح",
      clauses_contractuelles_types_de_la_commission_euro: "البنود التعاقدية القياسية للمفوضية الأوروبية",
      certifications_de_protection_des_donn_es_ex_privac: "شهادات حماية البيانات (مثل درع الخصوصية للولايات المتحدة، عند الاقتضاء)",
      accords_de_confidentialit_stricts_avec_nos_sous_tr: "اتفاقيات سرية صارمة مع مقاولينا من الباطن",
      date_d_entr_e_en_vigueur_: "تاريخ السريان:",
      email_g_n_ral_: "البريد الإلكتروني العام:",
      probl_me_de_d_p_t: "مشكلة في الإيداع",
      code_non_fonctionnel: "رمز غير وظيفي",
      service_interrompu: "الخدمة متوقفة",
      conditions_g_n_rales_d_utilisation: "شروط وأحكام الاستخدام",
      note_importante_: "ملاحظة هامة:",
      article_1_principe_g_n_ral_absence_de_remboursemen: "المادة 1 - المبدأ العام: لا استرداد",
      le_solde_interne_eservices_n_est_pas_remboursable_: "الرصيد الداخلي لـ eServices غير قابل للاسترداد.",
      article_2_cas_exceptionnels_de_cr_dit_ou_de_rembou: "المادة 2 - حالات استثنائية للرصيد أو الاسترداد",
      statut_en_attente_: "الحالة \"قيد الانتظار\":",
      statut_valid_: "الحالة \"تم التحقق\":",
      exception_pour_double_virement_bancaire_: "استثناء للتحويل البنكي المزدوج:",
      d_lai_: "الإطار الزمني:",
      v_rification_: "التحقق:",
      article_3_proc_dure_pour_les_cas_exceptionnels_adm: "المادة 3 - إجراءات الحالات الاستثنائية المقبولة",
      ouvrez_un_ticket_de_support: "افتح تذكرة دعم",
      fournissez_toutes_les_preuves_n_cessaires_: "قدم جميع الأدلة اللازمة:",
      captures_d_cran_compl_tes: "لقطات شاشة كاملة",
      num_ro_d_identification_de_transaction_d17_flouci_: "رقم تعريف المعاملة (D17/Flouci)",
      justificatifs_de_virement_bancaire: "إثبات التحويل البنكي",
      num_ro_de_commande_concern_e: "رقم الطلب ذي الصلة",
      _tude_de_la_demande_: "طلب مراجعة:",
      d_cision_et_compensation_: "القرار والتعويض:",
      article_4_frais_applicables: "المادة 4 - الرسوم المطبقة",
      sans_frais: "لا رسوم",
      le_traitement_d_une_demande_de_cr_dit_de_remplacem: "معالجة طلب رصيد بديل (رمز معيب) مجانية.",
      frais_de_transaction_bancaire: "رسوم المعاملات البنكية",
      article_5_contact_et_modalit_s_de_traitement: "المادة 5 - طرق الاتصال والمعالجة",
      le_syst_me_de_tickets_garantit_un_suivi_organis_la: "يضمن نظام التذاكر متابعة منظمة، وتبادلات آمنة، والقدرة على إرفاق المستندات الداعمة.",
      vous_pouvez_suivre_l_avancement_de_votre_demande_t: "يمكنك تتبع تقدم طلبك في أي وقت من واجهتك.",
      documents_connexes: "الوثائق ذات الصلة",
      politique_de_livraison: "سياسة التسليم",
      date_de_derni_re_mise_jour_: "تاريخ آخر تحديث:",
      _diteur: "الناشر",
      raison_sociale_: "الاسم التجاري:",
      tva_intracom_: "ضريبة القيمة المضافة داخل الاتحاد:",
      si_ge_social_: "المقر الاجتماعي:",
      contact_l_gal_: "جهة الاتصال القانونية:",
      art_1_objet: "المادة 1. الغرض",
      les_pr_sentes_conditions_g_n_rales_cgu_ont_pour_ob: "تهدف هذه الشروط والأحكام العامة (GTC) إلى تحديد حقوق والتزامات الأطراف في إطار استخدام منصة eServices ونموذجها الاقتصادي القائم على رصيد داخلي مدفوع مسبقاً. وهي تحكم الوصول إلى موقع الويب eservices.tn وتطبيق الهاتف المحمول المرتبط به، وإنشاء حساب محفظة eServices، وإيداع الأموال، وشراء الخدمات الرقمية والمنتجات المخصصة.",
      art_2_d_finitions: "المادة 2. التعريفات",
      plateforme_: "المنصة:",
      utilisateur_client_: "المستخدم/العميل:",
      compte_portefeuille_eservices_: "الحساب / محفظة eServices:",
      solde_interne_: "الرصيد الداخلي:",
      d_p_t_: "الإيداع:",
      commande_: "الطلب:",
      art_3_acceptation_et_capacit_: "المادة 3. القبول والأهلية",
      art_4_description_du_service_et_r_le_de_eservices: "المادة 4. وصف الخدمة ودور eServices",
      la_gestion_d_un_portefeuille_lectronique_pr_pay_so: "إدارة محفظة إلكترونية مدفوعة مسبقاً (الرصيد الداخلي).",
      l_achat_de_services_fournis_par_des_partenaires_ti: "شراء الخدمات المقدمة من قبل شركاء خارجيين (مشغلي الاتصالات، ناشري الألعاب، خدمات البث) أو المنتجة من قبل eServices (التخصيص).",
      art_5_cr_ation_et_s_curit_du_compte: "المادة 5. إنشاء الحساب والأمان",
      art_6_solde_interne_recharge_nature_irr_vocabilit_: "المادة 6. الرصيد الداخلي: إعادة الشحن، الطبيعة، عدم القابلية للإلغاء",
      la_validation_du_d_p_t_est_conditionn_e_la_r_cepti: "التحقق من الإيداع مشروط باستلام eServices وإجراء التحقق اليدوي من إثبات دفع صالح.",
      le_solde_interne_est_strictement_attach_au_compte_: "الرصيد الداخلي مرتبط بشكل صارم بالحساب ولا يمكن التنازل عنه أو بيعه أو تحويله إلى طرف ثالث.",
      art_7_passation_de_commande_et_paiement: "المادة 7. تقديم الطلب والدفع",
      art_8_livraison: "المادة 8. التسليم",
      le_droit_de_r_tractation_est_exclu_: "يتم استبعاد حق الانسحاب.",
      livraison_selon_les_modalit_s_indiqu_es_sur_la_fic: "التسليم وفقاً للشروط الموضحة في ورقة المنتج. تبدأ أوقات التسليم بعد التحقق من التخصيص من قبل فريقنا. يتم تحديد تكاليف الشحن والمخاطر في وقت الطلب.",
      art_9_droit_de_r_tractation_et_garanties: "المادة 9. حق الانسحاب والضمانات",
      les_services_pleinement_ex_cut_s_avant_la_fin_du_d: "الخدمات التي تم تنفيذها بالكامل قبل نهاية فترة الانسحاب (إعادة الشحن، الرموز المسلمة)",
      les_biens_ou_services_dont_le_prix_d_pend_de_fluct: "السلع أو الخدمات التي يعتمد سعرها على تقلبات السوق المالية",
      les_dispositions_du_code_des_obligations_et_des_co: "تظل أحكام القانون التونسي للالتزامات والعقود المتعلقة بالعيوب الخفية سارية. بالنسبة لرمز رقمي معيب، يجب على العميل فتح تذكرة في غضون 48 ساعة للحصول على رمز بديل.",
      art_10_propri_t_intellectuelle: "المادة 10. الملكية الفكرية",
      la_plateforme_son_design_son_code_source_ses_bases: "المنصة وتصميمها ورمزها المصدري وقواعد بياناتها وشعاراتها ومحتواها التحريري هي ملكية حصرية لـ eServices أو مرخصيها وهي محمية بموجب قانون حقوق النشر التونسي والاتفاقيات الدولية (INNORPI). أي ملف يتم تحميله من قبل العميل يظل ملكيته الفكرية؛ ويمنح eServices ترخيص استخدام محدود للتنفيذ الصارم للطلب.",
      art_11_obligations_et_responsabilit_s_du_client: "المادة 11. التزامات ومسؤوليات العميل",
      le_client_s_engage_ne_pas_: "يتعهد العميل بعدم:",
      utiliser_la_plateforme_des_fins_ill_gales_ou_fraud: "استخدام المنصة لأغراض غير قانونية أو احتيالية",
      tenter_de_pirater_d_sassembler_ou_surcharger_l_inf: "محاولة اختراق أو فك تجميع أو إثقال البنية التحتية",
      uploader_des_fichiers_contenant_des_virus_ou_du_co: "تحميل ملفات تحتوي على فيروسات أو محتوى غير قانوني",
      contourner_le_syst_me_de_solde_interne: "تجاوز نظام الرصيد الداخلي",
      art_12_limitation_de_responsabilit_de_eservices: "المادة 12. تحديد مسؤولية eServices",
      les_interruptions_dues_la_maintenance_ou_un_cas_de: "الانقطاعات بسبب الصيانة أو القوة القاهرة",
      la_perte_de_donn_es_li_e_une_faute_du_client: "فقدان البيانات المتعلق بخطأ العميل",
      le_contenu_ou_la_disponibilit_des_services_fournis: "محتوى أو توفر الخدمات المقدمة من قبل شركاء خارجيين (مشغلين، ناشرين)",
      les_dommages_indirects_perte_de_b_n_fices_perte_d_: "الأضرار غير المباشرة (فقدان الأرباح، فقدان الفرصة)",
      la_responsabilit_de_eservices_si_elle_est_retenue_: "مسؤولية eServices، إذا تم قبولها، لا يمكن أن تتجاوز مبلغ الطلب المتنازع عليه أو آخر إيداع تم إجراؤه.",
      art_13_donn_es_personnelles: "المادة 13. البيانات الشخصية",
      art_14_suspension_et_r_solution: "المادة 14. التعليق والإنهاء",
      art_16_droit_applicable_et_litiges: "المادة 16. القانون المعمول به والنزاعات",
      tribunaux_de_ville_du_si_ge_social_: "محاكم [مدينة المقر المسجل]",
      bient_t_disponible: "قريباً متاح",
      service_s_curis_et_fiable: "خدمة آمنة وموثوقة",
      support_24_7_disponible: "دعم متاح 24/7",
      google: "Google",
      github: "GitHub",
      services: "الخدمات",
      open_menu: "فتح القائمة",
      close_menu: "إغلاق القائمة",
      total_payer: "الإجمالي المستحق للدفع",
      entrez_l: "أدخل",
      r_sum_: "الملخص",
      votre_solde_actuel: "رصيدك الحالي",
      instructions: "التعليمات",
      comptes_bancaires: "الحسابات البنكية",
      choisir_un_fichier: "اختر ملفاً",
      aujourd: "اليوم",
      d_p_ts: "الإيداعات",
      total_commandes: "إجمالي الطلبات",
      tickets_support: "تذاكر الدعم",
      mes_commandes: "طلباتي",
      mes_d_p_ts: "إيداعاتي",
      commandes_en_attente: "الطلبات المعلقة",
      d_p_ts_en_attente: "الإيداعات المعلقة",
      commandes: "الطلبات",
      tickets: "التذاكر",
      clients: "العملاء",
      produits: "المنتجات",
      stock: "المخزون",
      m_dia: "الوسائط",
      recharger: "الشحن",
      boutique: "المتجر",
      support: "الدعم",
      historique: "السجل",
      promotion: "العروض",
      produits_populaires: "المنتجات الشائعة",
      bienvenue_: "مرحباً،",
      chiffre_d_affaires_total: "إجمالي الإيرادات",
      offre_limit_e: "عرض محدود",
      netflix_premium_20_: "Netflix Premium -20%",
      profitez_du_meilleur_du_streaming_prix_r_duit_: "استمتع بأفضل ما في البث بسعر مخفض.",
      r_sum_du_jour: "ملخص اليوم",
      aucune_commande_r_cente: "لا توجد طلبات حديثة",
      mes_favoris: "مفضلاتي",
      retrouvez_les_articles_que_vous_avez_aim_s_: "استرجع العناصر التي أعجبتك.",
      aucun_favori: "لا توجد مفضلات",
      parcourez_le_catalogue_et_ajoutez_des_articles_vos: "تصفح الكتالوج وأضف عناصر إلى مفضلاتك.",
      modifier: "تعديل",
      supprimer: "حذف",
      rechercher_: "بحث...",
      nom_de_la_cat_gorie: "اسم الفئة",
      description_de_la_cat_gorie: "وصف الفئة",
      preview: "معاينة",
      nom_de_la_sous_cat_gorie: "اسم الفئة الفرعية",
      description_de_la_sous_cat_gorie: "وصف الفئة الفرعية",
      s_lectionner_une_cat_gorie: "اختر فئة",
      preuve_de_d_p_t: "إثبات الإيداع",
      montant: "المبلغ",
      m_thode: "الطريقة",
      preuve_de_paiement: "إثبات الدفع",
      image_non_disponible: "الصورة غير متاحة",
      cliquez_pour_voir_le_code_complet: "انقر لعرض الرمز الكامل",
      aucun_d_p_t: "لا توجد إيداعات",
      voir_les_d_tails_de_la_commande: "عرض تفاصيل الطلب",
      g_rez_les_commandes_des_clients: "إدارة طلبات العملاء",
      montant_total: "المبلغ الإجمالي",
      moyen_de_paiement: "طريقة الدفع",
      changer_le_statut_de_la_commande: "تغيير حالة الطلب",
      aucune_commande: "لا توجد طلبات",
      client: "العميل",
      statut: "الحالة",
      articles: "العناصر",
      rechercher_un_produit_: "بحث عن منتج...",
      g_rez_votre_catalogue: "إدارة الكتالوج الخاص بك",
      best: "الأفضل",
      aucun_produit_trouv_: "لم يتم العثور على منتج",
      rechercher_un_client_: "بحث عن عميل...",
      g_rez_vos_utilisateurs: "إدارة المستخدمين",
      d_p_ts_: "الإيداعات:",
      aucun: "لا يوجد",
      commandes_: "الطلبات:",
      aucune: "لا توجد",
      conversations_: "المحادثات:",
      s_curisation_: "جاري التأمين...",
      logo: "الشعار",
      saisir_montant: "أدخل المبلغ",
      produit_introuvable: "المنتج غير موجود",
      prix_de_base: "السعر الأساسي",
      prix_total: "السعر الإجمالي",
      cat_gorie: "الفئة",
      sous_cat_gorie: "الفئة الفرعية",
      m_thode_de_livraison: "طريقة التسليم",
      moyens_de_paiement: "طرق الدفع",
      type_de_vente: "نوع البيع",
      quantit_minimale: "الحد الأدنى للكمية",
      s_lectionner_: "اختر...",
      aucune_description_disponible_pour_ce_produit_: "لا يوجد وصف متاح لهذا المنتج.",
      valeur_du_produit: "قيمة المنتج",
      s_lectionnez_la_quantit_souhait_e_et_ajoutez_au_pa: "اختر الكمية المطلوبة وأضف إلى السلة.",
      proc_dez_au_paiement_s_curis_via_votre_solde_ou_au: "تابع الدفع الآمن عبر رصيدك أو طريقة أخرى.",
      recevez_votre_code_instantan_ment_dans_votre_espac: "احصل على رمزك فوراً في مساحة \"أكوادي\".",
      changement_en_cours_: "جاري التغيير...",
      d_sactivation_: "جاري التعطيل...",
      ex_probl_me_de_connexion: "مثال: مشكلة في الاتصال",
      d_crivez_votre_probl_me_en_d_tail_: "صف مشكلتك بالتفصيل...",
      tapez_votre_r_ponse_: "اكتب إجابتك...",
      nouveau_ticket: "تذكرة جديدة",
      sujet: "الموضوع",
      type_d_assistance: "نوع المساعدة",
      message: "الرسالة",
      chargement_des_messages_: "جاري تحميل الرسائل...",
      envoi_: "جاري الإرسال...",
      envoyer: "إرسال",
      rechercher_un_service_: "بحث عن خدمة...",
      id_de_transaction: "معرف المعاملة",
      instructions_de_paiement: "تعليمات الدفع",
      ouvrez_l_application_d17_et_envoyez_le_montant: "افتح تطبيق D17 وأرسل المبلغ",
      virement_bancaire: "التحويل البنكي",
      d_p_ts_ce_mois: "الإيداعات هذا الشهر",
      d_penses_ce_mois: "المصروفات هذا الشهر",
      aucun_d_p_t_trouv_: "لم يتم العثور على إيداع",
      montant_personnalis_: "مبلغ مخصص",
      choisissez_une_m_thode: "اختر طريقة",
      page_non_trouv_e: "الصفحة غير موجودة",
      produit_introuvable_: "المنتج غير موجود.",
      total_estim_: "الإجمالي المقدر",
      jean: "Jean",
      dupont: "Dupont",
      rue_ville_code_postal: "الشارع، المدينة، الرمز البريدي",
      confirmer_le_mot_de_passe: "تأكيد كلمة المرور",
      nouveau_mot_de_passe: "كلمة المرور الجديدة",
      v_rification_du_lien_: "جاري التحقق من الرابط...",
      mot_de_passe_s_curis_: "كلمة مرور آمنة",
      chiffrement_de_niveau_bancaire: "تشفير على مستوى البنك",
      mise_jour_en_cours_: "جاري التحديث...",
      mettre_jour_le_mot_de_passe: "تحديث كلمة المرور",
      open_sidebar: "فتح الشريط الجانبي",
      open_user_menu: "فتح قائمة المستخدم",
      d_connexion: "تسجيل الخروج",
      fermer: "إغلاق",
      image_pr_c_dente: "الصورة السابقة",
      image_suivante: "الصورة التالية",
      aper_u: "معاينة",
      rechercher_une_image_: "بحث عن صورة...",
      biblioth_que_m_dia: "المكتبة الإعلامية",
      aucune_image_trouv_e: "لم يتم العثور على صورة",
      votre_message_: "رسالتك...",
      en_ligne: "متصل",
      besoin_d_aide_: "تحتاج مساعدة؟",
      posez_moi_vos_questions_sur_les_recharges_ou_nos_s: "اطرح عليّ أسئلتك حول إعادة الشحن أو خدماتنا.",
      valeur: "القيمة",
      s_rie_id: "السلسلة / المعرف",
      date_d_achat: "تاريخ الشراء",
      authentique: "أصلي",
      notifications: "الإشعارات",
      trustpilot: "Trustpilot",
      retour: "رجوع"
    },
    message: {
      failed_to_fetch_admin_stats: "فشل في جلب إحصائيات الإدارة",
      failed_to_update_profile: "فشل في تحديث الملف الشخصي",
      failed_to_post_reply: "فشل في إرسال الرد",
      failed_to_update_status: "فشل في تحديث الحالة",
      failed_update_meta: "فشل في تحديث البيانات الوصفية",
      failed_to_fetch_deposits: "فشل في جلب الودائع",
      failed_to_update_deposit_status: "فشل في تحديث حالة الإيداع",
      failed_to_load_media: "فشل في تحميل الوسائط",
      sync_error: "خطأ في المزامنة",
      erreur_lors_de_la_synchronisation_: "خطأ في المزامنة: ",
      upload_error: "خطأ في الرفع",
      nom_mis_jour: "تم تحديث الاسم",
      erreur_de_renommage: "خطأ في إعادة التسمية",
      failed_to_fetch_data: "فشل في جلب البيانات",
      tout_semble_correct_: "كل شيء يبدو صحيحاً.",
      failed_to_fetch_tickets: "فشل في جلب التذاكر",
      erreur_lors_de_l: "خطأ أثناء",
      error_loading_product_detail_for_cart: "خطأ في تحميل تفاصيل المنتج للسلة",
      failed_to_load_payment_settings: "فشل في تحميل إعدادات الدفع",
      error_loading_product_detail: "خطأ في تحميل تفاصيل المنتج",
      failed_to_load_services_page_data: "فشل في تحميل بيانات صفحة الخدمات",
      failed_to_fetch_dashboard_data_: "فشل في جلب بيانات لوحة التحكم:",
      failed_to_load_order_page_data: "فشل في تحميل بيانات صفحة الطلب",
      failed_to_send_reset_email: "فشل في إرسال بريد إعادة التعيين",
      erreur_turnstile_: "خطأ Turnstile:",
      newsletter_subscription_error: "خطأ في الاشتراك في النشرة الإخبارية",
      failed_to_fetch_ticket: "فشل في جلب التذكرة",
      failed_to_send_reply: "فشل في إرسال الرد",
      failed_to_fetch_dashboard_data: "فشل في جلب بيانات لوحة التحكم",
      failed_to_fetch_categories_data: "فشل في جلب بيانات الفئات",
      failed_to_save_category: "فشل في حفظ الفئة",
      failed_to_save_subcategory: "فشل في حفظ الفئة الفرعية",
      failed_to_delete: "فشل في الحذف",
      failed_to_fetch_stock_data: "فشل في جلب بيانات المخزون",
      attempting_to_reveal_code_: "محاولة كشف الرمز:",
      failed_to_reveal_code_: "فشل في كشف الرمز:",
      failed_to_copy_: "فشل في النسخ:",
      error_fetching_orders: "خطأ في جلب الطلبات",
      error_fetching_product: "خطأ في جلب المنتج",
      erreur_d: "خطأ",
      failed_to_fetch_orders_count: "فشل في جلب عدد الطلبات",
      failed_to_fetch_2fa_status: "فشل في جلب حالة المصادقة الثنائية",
      failed_to_generate_2fa_secret: "فشل في إنشاء المفتاح السري للمصادقة الثنائية",
      failed_to_verify_2fa_code: "فشل في التحقق من رمز المصادقة الثنائية",
      failed_to_disable_2fa: "فشل في تعطيل المصادقة الثنائية",
      failed_to_regenerate_recovery_codes: "فشل في إعادة إنشاء رموز الاسترداد",
      failed_to_change_password: "فشل في تغيير كلمة المرور",
      error_fetching_tickets: "خطأ في جلب التذاكر",
      error_creating_ticket: "خطأ في إنشاء التذكرة",
      error_fetching_ticket_detail: "خطأ في جلب تفاصيل التذكرة",
      error_posting_reply: "خطأ في إرسال الرد",
      failed_to_fetch_catalog: "فشل في جلب الكتالوج",
      failed_to_fetch_wallet_data: "فشل في جلب بيانات المحفظة",
      d_p_t_soumis_avec_succ_s_: "تم تقديم الإيداع بنجاح!",
      failed_to_submit_deposit: "فشل في تقديم الإيداع",
      erreur_lors_de_la_soumission_veuillez_r_essayer_: "خطأ في التقديم. يرجى المحاولة مرة أخرى.",
      erreur_lors_de_l_: "خطأ أثناء",
      erreur_oauth_callback_: "خطأ في استدعاء OAuth:",
      error_checking_session: "خطأ في التحقق من الجلسة",
      failed_to_reset_password: "فشل في إعادة تعيين كلمة المرور",
      upload_failed: "فشل الرفع",
      ai_error_: "خطأ في الذكاء الاصطناعي:",
      erreur_de_s_curit_impossible_de_r_cup_rer_le_code_: "خطأ أمني: لا يمكن استرداد الرمز السري.",
      erreur_lors_de_la_g_n_ration_du_document_pdf_: "خطأ في إنشاء مستند PDF.",
      failed_to_fetch_favorite_products_details: "فشل في جلب تفاصيل المنتجات المفضلة",
      _splashscreen_erreur_lors_de_la_v_rification_ota_: "[SplashScreen] خطأ في التحقق من OTA:",
      _publiclandingroute_affichage_de_la_landingpage_pu: "[PublicLandingRoute] عرض صفحة الهبوط (عامة)",
      service_worker_enregistr_avec_succ_s_: "تم تسجيل Service Worker بنجاح:",
      _chec_de_l_: "فشل"
    },
    "Aucune preuve": "لا يوجد دليل.",
    "Erreur lors de la synchronisation : ": "خطأ في المزامنة: ",
    "Nom mis à jour": "تم تحديث الاسم",
    "Erreur de renommage": "خطأ في إعادة التسمية",
    "/": "/",
    "Tracking Number": "رقم التتبع",
    "\\n": "\\n",
    "Tout semble correct": "كل شيء يبدو صحيحاً.",
    nom: "الاسم",
    statut: "الحالة",
    solde: "الرصيد",
    date_creation: "تاريخ الإنشاء",
    "Erreur lors de l": "خطأ أثناء",
    mobile: {
      nav: {
        home: "الرئيسية",
        orders_admin: "الطلبات",
        support: "الدعم",
        catalog: "اكتشف",
        shop: "المتجر",
        orders: "الطلبات",
        favorites: "المفضلة",
        profile: "الملف الشخصي"
      },
      desktop_only: {
        title: "ميزة سطح المكتب فقط",
        media: "المكتبة الإعلامية",
        open_desktop: "فتح على سطح المكتب"
      }
    },
    sidebar: {
      sections: {
        account: "الحساب",
        preferences: "التفضيلات",
        navigation: "التنقل"
      }
    },
    T: "T",
    ProductCatalog: {
      search: {
        placeholder: "البحث عن خدمة..."
      },
      filters: {
        all: "الكل",
        onSale: "قيد البيع",
        incoming: "قيد الوصول",
        soldOut: "نفدت الكمية"
      },
      categories: {
        all: "الكل",
        codes: "رموز",
        licences: "تراخيص",
        subscriptions: "اشتراكات",
        recharges: "شحنات"
      },
      product: {
        quickActivation: "تفعيل سريع",
        addToCart: "إضافة",
        unavailable: "غير متاح"
      },
      empty: {
        noProductsFound: "لم يتم العثور على منتجات"
      }
    },
    MobileSupport: {
      header: {
        titleAdmin: "إدارة الدعم",
        titleClient: "تحتاج مساعدة؟",
        subtitleAdmin: "الرد على طلبات العملاء وإدارة التذاكر المعلقة.",
        subtitleClient: "فريقنا الفني متواجد لمساعدتك على مدار الساعة.",
        openTicket: "فتح تذكرة"
      },
      list: {
        sectionTitleAdmin: "جميع الطلبات",
        sectionTitleClient: "طلباتي",
        ticketsCount: "{{count}} تذاكر",
        emptyAdmin: "لا توجد تذاكر مفتوحة حالياً.",
        emptyClient: "ليس لديك تذاكر مفتوحة."
      },
      modal: {
        title: "تذكرة جديدة",
        subjectLabel: "الموضوع",
        subjectPlaceholder: "مثال: مشكلة في الاتصال",
        assistanceTypeLabel: "نوع المساعدة",
        messageLabel: "الرسالة",
        messagePlaceholder: "اشرح مشكلتك بالتفصيل...",
        submitButton: "إرسال الطلب"
      },
      detail: {
        ticketTitle: "تذكرة #{{id}}",
        attachment: "مرفق",
        supportLabel: "دعم ء خدمات",
        loadingMessages: "جاري تحميل الرسائل..."
      },
      reply: {
        placeholder: "اكتب ردك...",
        sending: "جاري الإرسال...",
        send: "إرسال",
        attachmentOptional: "مرفق (اختياري)"
      }
    },
    MobileOrders: {
      header: {
        titleAdmin: "إدارة الطلبات",
        titleClient: "سجل الطلبات",
        subtitleAdmin: "اطلع على طلبات جميع العملاء وأدرها.",
        subtitleClient: "تتبع مشترياتك في الوقت الفعلي."
      },
      card: {
        orderLabel: "طلب #{{id}}",
        totalAdmin: "المبلغ الإجمالي",
        totalClient: "المبلغ المدفوع"
      },
      item: {
        codeDelivered: "تم تسليم الرمز",
        accessDelivered: "تم تسليم الوصول",
        viewAccess: "عرض الوصول",
        codePending: "رمز قيد الانتظار",
        codesCount: "{{count}} رموز"
      },
      empty: {
        title: "لا توجد طلبات",
        textAdmin: "لم يتم تقديم أي طلب على المتجر بعد.",
        textClient: "لم تقم بتقديم أي طلب على متجرنا بعد.",
        discoverCatalog: "اكتشف الكتالوج"
      }
    },
    MobileMyCodes: {
      header: {
        title: "رموزي",
        itemsCount: "{{count}} عناصر",
        itemSingular: "عنصر واحد"
      },
      alert: {
        deliveryPendingTitle: "التسليم قيد الانتظار",
        deliveryPendingMessage: "لم يتم إنشاء بعض الرموز تلقائياً. سيقوم المسؤولون بتعيينها يدوياً.",
        viewOrders: "عرض طلباتي"
      },
      loading: "جاري التحميل...",
      empty: {
        title: "لم يتم العثور على رموز",
        subtitle: "ستظهر رموزك ووصولك هنا",
        discoverProducts: "اكتشف المنتجات"
      },
      badges: {
        code: "رمز",
        licence: "ترخيص",
        compte: "حساب",
        acces: "وصول",
        lien: "رابط"
      },
      list: {
        refLabel: "المرجع:",
        cmdLabel: "طلب #"
      },
      fallback: {
        product: "منتج"
      },
      drawer: {
        details: "التفاصيل",
        close: "إغلاق"
      },
      drawerCode: {
        yourCode: "رمزك",
        securing: "جاري التأمين...",
        revealSecret: "إظهار الرمز السري",
        copied: "تم النسخ!",
        copy: "نسخ",
        hide: "إخفاء"
      },
      drawerMeta: {
        reference: "المرجع",
        order: "الطلب"
      },
      security: {
        title: "إرشادات الأمان",
        description: "هذا الرمز أو الوصول سري للغاية. لا تشاركه أبداً مع أطراف ثالثة."
      },
      errors: {
        codeEmpty: "الرمز فارغ أو غير موجود",
        codeRetrieveFail: "تعذر استرداد الرمز."
      }
    },
    MobileProductDetail: {
      notFound: "المنتج غير موجود",
      badge: {
        bestSeller: "الأكثر مبيعاً"
      },
      valueLabel: "القيمة: {{value}}",
      reviews: "(4.8 • 124 تقييم)",
      price: {
        base: "السعر الأساسي",
        total: "السعر الإجمالي"
      },
      status: {
        onSale: "قيد البيع",
        incoming: "قيد الوصول",
        soldOut: "نفدت الكمية"
      },
      info: {
        title: "معلومات المنتج",
        category: "الفئة",
        subCategory: "الفئة الفرعية",
        deliveryMethod: "طريقة التسليم",
        paymentMethods: "طرق الدفع",
        saleType: "نوع البيع",
        minQuantity: "الحد الأدنى للكمية"
      },
      deliveryMethods: {
        code_instantane: "رمز فوري",
        mail_compte_code: "بريد حساب ورمز",
        mail_code: "بريد رمز",
        mail_acces: "بريد وصول",
        mail_licence: "بريد ترخيص",
        traitement_lien: "معالجة رابط",
        livraison_domicile: "توصيل إلى المنزل"
      },
      paymentMethods: {
        solde_interne: "الرصيد الداخلي",
        flouci: "Flouci",
        d17: "D17",
        virement: "تحويل بنكي",
        carte_bancaire: "بطاقة بنكية"
      },
      saleType: {
        detail: "تجزئة",
        gros: "جملة"
      },
      custom: {
        title: "التخصيص",
        required: "مطلوب",
        selectPlaceholder: "اختر...",
        enterField: "أدخل {{field}}",
        amountPlaceholder: "أدخل المبلغ",
        fileUploading: "جاري الرفع...",
        fileAdded: "تمت إضافة الملف",
        addFile: "إضافة ملف"
      },
      features: {
        title: "مشمول مع خياراتك"
      },
      tabs: {
        description: "الوصف",
        howItWorks: "كيف يعمل؟"
      },
      description: {
        none: "لا يوجد وصف متاح لهذا المنتج.",
        productValue: "قيمة المنتج"
      },
      howItWorks: {
        step1: "اختر الكمية المطلوبة وأضف إلى السلة.",
        step2: "تابع الدفع الآمن عبر رصيدك أو طريقة أخرى.",
        step3: "استلم رمزك فوراً في مساحة \"رموزي\"."
      },
      actions: {
        outOfStock: "نفدت الكمية",
        addToCart: "إضافة إلى السلة"
      },
      errors: {
        uploadError: "خطأ في الرفع."
      }
    },
    VerifyPhone: {
      phone: {
        confirmRegistrationTitle: "أكد الرقم الذي تم إدخاله أثناء التسجيل",
        confirmRegistrationDescription:
          "سيتم إرسال رمز مكوّن من 6 أرقام عبر واتساب إلى الرقم أدناه.",
        confirmationLabel: "الرقم المراد تأكيده",
        verificationTitle: "تحقق من رقم هاتفك",
        verificationDescription:
          "لضمان حسابك، يُرجى تأكيد رقم واتساب الخاص بك.",
        whatsappPhoneLabel: "رقم واتساب",
        whatsappPhonePlaceholder: "XXXXXXXX",
        phoneFormatHint: "صيغة الإدخال المتوقعة: XXXXXXXX (يتم تطبيق بادئة +216 تلقائياً).",
        sendCodeButton: "إرسال الرمز",
        sendCodeSending: "جارٍ إرسال الرمز..."
      },
      code: {
        enterCodeTitle: "أدخل الرمز المستلم",
        sentCodeDescription:
          "لقد أرسلنا رمزاً مكوّناً من 6 أرقام عبر واتساب إلى +{{phone}}.",
        resendCodeIn: "إعادة إرسال الرمز بعد {{countdown}}",
        resendCodeDefault: "يمكنك إعادة إرسال رمز جديد.",
        resendButton: "إعادة إرسال الرمز",
        submitVerifying: "جارٍ التحقق...",
        submitButton: "تأكيد الرمز"
      },
      success: {
        registrationSuccessTitle: "تم التسجيل بنجاح",
        phoneVerifiedTitle: "تم التحقق من الرقم",
        registrationSuccessDescription:
          "تم إنشاء حسابك. سجّل الدخول باستخدام بريدك الإلكتروني وكلمة المرور للوصول إلى لوحة التحكم.",
        phoneVerifiedDescription:
          "تم ربط رقم واتساب الخاص بك بحسابك الآن. يمكنك الوصول إلى لوحة التحكم.",
        registrationSuccessButton: "تسجيل الدخول",
        dashboardButton: "الانتقال إلى لوحة التحكم"
      },
      errors: {
        phoneRequired: "يرجى إدخال رقم الهاتف الخاص بك.",
        phoneInvalidLength: "يجب أن يحتوي الرقم على 8 أرقام (الصيغة المحلية التونسية).",
        phoneInvalid: "رقم هاتف غير صالح.",
        finalizationGeneric: "حدث خطأ أثناء إتمام التسجيل.",
        linkExpired: "انتهت صلاحية الرابط. يُرجى إعادة بدء التسجيل.",
        codeExpired: "انتهت صلاحية الرمز. يُرجى طلب رمز جديد.",
        tooManyAttempts: "عدد كبير جداً من المحاولات. يُرجى طلب رمز جديد لاحقاً.",
        phoneAlreadyUsed: "هذا الرقم مستخدم بالفعل من قبل حساب آخر. يُرجى اختيار رقم آخر.",
        emailAlreadyUsed: "هذا البريد الإلكتروني مستخدم بالفعل. سجّل الدخول أو أعد تعيين كلمة المرور.",
        invalidCodeServer: "رمز غير صالح أو خطأ في الخادم. يُرجى المحاولة مرة أخرى.",
        confirmationGeneric: "حدث خطأ أثناء التحقق من الرمز. يُرجى المحاولة مرة أخرى.",
        emailNotFound: "لم يتم العثور على حساب لهذا البريد الإلكتروني. يُرجى إعادة بدء التسجيل.",
        invalidCode: "رمز غير صالح. يُرجى التحقق والمحاولة مرة أخرى."
      }
    },
    legal: {
      documents: {
        subtitle: "اطلع على جميع وثائقنا الرسمية",
        intro: "ستجد هنا جميع وثائقنا القانونية والسياسية. يحتوي كل مستند على معلومات مهمة حول خدماتنا وحقوقك والتزاماتنا.",
        info_title: "تحتاج مساعدة؟",
        info_text: "إذا كان لديك أسئلة حول وثائقنا القانونية، لا"
      }
    },
    "Erreur lors du chargement des données": "خطأ في تحميل البيانات",
    "Le nom de la catégorie est requis": "اسم الفئة مطلوب",
    "Catégorie modifiée avec succès": "تم تعديل الفئة بنجاح",
    "Catégorie ajoutée avec succès": "تمت إضافة الفئة بنجاح",
    "Le nom et la catégorie sont requis": "الاسم والفئة مطلوبان",
    "Sous-catégorie modifiée avec succès": "تم تعديل الفئة الفرعية بنجاح",
    "Sous-catégorie ajoutée avec succès": "تمت إضافة الفئة الفرعية بنجاح",
    "Erreur lors de la suppression": "خطأ في الحذف",
    "La modification doit être effectuée seulement via le Dashboard admin desktop": "يجب إجراء التعديل فقط عبر لوحة تحكم الإدارة على سطح المكتب.",
    code_id: "code_id",
    "Erreur d": "خطأ",
    "Dépôt soumis avec succès !": "تم تقديم الإيداع بنجاح!",
    "Erreur lors de la soumission. Veuillez réessayer": "خطأ في التقديم. يرجى المحاولة مرة أخرى.",
    error: "حدث خطأ",
    error_description: "وصف الخطأ",
    code: "الرمز",
    access_token: "access_token",
    refresh_token: "refresh_token",
    view: "عرض",
    "Erreur de sécurité : Impossible de récupérer le code secret": "خطأ أمني: لا يمكن استرداد الرمز السري.",
    "Erreur lors de la génération du document PDF": "خطأ في إنشاء مستند PDF.",
    android: {
      app_name: "eServices",
      title_activity_main: "eServices"
    }
  }
};

export { ar };
export default ar;
